import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormArray, FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { HelperService } from 'src/app/core/services/helper.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, copyArrayItem, CdkDragEnter } from '@angular/cdk/drag-drop';
import remove from 'lodash-es/remove';
import _ from 'lodash';
import { ops_restapi } from '../../core/db/operations';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { environment } from '../../../environments/environment';
import { CodemirrorComponent } from '@ctrl/ngx-codemirror';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { TimeZone } from '../integration-update/integration-update.component';
import { SchedularComponent } from 'src/app/shared/modals/scheduler/schedular.component';
import { IonRouterOutlet, ModalController } from '@ionic/angular';

enum ops_name {
  bizdata_ops_jdbcoutput = 'Database',
  bizdata_ops_singletomultiline = 'Single Line to Multiline',
  bizdata_ops_eliminate = 'Eliminate',
  bizdata_ops_rename = 'Rename',
  bizdata_ops_append = 'Append',
  bizdata_ops_uppercase = 'Uppercase',
  bizdata_ops_titlecase = 'Titlecase',
  bizdata_ops_lowercase = 'Lowercase',
  bizdata_ops_dropeventsstartswith = 'Drop all events to start with',
  bizdata_ops_dropalleventvalues = 'Drop all events for value',
  bizdata_ops_calculater = 'Calculator',
  bizdata_ops_dateanalytics = 'Date Analytics',
  bizdata_ops_substitute = 'Substitute',
  bizdata_ops_strip = 'Strip',
  bizdata_ops_substring = 'Substring',
  bizdata_ops_generatesequence = 'Generate Array Sequence Number',
  bizdata_ops_json2string = 'JSON to String',
  bizdata_ops_string2json = 'String to JSON',
  bizdata_ops_toplevel = 'Send Keys Top of Root',
  bizdata_ops_datetimestamp = 'Today Timestamp',
  bizdata_ops_dataaggregation = 'Data aggregation',
  bizdata_ops_datatypes = 'Data types',
  bizdata_ops_round = 'Round',
  bizdata_ops_pivot = 'Pivot',
  bizdata_ops_postgres = 'Postgres',
  bizdata_ops_replacinganyvalue = 'Replacing any value',
  bizdata_ops_trim = 'Trim',
  bizdata_ops_base64decoding = 'Base64 decoding',
  bizdata_ops_base64encoding = 'Base64 encoding',
  bizdata_ops_bodmascal = 'Bodmascal',
  bizdata_ops_json2dl = 'JSON to delimiter',
  bizdata_ops_dl2json = 'Delimiter to JSON',
  bizdata_ops_sleeptime = 'Sleep time',
  bizdata_ops_pycode = 'Python',
  bizdata_ops_aiops = 'AI Operation',
  bizdata_ops_jsontoxml = 'JSON to XML',
  bizdata_ops_xmltojson = 'XML to JSON',
  bizdata_ops_restapitarget = 'API',
  bizdata_ops_email = 'Email',
  bizdata_ops_analytics = 'Analytics',
  bizdata_ops_dataextractor = 'Data extractor',
  // bizdata_ops_file = 'File',
  bizdata_ops_unpivot = 'Unpivot',
  bizdata_ops_singleline2tuple = 'Single Line to Tuple',
  bizdata_ops_tuple2singleline = 'Tuple to Single Line',
  bizdata_ops_repeatfirstrow = 'Repeat First Row Values',
  bizdata_ops_filter = 'Filter',
  bizdata_ops_encodedecode = 'Encode Decode',
  bizdata_ops_zipfileinbase64 = 'Zipfile in Base64',
  bizdata_ops_arraycount = 'Array Count',
  bizdata_ops_dl2array = 'Delimiter to Array',
  bizdata_ops_filterends = 'Filter Ends',
  bizdata_ops_rawsentencegenerator = 'Raw Sentence Generator',
  bizdata_ops_timeunits = 'Time Units',
  bizdata_ops_datachunking = 'Data Chunking',
  bizdata_ops_json2avro = 'JSON to AVRO',
  bizdata_ops_avro2json = 'AVRO to JSON',
  bizdata_ops_htmlextractor = 'HTML Extractor',
  bizdata_ops_extract2array = 'Extract to Array',
};

export interface ProductGroup {
  brand_name: string;
  products: string[];
}

export interface Target {
  product_name: string
}

export const filterSource = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
}

@Component({
  selector: 'app-integration-details',
  templateUrl: './integration-details.component.html',
  styleUrls: ['./integration-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IntegrationDetailsComponent implements OnInit {

  showAdvancedSettings: boolean = false; // Initial value, can be true or false based on your requirement
  streamingBatchSize: number; // Define the property
  sourceResponseWaitTime: number; // Define the property

  @ViewChild(JsonEditorComponent, { static: false }) editor: JsonEditorComponent;
  editorSourceOptions: JsonEditorOptions;
  editorTargetOptions: JsonEditorOptions;
  appendoptions: JsonEditorOptions;
  renameoptions: JsonEditorOptions;
  singletomultioptions: JsonEditorOptions;

  editor2Options: JsonEditorOptions;
  dataStructure: any;

  // editorSourceOptions2 = {
  //   language: 'text', readOnly: true,
  //   minimap: {
  //     enabled: false
  //   },
  // };
  // editorTargetOptions2 = {
  //   language: 'text', readOnly: true,
  //   minimap: {
  //     enabled: false
  //   },
  // };

  @ViewChild("bodySourceEditor") _bodySourceEditor: CodemirrorComponent;
  @ViewChild("bodyTargetEditor") _bodyTargetEditor: CodemirrorComponent;
  @ViewChild("dlSearchEditor") _dlSearchEditor: CodemirrorComponent;
  @ViewChild("pycodeEditor") _pycodeEditor: CodemirrorComponent;
  @ViewChild("pyresponseEditor") _pyresponseEditor: CodemirrorComponent;
  @ViewChild("queryEditor") _queryEditor: CodemirrorComponent;
  @ViewChild("queryresponseEditor") _queryresponseEditor: CodemirrorComponent;
  @ViewChild("sourcePreRequestScriptEditor") _sourcePreRequestScriptEditor: CodemirrorComponent;
  @ViewChild("targetPreRequestScriptEditor") _targetPreRequestScriptEditor: CodemirrorComponent;
  @ViewChild("preRequestScriptEditorROA") _preRequestScriptEditorROA: CodemirrorComponent;
  @ViewChild("sourceMessageEditor") _sourceMessageEditor: CodemirrorComponent;
  @ViewChild("sourceCustomPaginationScriptEditor") _sourceCustomPaginationScriptEditor: CodemirrorComponent;

  preRequestScriptEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "javascript" },
    // readOnly: true,
    readOnly: 'nocursor',
  };

  codeMirrorEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },
    readOnly: 'nocursor'
  };

  bodyTypeOptions: Array<any> = [
    { id: 1, type: 'JSON' },
    { id: 2, type: 'XML' },
    { id: 3, type: 'TEXT' }
  ]
  messageEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },
    readOnly: 'nocursor'
  };
  // sourceparamsFlag: boolean = true;
  targetparamsFlag: boolean = true;
  sourceheadersFlag: boolean = true;
  targetheadersFlag: boolean = true;
  sourcebodyFlag: boolean = true;
  targetbodyFlag: boolean = true;
  requestscriptFlag: boolean = true;

  stepperOrientation: Observable<StepperOrientation>;
  sourceColoumns: any;
  targetColoumns: any;
  color: ThemePalette = 'primary';
  checked = false;
  disabled = false;
  isLinear = true;
  dataSource: UntypedFormGroup = new UntypedFormGroup({});
  dataTarget: UntypedFormGroup = new UntypedFormGroup({});
  dataOperations: UntypedFormGroup;
  //---Transformation From Init----------
  bizdata_ops_datatypes_fb: UntypedFormGroup;
  bizdata_ops_append_formArray: UntypedFormGroup
  bizdata_ops_append_fb: UntypedFormGroup;
  bizdata_ops_titlecase_fb: UntypedFormGroup;
  bizdata_ops_uppercase_fb: UntypedFormGroup;
  bizdata_ops_lowercase_fb: UntypedFormGroup;
  bizdata_ops_dataextractor_fb: UntypedFormGroup;
  bizdata_ops_trim_fb: UntypedFormGroup;
  bizdata_ops_base64decoding_fb: UntypedFormGroup;
  bizdata_ops_base64encoding_fb: UntypedFormGroup;
  bizdata_ops_jsontoxml_fb: UntypedFormGroup;
  bizdata_ops_xmltojson_fb: UntypedFormGroup;
  bizdata_ops_generatesequence_fb: UntypedFormGroup;
  bizdata_ops_json2string_fb: UntypedFormGroup;
  bizdata_ops_string2json_fb: UntypedFormGroup;
  bizdata_ops_toplevel_fb: UntypedFormGroup;
  bizdata_ops_datetimestamp_fb: UntypedFormGroup;
  bizdata_ops_repeatfirstrow_fb: UntypedFormGroup;
  bizdata_ops_encodedecode_fb: UntypedFormGroup;
  bizdata_ops_zipfileinbase64_fb: UntypedFormGroup;
  bizdata_ops_arraycount_fb: UntypedFormGroup;
  bizdata_ops_pdfextractor_fb: UntypedFormGroup;
  bizdata_ops_fileextractor_fb: UntypedFormGroup;
  bizdata_ops_grokpattern_fb: UntypedFormGroup;
  bizdata_ops_rawsentencegenerator_fb: UntypedFormGroup;
  bizdata_ops_timeunits_fb: UntypedFormGroup;
  bizdata_ops_datachunking_fb: UntypedFormGroup;
  bizdata_ops_json2avro_fb:UntypedFormGroup;
  bizdata_ops_avro2json_fb:UntypedFormGroup;
  bizdata_ops_extract2array_fb: UntypedFormGroup;
  bizdata_ops_htmlextractor_fb: UntypedFormGroup;
  //--------------------------------------
  //--------------Waringling-------------
  bizdata_ops_json2dl_fb: UntypedFormGroup;
  bizdata_ops_dl2json_fb: UntypedFormGroup;
  bizdata_ops_dataaggregation_fb: UntypedFormGroup;
  bizdata_ops_pivot_fb: UntypedFormGroup;
  bizdata_ops_singleline2tuple_fb: UntypedFormGroup;
  bizdata_ops_tuple2singleline_fb: UntypedFormGroup;
  bizdata_ops_unpivot_fb: UntypedFormGroup;
  bizdata_ops_singletomultiline_fb: UntypedFormGroup;
  bizdata_ops_dl2array_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Orchestration---------------
  // bizdata_ops_file_fb: FormGroup;
  bizdata_ops_email_fb: UntypedFormGroup;
  bizdata_ops_restapi_fb: UntypedFormGroup;
  bizdata_ops_json_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Cleaning-----------------
  bizdata_ops_dropeventsstartswith_fb: UntypedFormGroup;
  bizdata_ops_dropalleventvalues_fb: UntypedFormGroup;
  bizdata_ops_eliminate_fb: UntypedFormGroup;
  bizdata_ops_rename_fb: UntypedFormGroup;
  bizdata_ops_calculater_fb: UntypedFormGroup;
  bizdata_ops_dateanalytics_fb: UntypedFormGroup;
  bizdata_ops_substitute_fb: UntypedFormGroup;
  bizdata_ops_strip_fb: UntypedFormGroup;
  bizdata_ops_substring_fb: UntypedFormGroup;
  bizdata_ops_round_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Pipeline Controls-----------------
  bizdata_ops_sleeptime_fb: UntypedFormGroup;
  bizdata_ops_pycode_fb: UntypedFormGroup;
  bizdata_ops_aiops_fb: UntypedFormGroup;
  bizdata_ops_filter_fb: UntypedFormGroup;
  bizdata_ops_filterends_fb: UntypedFormGroup;
  //-----------------------------------------
  bizdata_ops_jdbcoutput_fb: UntypedFormGroup;
  bizdata_ops_postgres_fb: UntypedFormGroup;
  bizdata_ops_replacinganyvalue_fb: UntypedFormGroup;
  bizdata_ops_restapitarget_fb: UntypedFormGroup;
  bizdata_ops_analytics_fb: UntypedFormGroup;
  bizdata_ops_dlakeingestion_fb: UntypedFormGroup;
  bizdata_ops_dlsearch_fb: UntypedFormGroup;
  //=------------Deep Learning---------------
  bizdata_ops_docunderstanding_fb: UntypedFormGroup;
  bizdata_ops_imgunderstanding_fb: UntypedFormGroup;


  mapping: UntypedFormGroup;
  summary: UntypedFormGroup;
  displayedSourceColumns: string[] = ['source'];
  // sourceTable = SOURCE_ELEMENT_DATA;
  displayedTargetColumns: string[] = ['target', 'mapping'];
  // targetTable = TARGET_ELEMENT_DATA;
  matChipColor = "#87c4f3";
  hide1024 = false;
  operationParam: any;
  userIp;
  integrationID;
  @ViewChild("myckeditor") ckeditor: any;
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['ShowBlocks']
    ],
    fullPage: true,
    allowedContent: true,
    readOnly: true,
    versionCheck: false
  };

  breadcrumbList = [
    {
      label: 'Integration',
      embedurl: true,
      url: '/baseapp/integration/list'
    },
    {
      label: 'Details',
      embedurl: false,
      url: ''
    }
  ];

  loading = true;

  type: string = "data_source";

  bridgeSourceCatalogType = [];
  bridgeSourceBusinessObject = [];

  bridgeTargetCatalogType = [];
  bridgeSourceList: ProductGroup[] = [];
  bridgeSourceProduct$: Observable<ProductGroup[]>;
  bridgeTargetList: ProductGroup[] = [];
  bridgeTargetListRAO: ProductGroup[] = [];
  bridgeTarget$: Observable<ProductGroup[]>;
  bridgeTargetRAO$: Observable<ProductGroup[]>;
  bridgeTargetBusinessObject = [];

  methodList: any;
  authenticationSourceTypeOptions: any;
  authenticationTargetTypeOptions: any;
  selectSourceType: number = 1;
  selectTargetType: number = 1;
  bridgeSourceResponse;
  bridgeTargetResponse;

  bridgeSourceResponseMapping = [];
  bridgeTargetResponseMapping = [];
  isMappingActive = false;

  integrationObj;
  source_name_for_webSocket;
  selectedIndex = 0;
  bridge_source_arr = [];
  bridge_target_arr = [];
  bridge_source_business_object_arr = [];
  bridge_target_business_object_arr = [];

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  emails: string[] = [];
  announcer = inject(LiveAnnouncer);

  selectedSourceColumn = { "source_column": "", "source_value": "", "selected": false, "type": "" };
  isSourceColumnSelected = false;
  sourceColumnIndex = 0;
  isSourceTargetSwitched = false;
  bubbleshow: boolean = false;
  sourcetotarget: boolean;
  updatedtoken: any;
  noAbout = false;
  selectedOperationId;
  createNew = "Create New";
  bridgeSourceType = [{ id: 1, value: "API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)" }, { id: 2, value: "Database" }, { id: 3, value: "Bizintel360 Data Lake Source" }, { id: 4, value: "Websocket" }, { id: 5, value: "Email" }];//
  bridgeTargetType = [{ id: 1, value: "API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)" }, { id: 2, value: "Database" }, { id: 3, value: "Bizintel360 Data Lake Ingestion" }, { id: 4, value: "Email" }, { id: 5, value: "No Target" }];//
  bridge_target_type = 1;
  bridge_source_type = 1;
  bridge_summary_source_name: any;
  bridge_summary_source_bobj: any;
  bridge_summary_target_name: any;
  bridge_summary_target_bobj: any;
  data_source_status;
  data_target_status;
  datatarget_action_type = "upsert";
  dataTargetDLIngestion: any;
  dlTargetTypeversion: any;
  indexSelectionEmailTarget: number = 0;
  indexSelectionWebsocket: number = 0;
  verisonListDLO = [];
  verisonListDLSO = [
    {
      versionTitle: 'Data Lake from Bizdata after 2023',
      value: 'bizdata_ops_dlsearch'
    },
    {
      versionTitle: 'Data Lake from Bizdata before 2023',
      value: 'bizdata_ops_bizintel360search'
    }
  ];
  actionTypeListDLO = [
    {
      actionTypeTitle: 'Upsert',
      actionTypevalue: 'upsert',
    },
    {
      actionTypeTitle: 'Update',
      actionTypevalue: 'update'
    },
    {
      actionTypeTitle: 'Delete',
      actionTypevalue: 'delete',
    },
    {
      actionTypeTitle: 'Create',
      actionTypevalue: 'create'
    },
    {
      actionTypeTitle: 'Insert',
      actionTypevalue: 'index'
    }
  ];
  indexingTypeListDLO = [
    {
      indexTypeTitle: 'Parallel Computing',
      indexTypevalue: 'parallel_bulk'
    },
    {
      indexTypeTitle: 'Streaming Computing',
      indexTypevalue: 'streaming_bulk'
    },
    {
      indexTypeTitle: 'Bump Computing',
      indexTypevalue: 'bulk'
    }
  ];
  paginationTypeOptions: Array<any> = [
    {
      id: 1,
      type: "No Pagination",
      type_value: "no_pagination"
    },
    {
      id: 2,
      type: "Next URL Pagination",
      type_value: "next_url_pagination"
    },
    {
      id: 3,
      type: "Offset Pagination",
      type_value: "offset_pagination"
    },
    {
      id: 4,
      type: "Total Page Count",
      type_value: "total_pages"
    },
    {
      id: 5,
      type: "Pagination with Body",
      type_value: "pagination_with_body"
    },
    {
      id: 6,
      type: "Cursor Pagination",
      type_value: "cursor_pagination"
    },
    {
      id: 7,
      type: "Encoded Next Token",
      type_value: "encoded_next_token_pagination"
    },
    {
      id: 8,
      type: "Custom Pagination",
      type_value: "custom_pagination"
    }
  ]

  //--Transformation Array Declearation--
  bizdata_ops_datatypes_obj = []
  bizdata_ops_append_obj = []
  bizdata_ops_titlecase_obj = []
  bizdata_ops_uppercase_obj = []
  bizdata_ops_lowercase_obj = []
  bizdata_ops_dataextractor_obj = []
  bizdata_ops_trim_obj = []
  bizdata_ops_base64decoding_obj = []
  bizdata_ops_base64encoding_obj = []
  bizdata_ops_jsontoxml_obj = []
  bizdata_ops_xmltojson_obj = []
  bizdata_ops_generatesequence_obj = []
  bizdata_ops_json2string_obj = []
  bizdata_ops_string2json_obj = []
  bizdata_ops_toplevel_obj = []
  bizdata_ops_datetimestamp_obj = []
  bizdata_ops_repeatfirstrow_obj = []
  bizdata_ops_encodedecode_obj = []
  bizdata_ops_zipfileinbase64_obj = []
  bizdata_ops_arraycount_obj = []
  bizdata_ops_pdfextractor_obj = []
  bizdata_ops_fileextractor_obj = []
  bizdata_ops_grokpattern_obj = []
  bizdata_ops_rawsentencegenerator_obj = []
  bizdata_ops_timeunits_obj = []
  bizdata_ops_datachunking_obj = []
  bizdata_ops_json2avro_obj = []
  bizdata_ops_htmlextractor_obj = []
  bizdata_ops_avro2json_obj = []
  bizdata_ops_extract2array_obj = [];
  //--------------------------------------
  //--------------Waringling-------------
  bizdata_ops_json2dl_obj = []
  bizdata_ops_dl2json_obj = []
  bizdata_ops_dataaggregation_obj = []
  bizdata_ops_pivot_obj = []
  bizdata_ops_unpivot_obj = []
  bizdata_ops_singletomultiline_obj = []
  bizdata_ops_singleline2tuple_obj = []
  bizdata_ops_tuple2singleline_obj = []
  bizdata_ops_dl2array_obj = []
  //--------------------------------------
  //--------------Orchestration---------------
  // bizdata_ops_file_obj = []
  bizdata_ops_email_obj = []
  bizdata_ops_restapi_obj = []
  bizdata_ops_json_obj = []
  //-----------------------------------------
  //--------------Cleaning-----------------
  bizdata_ops_dropeventsstartswith_obj = []
  bizdata_ops_dropalleventvalues_obj = []
  bizdata_ops_eliminate_obj = []
  bizdata_ops_rename_obj = []
  bizdata_ops_calculater_obj = []
  bizdata_ops_dateanalytics_obj = []
  bizdata_ops_substitute_obj = []
  bizdata_ops_strip_obj = []
  bizdata_ops_substring_obj = []
  bizdata_ops_round_obj = []
  //-----------------------------------------
  //--------------Pipeline Controls-----------------
  bizdata_ops_sleeptime_obj = []
  bizdata_ops_pycode_obj = []
  bizdata_ops_aiOps_obj = []
  bizdata_ops_filter_obj = []
  bizdata_ops_filterends_obj = []
  //-----------------------------------------
  bizdata_ops_jdbcoutput_obj = []
  bizdata_ops_postgres_obj = []
  bizdata_ops_replacinganyvalue_obj = []
  bizdata_ops_restapitarget_obj = []
  bizdata_ops_analytics_obj = []
  bizdata_ops_docunderstanding_obj = []
  bizdata_ops_imgunderstanding_obj = []

  //-----------------------------------
  isDataTypeFromEnabled: boolean = false;
  isAppendFromEnabled: boolean = false;
  isTitlecaseFromEnabled: boolean = false;
  isUppercaseFromEnabled: boolean = false;
  isLowercaseFromEnabled: boolean = false;
  isData_extractorFromEnabled: boolean = false;
  isTrimFromEnabled: boolean = false;
  isBase64encodingFromEnabled: boolean = false;
  isBase64decodingFromEnabled: boolean = false;
  isJSON_to_XMLFromEnabled: boolean = false;
  isXML_to_JSONFromEnabled: boolean = false;
  isGeneratesequenceFromEnabled: boolean = false;
  isJson2stringFromEnabled: boolean = false;
  isString2jsonFromEnabled: boolean = false;
  isToplevelFromEnabled: boolean = false;
  isDatetimestampFromEnabled: boolean = false;
  isRepeatfirstrowFromEnabled: boolean = false;
  isjdbcoutputFromEnabled: boolean = false;
  isEncodedecodeFromEnabled: boolean = false;
  isDLIngestionFormEnabled: boolean = false;
  isDlsearchFormEnabled: boolean = false;
  isZipfileinbase64FromEnabled: boolean = false;
  isArraycountFromEnabled: boolean = false;
  isPdfextractorFormEnabled: boolean = false;
  isFileextractorFormEnabled: boolean = false;
  isGorkPatternFormEnabled: boolean = false;
  isRawSentenceGeneratorFormEnabled: boolean = false;
  isTimeUnitsFormEnabled: boolean = false;
  isDataChunkingFormEnabled : boolean = false;
  isJson2avroFormEnabled: boolean = false;
  isHTMLExtractorFormEnabled : boolean = false;
  isAvro2jsonFormEnabled: boolean = false;
  isExtract2ArrayFormEnabled: boolean= false;
  //-----------------------------------//

  //-----Waringlging-------------------------------//
  isDl2jsonFromEnabled: boolean = false;
  isJSON2dlFromEnabled: boolean = false;
  isDataaggregationFromEnabled: boolean = false;
  isPivotFromEnabled: boolean = false;
  isUnPivotFromEnabled: boolean = false;
  chopFormEnabled: boolean = false
  singleline2tupleFormEnabled: boolean = false
  tuple2singlelineFormEnabled: boolean = false
  isDl2arrayFormEnabled: boolean = false
  //---------------------------------------------//
  //--------------Orchestration---------------
  isfileFromEnabled: boolean = false;
  isemailFromEnabled: boolean = false;
  isrestapiFormEnabled: boolean = false
  isjsonFormEnabled: boolean = false
  //---------------------------------------------//
  //--------------Cleaning---------------
  isdropeventsstartswithFromEnabled: boolean = false;
  isdropalleventvaluesFromEnabled: boolean = false;
  iseliminateFromEnabled: boolean = false;
  isrenameFromEnabled: boolean = false
  iscalculaterFromEnabled: boolean = false
  isdateanalyticsFromEnabled: boolean = false
  issubstituteFromEnabled: boolean = false
  isstripFromEnabled: boolean = false
  issubstringFromEnabled: boolean = false
  isroundFromEnabled: boolean = false;
  //---------------------------------------------//
  //--------------Pipeline Controls---------------
  issleepFromEnabled: boolean = false;
  ispycodeFromEnabled: boolean = false;
  isfilterFromEnabled: boolean = false;
  isfilterEndsFromEnabled: boolean = false;
  isaiopsFromEnabled: boolean = false;
  //---------------------------------------------//

  isPostgresFromEnabled: boolean = false;
  isReplacingvalueFromEnabled: boolean = false;
  isRestapitargetFromEnabled: boolean = false;
  isAnalyticsFromEnabled: boolean = false;
  isDataextractorEnabled: boolean = false;
  isjdbcoutputFormEnabled: boolean = false;
  isDocunderstandingFromEnabled: boolean = false;
  isImgunderstandingFromEnabled:boolean = false;
  operations = {};
  blocks: Array<any> = []
  newBlocks = [];
  finalBlocks: Array<any> = []
  isOpsFromEnabled = false;
  timertypeval: string = "";
  scheduleval: boolean = false;
  submitted: boolean = false;
  selectPaginationType: number = 1;
  isNewSource: boolean = false;
  isNewTarget: boolean = false;

  user_key_2: string = '';
  user_key_3: string = '';
  user_key_4: string = '';
  user_key_5: string = '';
  user_key_6: string = '';
  user_key_7: string = '';
  user_key_url_6: string = '';
  key_name_to_update_3: string = '';
  key_name_to_update_4: string = '';
  key_name_to_update_5: string = '';
  response_parameters_2: string = '';
  response_parameters_3: string = '';
  response_parameters_4: string = '';
  response_parameters_5: string = '';
  response_parameters_6: string = '';
  response_parameters_7: string = '';
  custom_pagination_script: string = '';
  another_response_parameter_2: string = '';

  option2: Boolean = false;
  option3: Boolean = false;
  option4: Boolean = false;
  option5: Boolean = false;
  option6: Boolean = false;
  isDisabled :Boolean= true;
  processEDOList = [
    {
      process: 'encode',
    },
    {
      process: 'decode',
    }
  ];

  //Output types for Email Source.
  email_out_types = [{ label: 'Text', value: 'text' }, { label: 'HTML', value: 'html' }, { label: 'Base64', value: 'base64' }]
  pdfLocationToggleValue: any;
  isHidden: boolean = true;
  visibleIndex = -1;
  items = [
    {
      name: 'Request Header',
      subItems: []
    }, {
      name: 'Request Params',
      subItems: []
    }, {
      name: 'Request Body',
      subItems: []
    }, {
      name: 'Pre Request Script',
      subItems: []
    },
    {
      requestMethod: '',
      requestUrl: ''
    }
  ];

  ops_environment=[];//selectedSourceEnv
  source_environment = [];
  target_environment = [];
  contentDivTarget = document.getElementById('contentDivTarget');
  endpoint_target_url = "";
  params_target_key = [];
  contentDevTargetParam;
  params_target_value = [];
  contentDevTargetParamValue;
  headers_target_key = [];
  contentDevTargetHeaderKey;
  headers_target_value = [];
  contentDevTargetHeaderValue;
  target_auth = "";
  ops_auth=[];
  contentDevTargetAuth;
  endpoint_ops_url=[];
  ops_authUser = [];
  ops_authPassword = [];
  params_ops_key=[];
  params_ops_value=[];
  headers_ops_key=[];
  headers_ops_value=[];
  params_ops_raw={};
  headers_ops_raw ={};
  spinnerTargetRAOShow: boolean = false;
  spinnerOperationPycodeApiShow: boolean = false;
  spinnerOperationDatabaseShow: boolean = false;
  spinnerTargetRAO: boolean = false;
  spinnerOperationPycodeApi: boolean = false;
  spinnerOperationDatabase: boolean = false;
  operationPycodeApTestApi: any;
  operationDatabaseTestApi: any;
  targetRAOTestApi: any;
  showEnvironmentTabRAO = false;
  selectedTabIndex: number = 0;
  environmentType = [
    { value: 'text', viewValue: 'Default' },
    { value: 'password', viewValue: 'Secret' },
  ];
  currentDisplayedEnvIndexRAO: number = 0;
  selectedSourceEnvTabs: string[] = [];
  selectedEnvTabsRAO: string[] = [];
  selectedTargetEnvTabs: string[] = [];
  authorizationScriptEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    // mode: { name: "text" }
    mode: { name: "javascript", json: true }
  };
  isjdbcSourceFromEnabled:Boolean=false;
  isjdbcTargetFromEnabled=false;
  constructor(
    private backendService: BackendService,
    public breakpointObserver: BreakpointObserver,
    private _formBuilder: UntypedFormBuilder,
    public storage: Storage,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet,
    public helperService: HelperService) { }

  ngOnInit() {

    //---------------------Storing the Transformation key from response-------------------//
    // if(this.bizdata_ops_datatypes_obj.hasOwnProperty('source') || this.bizdata_ops_datatypes_obj.hasOwnProperty('target')){

    // }
    // this.bizdata_ops_datatypes_obj = this.helperService.removeSourceTargetTag([Object.keys(ops_restapi['bizdata_ops_datatypes'])])

    this.bizdata_ops_datatypes_obj = Object.keys(ops_restapi['bizdata_ops_datatypes']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datatypes_obj)
    this.bizdata_ops_titlecase_obj = Object.keys(ops_restapi['bizdata_ops_titlecase']);
    for (var i = 0; i < this.bizdata_ops_titlecase_obj.length; i++) {
      if (this.bizdata_ops_titlecase_obj[i] == 'source') {
        this.bizdata_ops_titlecase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_titlecase_obj[i] == 'target') {
        this.bizdata_ops_titlecase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_append_obj = Object.keys(ops_restapi['bizdata_ops_append']);
    for (var i = 0; i < this.bizdata_ops_append_obj.length; i++) {
      if (this.bizdata_ops_append_obj[i] == 'source') {
        this.bizdata_ops_append_obj.splice(i, 1);
      }
      if (this.bizdata_ops_append_obj[i] == 'target') {
        this.bizdata_ops_append_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_uppercase_obj = Object.keys(ops_restapi['bizdata_ops_uppercase']);
    for (var i = 0; i < this.bizdata_ops_uppercase_obj.length; i++) {
      if (this.bizdata_ops_uppercase_obj[i] == 'source') {
        this.bizdata_ops_uppercase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_uppercase_obj[i] == 'target') {
        this.bizdata_ops_uppercase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_lowercase_obj = Object.keys(ops_restapi['bizdata_ops_lowercase']);
    for (var i = 0; i < this.bizdata_ops_lowercase_obj.length; i++) {
      if (this.bizdata_ops_lowercase_obj[i] == 'source') {
        this.bizdata_ops_lowercase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_lowercase_obj[i] == 'target') {
        this.bizdata_ops_lowercase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_dataextractor_obj = Object.keys(ops_restapi['bizdata_ops_dataextractor']);
    for (var i = 0; i < this.bizdata_ops_dataextractor_obj.length; i++) {
      if (this.bizdata_ops_dataextractor_obj[i] == 'source') {
        this.bizdata_ops_dataextractor_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dataextractor_obj[i] == 'target') {
        this.bizdata_ops_dataextractor_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_base64decoding_obj = Object.keys(ops_restapi['bizdata_ops_base64decoding']);
    for (var i = 0; i < this.bizdata_ops_base64decoding_obj.length; i++) {
      if (this.bizdata_ops_base64decoding_obj[i] == 'source') {
        this.bizdata_ops_base64decoding_obj.splice(i, 1);
      }
      if (this.bizdata_ops_base64decoding_obj[i] == 'target') {
        this.bizdata_ops_base64decoding_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_trim_obj = Object.keys(ops_restapi['bizdata_ops_trim']);
    for (var i = 0; i < this.bizdata_ops_trim_obj.length; i++) {
      if (this.bizdata_ops_trim_obj[i] == 'source') {
        this.bizdata_ops_trim_obj.splice(i, 1);
      }
      if (this.bizdata_ops_trim_obj[i] == 'target') {
        this.bizdata_ops_trim_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_base64encoding_obj = Object.keys(ops_restapi['bizdata_ops_base64encoding']);
    for (var i = 0; i < this.bizdata_ops_base64encoding_obj.length; i++) {
      if (this.bizdata_ops_base64encoding_obj[i] == 'source') {
        this.bizdata_ops_base64encoding_obj.splice(i, 1);
      }
      if (this.bizdata_ops_base64encoding_obj[i] == 'target') {
        this.bizdata_ops_base64encoding_obj.splice(i, 1);
      }
    }

    this.bizdata_ops_generatesequence_obj = Object.keys(ops_restapi['bizdata_ops_generatesequence']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_generatesequence_obj)
    this.bizdata_ops_json2string_obj = Object.keys(ops_restapi['bizdata_ops_json2string']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_json2string_obj)
    this.bizdata_ops_string2json_obj = Object.keys(ops_restapi['bizdata_ops_string2json']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_string2json_obj)
    this.bizdata_ops_toplevel_obj = Object.keys(ops_restapi['bizdata_ops_toplevel']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_toplevel_obj)
    this.bizdata_ops_datetimestamp_obj = Object.keys(ops_restapi['bizdata_ops_datetimestamp']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datetimestamp_obj)
    this.bizdata_ops_jsontoxml_obj = Object.keys(ops_restapi['bizdata_ops_jsontoxml']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_jsontoxml_obj)
    this.bizdata_ops_xmltojson_obj = Object.keys(ops_restapi['bizdata_ops_xmltojson']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_xmltojson_obj)
    this.bizdata_ops_repeatfirstrow_obj = Object.keys(ops_restapi['bizdata_ops_repeatfirstrow']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_repeatfirstrow_obj)
    this.bizdata_ops_encodedecode_obj = Object.keys(ops_restapi['bizdata_ops_encodedecode']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_encodedecode_obj)
    this.bizdata_ops_zipfileinbase64_obj = Object.keys(ops_restapi['bizdata_ops_zipfileinbase64']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_zipfileinbase64_obj)
    this.bizdata_ops_arraycount_obj = Object.keys(ops_restapi['bizdata_ops_arraycount']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_arraycount_obj)
    //---------------------------------------------------------------------------------------------//
    //-------------------------Wrangling----------------------------------------------------------//
    this.bizdata_ops_dl2json_obj = Object.keys(ops_restapi['bizdata_ops_dl2json']);
    for (var i = 0; i < this.bizdata_ops_dl2json_obj.length; i++) {
      if (this.bizdata_ops_dl2json_obj[i] == 'source') {
        this.bizdata_ops_dl2json_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dl2json_obj[i] == 'target') {
        this.bizdata_ops_dl2json_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_json2dl_obj = Object.keys(ops_restapi['bizdata_ops_json2dl']);
    for (var i = 0; i < this.bizdata_ops_json2dl_obj.length; i++) {
      if (this.bizdata_ops_json2dl_obj[i] == 'source') {
        this.bizdata_ops_json2dl_obj.splice(i, 1);
      }
      if (this.bizdata_ops_json2dl_obj[i] == 'target') {
        this.bizdata_ops_json2dl_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_dataaggregation_obj = Object.keys(ops_restapi['bizdata_ops_dataaggregation']);
    for (var i = 0; i < this.bizdata_ops_dataaggregation_obj.length; i++) {
      if (this.bizdata_ops_dataaggregation_obj[i] == 'source') {
        this.bizdata_ops_dataaggregation_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dataaggregation_obj[i] == 'target') {
        this.bizdata_ops_dataaggregation_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_pivot_obj = Object.keys(ops_restapi['bizdata_ops_pivot']);
    for (var i = 0; i < this.bizdata_ops_pivot_obj.length; i++) {
      if (this.bizdata_ops_pivot_obj[i] == 'source') {
        this.bizdata_ops_pivot_obj.splice(i, 1);
      }
      if (this.bizdata_ops_pivot_obj[i] == 'target') {
        this.bizdata_ops_pivot_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_unpivot_obj = Object.keys(ops_restapi['bizdata_ops_unpivot']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_unpivot_obj)
    this.bizdata_ops_singletomultiline_obj = Object.keys(ops_restapi['bizdata_ops_singletomultiline']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_singletomultiline_obj)
    this.bizdata_ops_singleline2tuple_obj = Object.keys(ops_restapi['bizdata_ops_singleline2tuple']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_singleline2tuple_obj)
    this.bizdata_ops_tuple2singleline_obj = Object.keys(ops_restapi['bizdata_ops_tuple2singleline']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_tuple2singleline_obj)
    this.bizdata_ops_dl2array_obj = Object.keys(ops_restapi['bizdata_ops_dl2array']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dl2array_obj)
    this.bizdata_ops_pdfextractor_obj = Object.keys(ops_restapi['bizdata_ops_pdfextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_pdfextractor_obj)
    this.bizdata_ops_fileextractor_obj = Object.keys(ops_restapi['bizdata_ops_fileextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_fileextractor_obj)
    this.bizdata_ops_grokpattern_obj = Object.keys(ops_restapi['bizdata_ops_grokpattern']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_grokpattern_obj);
    this.bizdata_ops_rawsentencegenerator_obj = Object.keys(ops_restapi['bizdata_ops_rawsentencegenerator']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_rawsentencegenerator_obj);
    this.bizdata_ops_timeunits_obj = Object.keys(ops_restapi['bizdata_ops_timeunits']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_timeunits_obj)
    this.bizdata_ops_datachunking_obj = Object.keys(ops_restapi['bizdata_ops_datachunking']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datachunking_obj)
    this.bizdata_ops_json2avro_obj = Object.keys(ops_restapi['bizdata_ops_json2avro']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_json2avro_obj)
    this.bizdata_ops_htmlextractor_obj = Object.keys(ops_restapi['bizdata_ops_htmlextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_htmlextractor_obj)
    this.bizdata_ops_avro2json_obj = Object.keys(ops_restapi['bizdata_ops_avro2json']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_avro2json_obj)
    this.bizdata_ops_extract2array_obj = Object.keys(ops_restapi['bizdata_ops_extract2array']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_extract2array_obj);
    //---------------------------------------------------------------------------------------------//
    // this.bizdata_ops_file_obj = Object.keys(ops_restapi['bizdata_ops_file']);
    // this.helperService.removeSourceTargetTag(this.bizdata_ops_file_obj)
    this.bizdata_ops_email_obj = Object.keys(ops_restapi['bizdata_ops_email']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_email_obj)
    this.bizdata_ops_restapi_obj = Object.keys(ops_restapi['bizdata_ops_restapi']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_restapi_obj)
    this.bizdata_ops_json_obj = Object.keys(ops_restapi['bizdata_ops_jdbcoutput']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_json_obj)
    this.bizdata_ops_dropeventsstartswith_obj = Object.keys(ops_restapi['bizdata_ops_dropeventsstartswith']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dropeventsstartswith_obj)
    this.bizdata_ops_dropalleventvalues_obj = Object.keys(ops_restapi['bizdata_ops_dropalleventvalues']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dropalleventvalues_obj)
    this.bizdata_ops_eliminate_obj = Object.keys(ops_restapi['bizdata_ops_eliminate']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_eliminate_obj)
    this.bizdata_ops_round_obj = Object.keys(ops_restapi['bizdata_ops_round']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_round_obj)
    this.bizdata_ops_calculater_obj = Object.keys(ops_restapi['bizdata_ops_calculater']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_calculater_obj)
    this.bizdata_ops_dateanalytics_obj = Object.keys(ops_restapi['bizdata_ops_dateanalytics']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dateanalytics_obj)
    this.bizdata_ops_substitute_obj = Object.keys(ops_restapi['bizdata_ops_substitute']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_substitute_obj)
    this.bizdata_ops_strip_obj = Object.keys(ops_restapi['bizdata_ops_strip']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_strip_obj)
    this.bizdata_ops_substring_obj = Object.keys(ops_restapi['bizdata_ops_substring']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_substring_obj)
    this.bizdata_ops_rename_obj = Object.keys(ops_restapi['bizdata_ops_rename']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_rename_obj)
    this.bizdata_ops_sleeptime_obj = Object.keys(ops_restapi['bizdata_ops_sleeptime']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_sleeptime_obj)
    this.bizdata_ops_pycode_obj = Object.keys(ops_restapi['bizdata_ops_pycode']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_pycode_obj)
    this.bizdata_ops_pycode_obj = Object.keys(ops_restapi['bizdata_ops_aiops']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_aiOps_obj)
    this.bizdata_ops_filter_obj = Object.keys(ops_restapi['bizdata_ops_filter']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_filter_obj)

    this.bizdata_ops_filterends_obj = Object.keys(ops_restapi['bizdata_ops_filterends']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_filterends_obj)
    this.bizdata_ops_jdbcoutput_obj = Object.keys(ops_restapi['bizdata_ops_jdbcoutput']);
    this.bizdata_ops_postgres_obj = Object.keys(ops_restapi['bizdata_ops_postgres']);
    this.bizdata_ops_replacinganyvalue_obj = Object.keys(ops_restapi['bizdata_ops_replacinganyvalue']);
    this.bizdata_ops_restapitarget_obj = Object.keys(ops_restapi['bizdata_ops_restapitarget']);
    this.bizdata_ops_analytics_obj = Object.keys(ops_restapi['bizdata_ops_analytics']);
    this.bizdata_ops_docunderstanding_obj = Object.keys(ops_restapi['bizdata_ops_docunderstanding']);
    this.bizdata_ops_imgunderstanding_obj = Object.keys(ops_restapi['bizdata_ops_imgunderstanding']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_docunderstanding_obj)
    // let operations = [];
    // this.operationsArr.map((item) => {
    //   operations.push(...item.blocks);
    // })
    // this.operations = { 'blockArr': operations };

    this.stepperOrientation = this.breakpointObserver.observe('(min-width: 800px)').pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
    this.operationParam = ["parameter-1", "parameter-2", "parameter-3", "parameter-4"]
    this.breakpointObserver.observe(['(min-width: 1024px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1024 = true;
      } else {
        this.hide1024 = false;
      }
    });

    this.getUserIp();

    this.dataSource = this._formBuilder.group({
      'bridge_source_type': [{ value: "", disabled: true }],
      'bridge_source': [{ value: "", disabled: true }],
      'bridge_source_business_object': [{ value: "", disabled: true }],
      'bridge_source_endpoint_method': [{ value: "", disabled: true }],
      'bridge_source_endpoint_url': [{ value: "", disabled: true }],
      'bridge_source_endpoint_params_raw': new UntypedFormArray([]),
      'bridge_source_endpoint_headers': new UntypedFormArray([]),
      'bridge_source_endpoint_authentication_type': [{ value: "", disabled: true }],
      'bridge_source_endpoint_body_raw': [''],
      'bridge_source_body_type': [{ value: "JSON", disabled: true }],
      'pre_request_script': [{ value: '', disabled: true }],
      'bridge_source_response': [''],
      'bridge_source_pagination_type': [{ value: "", disabled: true }],
      'response_parameters_2': [{ value: "", disabled: true }],
      'another_response_parameter_2': [{ value: "", disabled: true }],
      'user_key_2': [{ value: "", disabled: true }],
      'user_key_3': [{ value: "", disabled: true }],
      'key_name_to_update_3': [{ value: "", disabled: true }],
      'response_parameters_3': [{ value: "", disabled: true }],
      'user_key_4': [{ value: "", disabled: true }],
      'key_name_to_update_4': [{ value: "", disabled: true }],
      'response_parameters_4': [{ value: "", disabled: true }],
      'user_key_5': [{ value: "", disabled: true }],
      'key_name_to_update_5': [{ value: "", disabled: true }],
      'response_parameters_5': [{ value: "", disabled: true }],
      'user_key_6': [{ value: "", disabled: true }],
      'user_key_url_6': [{ value: "", disabled: true }],
      'response_parameters_6': [{ value: "", disabled: true }],
      'user_key_7': [{ value: "", disabled: true }],
      'response_parameters_7': [{ value: "", disabled: true }],
      'custom_pagination_script': [{ value: "", disabled: true }],
      'min_number': [{ value: 0, disabled: true }],
      'max_number': [{ value: 1000, disabled: true }],
      'today_str': [{ value: '%Y-%m-%dT00:00:01Z', disabled: true }],
      'yesterday_str': [{ value: '%Y-%m-%dT00:00:01Z', disabled: true }],
      'rolling_time_format': [{ value: '%Y-%m-%dT%H:%M:00.000', disabled: true }],
      'rolling_frequency': [{ value: 900, disabled: true }],
      'offset_value': [{ value: 0, disabled: true }],

    });
    this.restAPIForm();
    this.dataTarget = this._formBuilder.group({
      'bridge_target_type': [{ value: "", disabled: true }],
      'bridge_target': [{ value: "", disabled: true }],
      'bridge_target_business_object': [{ value: "", disabled: true }],
      'bridge_target_body_type': [{ value: 'JSON', disabled: true }],
      'bridge_target_endpoint_method': [{ value: "", disabled: true }],
      'bridge_target_endpoint_url': [{ value: "", disabled: true }],
      'bridge_target_endpoint_params_raw': new UntypedFormArray([]),
      'bridge_target_endpoint_headers': new UntypedFormArray([]),
      'bridge_target_endpoint_authentication_type': [{ value: "", disabled: true }],
      'bridge_target_endpoint_body_raw': [{ value: "", disabled: true }],
      'pre_request_script': [{ value: '', disabled: true }],
      'bridge_target_response': ['']
    });
    this.mapping = this._formBuilder.group({
      // secondCtrl: ['', Validators.required],
    });
    this.summary = this._formBuilder.group({
      'bridge_name': [{ value: "", disabled: true }],
      'bridge_description': [{ value: "", disabled: true }],
      'timertype': [{ value: "", disabled: true }],
      'interval': [{ value: "", disabled: true }],
      'schedule': [{ value: "", disabled: true }],
      'time_zone': [{ value: "", disabled: true }],
      'alert_emails': [{ value: "", disabled: true }],
      'toggle': [{ value: "", disabled: true }],
      'sbs': [{ value: "", disabled: true }],
      'now': [{ value: "", disabled: true }],
      'srwt': [{ value: "", disabled: true }],
      'logsize': [{ value: "", disabled: true }]
    })

    this.editorSourceOptions = new JsonEditorOptions()
    this.editorSourceOptions.mode = 'code'; //set only one mode
    this.editorSourceOptions.mainMenuBar = false;

    this.editorTargetOptions = new JsonEditorOptions()
    this.editorTargetOptions.mode = 'code'; //set only one mode
    this.editorTargetOptions.mainMenuBar = false;

    this.appendoptions = new JsonEditorOptions()
    this.appendoptions.mode = 'code'; //set only one mode
    this.appendoptions.mainMenuBar = false;

    this.renameoptions = new JsonEditorOptions()
    this.renameoptions.mode = 'code'; //set only one mode
    this.renameoptions.mainMenuBar = false;

    this.singletomultioptions = new JsonEditorOptions()
    this.singletomultioptions.mode = 'code'; //set only one mode
    this.singletomultioptions.mainMenuBar = false;

    this.editor2Options = new JsonEditorOptions()
    this.editor2Options.mode = 'view'; //set only one mode
    this.editor2Options.mainMenuBar = false;

    this.getStorage().then((res) => {
      this.helperService.loader();
      this.integrationID = this.route.snapshot.params['id'];
      // GET API METHODS
      this.getMethod(res.token).then((method_list) => {
        this.methodList = method_list;
        // GET API AUTH TYPE
        this.getAuth(res.token).then((auth_list) => {
          this.authenticationSourceTypeOptions = auth_list;
          this.authenticationTargetTypeOptions = auth_list;
          // GET INTEGRATION BRIDGE DETAILS
          this.getIntegrationDetails(this.integrationID);
        })
      })

      this.getDataSource().then(res => {
        let data: [] = res as [];
        this.bridgeSourceList = data;
        this.bridgeSourceProduct$ = this.dataSource.get('bridge_source')!.valueChanges.pipe(
          startWith(''),
          map(value => this._filterMapSource(value || '')),
        );
      }); // Load products with brand for source data

      this.getDataTarget().then(res => {
        let data: [] = res as [];
        this.bridgeTargetList = data;
        this.bridgeTarget$ = this.dataTarget.get('bridge_target')!.valueChanges.pipe(
          startWith(''),
          map(value => this._filterMapTarget(value || '')),
        );
      }); // Load products with brand for target data

      this.getDlVersionDLO().then(res => {
        let data: [] = res as [];
        this.verisonListDLO = data;
      });

      this.bubbleshow = res.showDialog == 1 ? true : false;
    })

    this.generatetoken();
    this.summary.patchValue({ schedule: '* * * * *' });
    this.summary.patchValue({ interval: 60 });
  }

  private getMethod(token: string) {
    return new Promise((resolve) => {
      this.backendService.GetAPICall('getMethod', token).subscribe(
        method_res => {
          let bridge_endpoint_method = method_res.filter(function (entry) { return entry.id === 1 });
          this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_endpoint_method[0]);
          this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method[0]);
          resolve(method_res)
        })
    })
  }

  showSubItem(ind) {
    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  private getAuth(token: string) {
    return new Promise((resolve) => {
      this.backendService.GetAPICall('getAuth', token).subscribe(
        auth_res => {
          let endpoint_authentication_type = auth_res.filter(function (entry) { return entry.id === 1 });
          this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);
          this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);
          resolve(auth_res)
        })
    })
  }

  private _filterMapSource(value): ProductGroup[] {
    if (value) {
      return this.bridgeSourceList
        .map(res => ({ brand_name: res.brand_name, products: filterSource(res.products, value) }))
        .filter(res => res.products.length > 0);
    }
    return this.bridgeSourceList;
  }

  private _filterMapTarget(value: string): ProductGroup[] {
    return this.bridgeTargetList
      .map(res => ({ brand_name: res.brand_name, products: filterSource(res.products, value) }))
      .filter(res => res.products.length > 0);
  }

  restAPIForm() {
    //----------------Transformation Form Init---------------//
    // this.bizdata_ops_datatypes_fb = new FormGroup({})
    // for(const key of Object.keys(ops_restapi['bizdata_ops_datatypes'])) {
    //   //console.log(key,ops_restapi['bizdata_ops_datatypes'][key])
    //   this.bizdata_ops_datatypes_fb.addControl(key,this._formBuilder.control(['']));
    // }
    this.bizdata_ops_datatypes_fb = this._formBuilder.group({
      datatypesRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_datatypes_fb = this._formBuilder.group({
    //   "boolean_operator": [[]],
    //   "float_operator": [[]],
    //   "integer_operator": [[]],
    //   "datetime_operator": [[]],
    // });
    this.bizdata_ops_append_fb = this._formBuilder.group({
      appendRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_append_fb = this._formBuilder.group({
    //   'append': [[]]
    // });
    this.bizdata_ops_titlecase_fb = this._formBuilder.group({
      titlecaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_titlecase_fb = this._formBuilder.group({
    //   'Titlecase': [[]],
    // });
    this.bizdata_ops_uppercase_fb = this._formBuilder.group({
      uppercaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_uppercase_fb = this._formBuilder.group({
    //   'uppercase': [[]],
    // });
    this.bizdata_ops_lowercase_fb = this._formBuilder.group({
      lowercaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_lowercase_fb = this._formBuilder.group({
    //   'lowercase': [[]],
    // });
    this.bizdata_ops_dataextractor_fb = this._formBuilder.group({
      dataextractorRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dataextractor_fb = this._formBuilder.group({
    //   "data_extractor": [[]],
    //   "data_extractor_keys": [[]],
    // });
    this.bizdata_ops_trim_fb = this._formBuilder.group({
      trimRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_trim_fb = this._formBuilder.group({
    //   "trim_keys": [[]],
    // });
    this.bizdata_ops_base64decoding_fb = this._formBuilder.group({
      base64decodingRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_base64decoding_fb = this._formBuilder.group({
    //   "base64_decode": [[]],
    // });
    this.bizdata_ops_base64encoding_fb = this._formBuilder.group({
      base64encodingRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_base64encoding_fb = this._formBuilder.group({
    //   "base64_encode": [[]],
    // })
    this.bizdata_ops_jsontoxml_fb = this._formBuilder.group({
      jsontoxmlRows: new UntypedFormArray([])
    });
    this.bizdata_ops_xmltojson_fb = this._formBuilder.group({
      xmltojsonRows: new UntypedFormArray([])
    });
    this.bizdata_ops_repeatfirstrow_fb = this._formBuilder.group({
      repeatfirstrowRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_xmltojson_fb = this._formBuilder.group({
    //   'get_key': [''],
    // });
    //----------------Waringling Form Init------------------//
    // this.bizdata_ops_json2dl_fb = new FormGroup({})
    // for(const key of Object.keys(ops_restapi['bizdata_ops_json2dl'])) {
    //   this.bizdata_ops_json2dl_fb.addControl(key,this._formBuilder.control(['']));
    // };
    this.bizdata_ops_json2dl_fb = this._formBuilder.group({
      json2dlRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_json2dl_fb = this._formBuilder.group({
    //   "key_data": [''],
    //   "delimiter": [''],
    //   "fields": [[]],
    //   "autodetect_column_names": [''],
    //   "skip_header": [''],
    //   "response_key": [''],
    // });
    this.bizdata_ops_dl2json_fb = this._formBuilder.group({
      dl2jsonRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dl2json_fb = this._formBuilder.group({
    //   "key_data": [''],
    //   "delimiter": [''],
    //   "fields": [[]],
    //   "autodetect_column_names": [''],
    //   "skip_header": [''],
    //   "response_key": [''],
    // });
    this.bizdata_ops_dataaggregation_fb = this._formBuilder.group({
      dataaggregationRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dataaggregation_fb = this._formBuilder.group({
    //   "groupby_key": [''],
    //   "array_key": [''],
    //   "array_key_nested_columns": [[]],
    // });
    // });
    this.bizdata_ops_generatesequence_fb = this._formBuilder.group({
      generatesequenceRows: new UntypedFormArray([])
    });
    this.bizdata_ops_json2string_fb = this._formBuilder.group({
      json2stringRows: new UntypedFormArray([])
    });
    this.bizdata_ops_string2json_fb = this._formBuilder.group({
      string2jsonRows: new UntypedFormArray([])
    });
    this.bizdata_ops_toplevel_fb = this._formBuilder.group({
      toplevelRows: new UntypedFormArray([])
    });
    this.bizdata_ops_datetimestamp_fb = this._formBuilder.group({
      datetimestampRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dataaggregation_fb = this._formBuilder.group({
      dataaggregationRows: new UntypedFormArray([])
    });
    this.bizdata_ops_pivot_fb = this._formBuilder.group({
      pivotRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_pivot_fb = this._formBuilder.group({
    //   "transposed_key_name": [[]],
    //   "transposed_value": [[]],
    // });
    this.bizdata_ops_unpivot_fb = this._formBuilder.group({
      unpivotRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_pivot_fb = this._formBuilder.group({
    //   "transposed_key_name": [[]],
    //   "transposed_value": [[]],
    // });
    this.bizdata_ops_singletomultiline_fb = this._formBuilder.group({
      chopRows: new UntypedFormArray([])
    });
    this.bizdata_ops_singleline2tuple_fb = this._formBuilder.group({
      singleline2tupleRows: new UntypedFormArray([])
    });
    this.bizdata_ops_tuple2singleline_fb = this._formBuilder.group({
      tuple2singlelineRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_singletomultiline_fb = this._formBuilder.group({
    //   "chopkey": [''],
    // });
    // this.bizdata_ops_file_fb = this._formBuilder.group({
    //   fileRows: new FormArray([])
    // });
    // this.bizdata_ops_file_fb = this._formBuilder.group({
    //   "target_location": [''],
    //   "extension": [''],
    //   "write_mode": ['']
    // });
    this.bizdata_ops_email_fb = this._formBuilder.group({
      emailRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_email_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "response_parameter": [''],
    //   "mailserver": [''],
    //   "port_number": [''],
    //   "From": [''],
    //   "to": [''],
    //   "password": [''],
    //   "cc": [[]],
    //   "response_key": [''],
    //   "seperator": [''],
    //   "attachment": [''],
    //   "attachment_extension": [''],
    //   "in_data": [''],
    //   "body_arr": [[]],
    //   "subject": [''],
    //   "body": [''],
    // });
    this.bizdata_ops_restapi_fb = this._formBuilder.group({
      restapiRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_restapi_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "min_num": [''],
    //   "max_num": [''],
    //   "endpoint_url": [''],
    //   "endpoint_headers": [[]],
    //   "endpoint_method": [''],
    //   "endpoint_body": [[]],
    //   "endpoint_params": [[]],
    //   "authentication_type": [''],
    //   "username": [''],
    //   "password": [''],
    //   "refresh_token_url": [''],
    //   "refresh_token_headers": [''],
    //   "refresh_token_method": [''],
    //   "refresh_token_body": [''],
    //   "refresh_token_params": [[]],
    //   "pre_request_script": [''],
    //   "response_parameters": [''],
    //   "another_response_parameter": [''],
    //   "key_name_to_update": [''],
    //   "user_key": [''],
    //   "pagination_style": [''],
    //   "timer_type": [''],
    //   "interval_in_seconds": [''],
    //   "schedule": [''],
    //   "user_key_url": ['']
    // });
    this.bizdata_ops_json_fb = this._formBuilder.group({
      jsonRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_json_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "jdbc_driver": [''],
    //   "jdbc_string": [''],
    //   "jdbc_jar_file": [''],
    //   "username": [''],
    //   "password": [''],
    //   "unique_key": [''],
    //   "query": [''],
    //   "response_parameter": [''],
    //   "timer_type": [''],
    //   "schedule": [''],
    //   "interval_in_seconds": [''],
    //   "multiline": [''],
    // });
    this.bizdata_ops_dropeventsstartswith_fb = this._formBuilder.group({
      dropeventsstartswithRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dropeventsstartswith_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [[]],
    // });
    this.bizdata_ops_dropalleventvalues_fb = this._formBuilder.group({
      dropalleventvaluesRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dropalleventvalues_fb = this._formBuilder.group({
    //   'drop_all_event_for_value': [[]],
    // });
    this.bizdata_ops_eliminate_fb = this._formBuilder.group({
      eliminateRows: new UntypedFormArray([])
    });
    this.bizdata_ops_calculater_fb = this._formBuilder.group({
      calculaterRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dateanalytics_fb = this._formBuilder.group({
      dateanalyticsRows: new UntypedFormArray([])
    });
    this.bizdata_ops_substitute_fb = this._formBuilder.group({
      substituteRows: new UntypedFormArray([])
    });
    this.bizdata_ops_strip_fb = this._formBuilder.group({
      stripRows: new UntypedFormArray([])
    });
    this.bizdata_ops_substring_fb = this._formBuilder.group({
      substringRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_eliminate_fb = this._formBuilder.group({
    //   "eliminate": [[]],
    // });
    this.bizdata_ops_rename_fb = this._formBuilder.group({
      renameRows: new UntypedFormArray([])
    });
    this.bizdata_ops_round_fb = this._formBuilder.group({
      roundRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_rename_fb = this._formBuilder.group({
    //   "rename": [[]],
    // });
    this.bizdata_ops_sleeptime_fb = this._formBuilder.group({
      sleepRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_sleeptime_fb = this._formBuilder.group({
    //   "sleep_time": [''],
    // });
    this.bizdata_ops_pycode_fb = this._formBuilder.group({
      pycodeRows: new UntypedFormArray([])
    });

    this.bizdata_ops_aiops_fb = this._formBuilder.group({
      aiOpsRows: new UntypedFormArray([])
    });

    this.bizdata_ops_jdbcoutput_fb = this._formBuilder.group({
      jdbcoutputRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dlakeingestion_fb = this._formBuilder.group({
      dlIngestionRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dlsearch_fb = this._formBuilder.group({
      dlsearchRows: new UntypedFormArray([])
    });
    this.bizdata_ops_filter_fb = this._formBuilder.group({
      filterRows: new UntypedFormArray([])
    });

    this.bizdata_ops_encodedecode_fb = this._formBuilder.group({
      encodedecodeRows: new UntypedFormArray([])
    });

    this.bizdata_ops_zipfileinbase64_fb = this._formBuilder.group({
      zipfileinbase64Rows: new UntypedFormArray([])
    });

    this.bizdata_ops_arraycount_fb = this._formBuilder.group({
      arraycountRows: new UntypedFormArray([])
    });

    this.bizdata_ops_dl2array_fb = this._formBuilder.group({
      dl2arrayRows: new UntypedFormArray([])
    });

    this.bizdata_ops_pdfextractor_fb = this._formBuilder.group({
      pdfextractorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_fileextractor_fb = this._formBuilder.group({
      fileextractorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_docunderstanding_fb = this._formBuilder.group({
      docunderstandingRows: new UntypedFormArray([])
    });
    this.bizdata_ops_imgunderstanding_fb = this._formBuilder.group({
      imgunderstandingRows: new UntypedFormArray([])
    });

    this.bizdata_ops_filterends_fb = this._formBuilder.group({
      filterEndsRows: new UntypedFormArray([])
    });

    this.bizdata_ops_grokpattern_fb = this._formBuilder.group({
      grokpatternRows: new UntypedFormArray([])
    });

    this.bizdata_ops_rawsentencegenerator_fb = this._formBuilder.group({
      rawsentencegeneratorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_timeunits_fb = this._formBuilder.group({
      timeunitsRows: new UntypedFormArray([])
    });
    
    this.bizdata_ops_datachunking_fb = this._formBuilder.group({
      datachunkingRows: new UntypedFormArray([])
    });
    this.bizdata_ops_json2avro_fb = this._formBuilder.group({
      json2avroRows: new UntypedFormArray([])
    });

    this.bizdata_ops_htmlextractor_fb = this._formBuilder.group({
      htmlextractorRows: new UntypedFormArray([])
    });
    this.bizdata_ops_avro2json_fb = this._formBuilder.group({
      avro2jsonRows: new UntypedFormArray([])
    });
    this.bizdata_ops_extract2array_fb = this._formBuilder.group({
      extract2ArrayRows: new UntypedFormArray([])
    });
  }

  // get f() { return this.bizdata_ops_append_fb.controls; }
  // get t() { return this.f.appendRows as FormArray; }

  datatypesRows(): UntypedFormArray {
    return this.bizdata_ops_datatypes_fb.get("datatypesRows") as UntypedFormArray
  }

  appendRows(): UntypedFormArray {
    return this.bizdata_ops_append_fb.get("appendRows") as UntypedFormArray
  }

  titlecaseRows(): UntypedFormArray {
    return this.bizdata_ops_titlecase_fb.get("titlecaseRows") as UntypedFormArray
  }

  uppercaseRows(): UntypedFormArray {
    return this.bizdata_ops_uppercase_fb.get("uppercaseRows") as UntypedFormArray
  }

  lowercaseRows(): UntypedFormArray {
    return this.bizdata_ops_lowercase_fb.get("lowercaseRows") as UntypedFormArray
  }

  dataextractorRows(): UntypedFormArray {
    return this.bizdata_ops_dataextractor_fb.get("dataextractorRows") as UntypedFormArray
  }

  trimRows(): UntypedFormArray {
    return this.bizdata_ops_trim_fb.get("trimRows") as UntypedFormArray
  }

  base64decodingRows(): UntypedFormArray {
    return this.bizdata_ops_base64decoding_fb.get("base64decodingRows") as UntypedFormArray
  }

  base64encodingRows(): UntypedFormArray {
    return this.bizdata_ops_base64encoding_fb.get("base64encodingRows") as UntypedFormArray
  }

  jsontoxmlRows(): UntypedFormArray {
    return this.bizdata_ops_jsontoxml_fb.get("jsontoxmlRows") as UntypedFormArray
  }

  xmltojsonRows(): UntypedFormArray {
    return this.bizdata_ops_xmltojson_fb.get("xmltojsonRows") as UntypedFormArray
  }

  repeatfirstrowRows(): UntypedFormArray {
    return this.bizdata_ops_repeatfirstrow_fb.get("repeatfirstrowRows") as UntypedFormArray
  }

  encodedecodeRows(): UntypedFormArray {
    return this.bizdata_ops_encodedecode_fb.get("encodedecodeRows") as UntypedFormArray
  }

  generatesequenceRows(): UntypedFormArray {
    return this.bizdata_ops_generatesequence_fb.get("generatesequenceRows") as UntypedFormArray
  }

  json2stringRows(): UntypedFormArray {
    return this.bizdata_ops_json2string_fb.get("json2stringRows") as UntypedFormArray
  }

  string2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_string2json_fb.get("string2jsonRows") as UntypedFormArray
  }

  toplevelRows(): UntypedFormArray {
    return this.bizdata_ops_toplevel_fb.get("toplevelRows") as UntypedFormArray
  }

  datetimestampRows(): UntypedFormArray {
    return this.bizdata_ops_datetimestamp_fb.get("datetimestampRows") as UntypedFormArray
  }

  arraycountRows(): UntypedFormArray {
    return this.bizdata_ops_arraycount_fb.get("arraycountRows") as UntypedFormArray
  }

  pdfextractorRows(): UntypedFormArray {
    return this.bizdata_ops_pdfextractor_fb.get("pdfextractorRows") as UntypedFormArray
  }

  fileextractorRows(): UntypedFormArray {
    return this.bizdata_ops_fileextractor_fb.get("fileextractorRows") as UntypedFormArray
  }

  grokpatternRows(): UntypedFormArray {
    return this.bizdata_ops_grokpattern_fb.get("grokpatternRows") as UntypedFormArray
  }


  rawsentencegeneratorRows(): UntypedFormArray {
    return this.bizdata_ops_rawsentencegenerator_fb.get("rawsentencegeneratorRows") as UntypedFormArray
  }

  timeunitsRows(): UntypedFormArray {
    return this.bizdata_ops_timeunits_fb.get("timeunitsRows") as UntypedFormArray
  }

  datachunkingRows(): UntypedFormArray {
    return this.bizdata_ops_datachunking_fb.get("datachunkingRows") as UntypedFormArray
  }
  json2avroRows(): UntypedFormArray {
    return this.bizdata_ops_json2avro_fb.get("json2avroRows") as UntypedFormArray
  }

  htmlextractorRows(): UntypedFormArray {
    return this.bizdata_ops_htmlextractor_fb.get("htmlextractorRows") as UntypedFormArray
  }
  avro2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_avro2json_fb.get("avro2jsonRows") as UntypedFormArray
  }
  extract2ArrayRows(): UntypedFormArray {
    return this.bizdata_ops_extract2array_fb.get("extract2ArrayRows") as UntypedFormArray
  }
  //--------------------------
  json2dlRows(): UntypedFormArray {
    return this.bizdata_ops_json2dl_fb.get("json2dlRows") as UntypedFormArray
  }

  dl2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_dl2json_fb.get("dl2jsonRows") as UntypedFormArray
  }

  dataaggregationRows(): UntypedFormArray {
    return this.bizdata_ops_dataaggregation_fb.get("dataaggregationRows") as UntypedFormArray
  }

  pivotRows(): UntypedFormArray {
    return this.bizdata_ops_pivot_fb.get("pivotRows") as UntypedFormArray
  }

  unpivotRows(): UntypedFormArray {
    return this.bizdata_ops_unpivot_fb.get("unpivotRows") as UntypedFormArray
  }

  chopRows(): UntypedFormArray {
    return this.bizdata_ops_singletomultiline_fb.get("chopRows") as UntypedFormArray
  }

  singleline2tupleRows(): UntypedFormArray {
    return this.bizdata_ops_singleline2tuple_fb.get("singleline2tupleRows") as UntypedFormArray
  }

  tuple2singlelineRows(): UntypedFormArray {
    return this.bizdata_ops_tuple2singleline_fb.get("tuple2singlelineRows") as UntypedFormArray
  }

  // fileRows(): FormArray {
  //   return this.bizdata_ops_file_fb.get("fileRows") as FormArray
  // }

  emailRows(): UntypedFormArray {
    return this.bizdata_ops_email_fb.get("emailRows") as UntypedFormArray
  }

  restapiRows(): UntypedFormArray {
    return this.bizdata_ops_restapi_fb.get("restapiRows") as UntypedFormArray
  }

  jsonRows(): UntypedFormArray {
    return this.bizdata_ops_json_fb.get("jsonRows") as UntypedFormArray
  }

  dropeventsstartswithRows(): UntypedFormArray {
    return this.bizdata_ops_dropeventsstartswith_fb.get("dropeventsstartswithRows") as UntypedFormArray
  }

  dropalleventvaluesRows(): UntypedFormArray {
    return this.bizdata_ops_dropalleventvalues_fb.get("dropalleventvaluesRows") as UntypedFormArray
  }

  eliminateRows(): UntypedFormArray {
    return this.bizdata_ops_eliminate_fb.get("eliminateRows") as UntypedFormArray
  }

  roundRows(): UntypedFormArray {
    return this.bizdata_ops_round_fb.get("roundRows") as UntypedFormArray
  }

  calculaterRows(): UntypedFormArray {
    return this.bizdata_ops_calculater_fb.get("calculaterRows") as UntypedFormArray
  }


  dateanalyticsRows(): UntypedFormArray {
    return this.bizdata_ops_dateanalytics_fb.get("dateanalyticsRows") as UntypedFormArray
  }

  substituteRows(): UntypedFormArray {
    return this.bizdata_ops_substitute_fb.get("substituteRows") as UntypedFormArray
  }

  stripRows(): UntypedFormArray {
    return this.bizdata_ops_strip_fb.get("stripRows") as UntypedFormArray
  }

  substringRows(): UntypedFormArray {
    return this.bizdata_ops_substring_fb.get("substringRows") as UntypedFormArray
  }

  renameRows(): UntypedFormArray {
    return this.bizdata_ops_rename_fb.get("renameRows") as UntypedFormArray
  }

  sleepRows(): UntypedFormArray {
    return this.bizdata_ops_sleeptime_fb.get("sleepRows") as UntypedFormArray
  }

  pycodeRows(): UntypedFormArray {
    return this.bizdata_ops_pycode_fb.get("pycodeRows") as UntypedFormArray
  }

  aiOpsRows(): UntypedFormArray {
    return this.bizdata_ops_aiops_fb.get("aiOpsRows") as UntypedFormArray
  }

  filterRows(): UntypedFormArray {
    return this.bizdata_ops_filter_fb.get("filterRows") as UntypedFormArray
  }

  filterEndsRows(): UntypedFormArray {
    return this.bizdata_ops_filterends_fb.get("filterEndsRows") as UntypedFormArray
  }

  jdbcoutputRows(): UntypedFormArray {
    return this.bizdata_ops_jdbcoutput_fb.get("jdbcoutputRows") as UntypedFormArray
  }
  dlIngestionRows(): UntypedFormArray {
    return this.bizdata_ops_dlakeingestion_fb.get("dlIngestionRows") as UntypedFormArray
  }
  dlsearchRows(): UntypedFormArray {
    return this.bizdata_ops_dlsearch_fb.get("dlsearchRows") as UntypedFormArray
  }
  zipfileinbase64Rows(): UntypedFormArray {
    return this.bizdata_ops_zipfileinbase64_fb.get("zipfileinbase64Rows") as UntypedFormArray
  }

  dl2arrayRows(): UntypedFormArray {
    return this.bizdata_ops_dl2array_fb.get("dl2arrayRows") as UntypedFormArray
  }

  docunderstandingRows(): UntypedFormArray {
    return this.bizdata_ops_docunderstanding_fb.get("docunderstandingRows") as UntypedFormArray
  }
  imgunderstandingRows(): UntypedFormArray {
    return this.bizdata_ops_imgunderstanding_fb.get("imgunderstandingRows") as UntypedFormArray
  }

  dataTypesForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      boolean_operator: '',
      float_operator: '',
      integer_operator: '',
      datetime_operator: '',
      id: id,
    })
  }
  bridgenameCheck(event) {
    return ((event.keyCode >= '65' && event.keyCode <= '90') || (event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  fillDataTypesForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      boolean_operator: [{ value: this.helperService.objectToStringConverter("Array", formdata.boolean_operator), disabled: true }],
      float_operator: [{ value: this.helperService.objectToStringConverter("Array", formdata.float_operator), disabled: true }],
      integer_operator: [{ value: this.helperService.objectToStringConverter("Array", formdata.integer_operator), disabled: true }],
      datetime_operator: [{ value: this.helperService.objectToStringConverter("Array", formdata.datetime_operator), disabled: true }],
      id: id,
    })
  }

  addNewDataTypesForm(id) {
    this.datatypesRows().push(this.dataTypesForm(id));
  }

  fillNewDataTypesForm(id, formdata) {
    this.datatypesRows().push(this.fillDataTypesForm(id, formdata));
  }

  appendForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      append: '',
      id: id,
    })
  }

  fillAppendForm(id, formdata): UntypedFormGroup {
    let append = JSON.stringify(formdata.append, null, ' ').slice(1, -1).trim();
    return this._formBuilder.group({
      append: [{ value:this.helperService.objectToStringConverter("Json", formdata.append), disabled: true }],//this.helperService.objectToStringConverter("Json", formdata.append)
      id: id,
    })
  }

  addNewAppendForm(id) {
    this.appendRows().push(this.appendForm(id));
  }


  fillNewAppendForm(id, formdata) {
    this.appendRows().push(this.fillAppendForm(id, formdata));
  }


  titlecaseForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      titlecase: '',
      id: id,
    })
  }

  fillTitlecaseForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      titlecase: [{ value: this.helperService.objectToStringConverter("Array", formdata.titlecase), disabled: true }],
      id: id,
    })
  }

  addNewTitlecaseForm(id) {
    this.titlecaseRows().push(this.titlecaseForm(id));
  }

  fillNewTitlecaseForm(id, formdata) {
    this.titlecaseRows().push(this.fillTitlecaseForm(id, formdata));
  }

  uppercaseForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      uppercase: '',
      id: id,
    })
  }

  fillUppercaseForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      uppercase: [{ value: this.helperService.objectToStringConverter("Array", formdata.uppercase), disabled: true }],
      id: id,
    })
  }

  addNewUppercaseForm(id) {
    this.uppercaseRows().push(this.uppercaseForm(id));
  }

  fillNewUppercaseForm(id, formdata) {
    this.uppercaseRows().push(this.fillUppercaseForm(id, formdata));
  }

  lowercaseForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      lowercase: '',
      id: id,
    })
  }

  fillLowercaseForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      lowercase: [{ value: this.helperService.objectToStringConverter("Array", formdata.lowercase), disabled: true }],
      id: id,
    })
  }

  addNewLowercaseForm(id) {
    this.lowercaseRows().push(this.lowercaseForm(id));
  }

  fillNewLowercaseForm(id, formdata) {
    this.lowercaseRows().push(this.fillLowercaseForm(id, formdata));
  }

  dataExtractorForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      data_extractor: '',
      data_extractor_keys: '',
      id: id,
    })
  }

  fillDataExtractorForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      data_extractor: [{ value: this.helperService.objectToStringConverter("Array", formdata.data_extractor), disabled: true }],
      data_extractor_keys: [{ value: this.helperService.objectToStringConverter("Array", formdata.data_extractor_keys), disabled: true }],
      id: id,
    })
  }

  addNewDataExtractorForm(id) {
    this.dataextractorRows().push(this.dataExtractorForm(id));
  }

  fillNewDataExtractorForm(id, formdata) {
    this.dataextractorRows().push(this.fillDataExtractorForm(id, formdata));
  }

  trimForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      trim_keys: '',
      id: id,
    })
  }

  fillTrimForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      trim_keys: [{ value: this.helperService.objectToStringConverter("Array", formdata.trim_keys), disabled: true }],
      id: id,
    })
  }

  addNewTrimForm(id) {
    this.trimRows().push(this.trimForm(id));
  }

  fillNewTrimForm(id, formdata) {
    this.trimRows().push(this.fillTrimForm(id, formdata));
  }

  base64decodingForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      base64_decode: '',
      id: id,
    })
  }

  fillBase64decodingForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      base64_decode: [{ value: this.helperService.objectToStringConverter("Array", formdata.base64_decode), disabled: true }],
      id: id,
    })
  }

  addNewBase64decodingForm(id) {
    this.base64decodingRows().push(this.base64decodingForm(id));
  }

  fillNewBase64decodingForm(id, formdata) {
    this.base64decodingRows().push(this.fillBase64decodingForm(id, formdata));
  }

  base64encodingForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      input_type: '',
      base64_encode: '',
      id: id,
    })
  }

  fillBase64encodingForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      input_type: [{ value: formdata.input_type, disabled: true }],
      base64_encode: [{ value: this.helperService.objectToStringConverter("Array", formdata.base64_encode), disabled: true }],
      id: id,
    })
  }

  addNewBase64encodingForm(id) {
    this.base64encodingRows().push(this.base64encodingForm(id));
  }

  fillNewBase64encodingForm(id, formdata) {
    this.base64encodingRows().push(this.fillBase64encodingForm(id, formdata));
  }

  jsontoxmlForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      response_key: '',
      id: id,
    })
  }

  fillJSONtoXMLForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: [{ value: formdata.key_data, disabled: true }],
      response_key: [{ value: formdata.response_key, disabled: true }],
      id: id,
    })
  }

  addNewJSONtoXMLForm(id) {
    this.jsontoxmlRows().push(this.jsontoxmlForm(id));
  }

  fillNewJSONtoXMLForm(id, formdata) {
    this.jsontoxmlRows().push(this.fillJSONtoXMLForm(id, formdata));
  }

  xmltojsonForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      get_key: '',
      response_key: '',
      id: id,
    })
  }

  fillXmltojsonForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      get_key: [{ value: formdata.get_key, disabled: true }],
      response_key: [{ value: formdata.response_key, disabled: true }],
      id: id,
    })
  }

  addNewXmltojsonForm(id) {
    this.xmltojsonRows().push(this.xmltojsonForm(id));
  }

  fillNewXmltojsonForm(id, formdata) {
    this.xmltojsonRows().push(this.fillXmltojsonForm(id, formdata));
  }

  repeatfirstrowForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      source_key: '',
      fields_to_repeat_value: '',
      id: id,
    })
  }

  fillRepeatfirstrowForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      source_key: [{ value: formdata.source_key, disabled: true }],
      fields_to_repeat_value: [{ value: this.helperService.objectToStringConverter("Array", formdata.fields_to_repeat_value), disabled: true }],
      id: id,
    })
  }

  addNewRepeatfirstrowForm(id) {
    this.repeatfirstrowRows().push(this.repeatfirstrowForm(id));
  }

  fillNewRepeatfirstrowForm(id, formdata) {
    this.repeatfirstrowRows().push(this.fillRepeatfirstrowForm(id, formdata));
  }

  generatesequenceForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      sequence_key: "",
      sequence_number_key: "",
      id: id,
    })
  }

  fillGeneratesequenceForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      sequence_key: [{ value: formdata.sequence_key, disabled: true }],
      sequence_number_key: [{ value: formdata.sequence_number_key, disabled: true }],
      id: id,
    })
  }

  addNewGeneratesequenceForm(id) {
    this.generatesequenceRows().push(this.generatesequenceForm(id));
  }

  fillNewGeneratesequenceForm(id, formdata) {
    this.generatesequenceRows().push(this.fillGeneratesequenceForm(id, formdata));
  }

  json2stringForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      json2string: "",
      id: id,
    })
  }

  fillJson2stringForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      json2string: [{ value: this.helperService.objectToStringConverter("Array", formdata.json2string), disabled: true }],
      id: id,
    })
  }

  addNewJson2stringForm(id) {
    this.json2stringRows().push(this.json2stringForm(id));
  }

  fillNewJson2stringForm(id, formdata) {
    this.json2stringRows().push(this.fillJson2stringForm(id, formdata));
  }

  string2jsonForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      string2json: "",
      id: id,
    })
  }

  fillString2jsonForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      string2json: [{ value: this.helperService.objectToStringConverter("Array", formdata.string2json), disabled: true }],
      id: id,
    })
  }

  addNewString2jsonForm(id) {
    this.string2jsonRows().push(this.string2jsonForm(id));
  }

  fillNewString2jsonForm(id, formdata) {
    this.string2jsonRows().push(this.fillString2jsonForm(id, formdata));
  }

  toplevelForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      column_to_root: "",
      id: id,
    })
  }

  fillToplevelForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      column_to_root: [{ value: this.helperService.objectToStringConverter("Array", formdata.column_to_root), disabled: true }],
      id: id,
    })
  }

  addNewToplevelForm(id) {
    this.toplevelRows().push(this.toplevelForm(id));
  }

  fillNewToplevelForm(id, formdata) {
    this.toplevelRows().push(this.fillToplevelForm(id, formdata));
  }

  datetimestampForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      date_format: "",
      datetime_key: "",
      id: id,
    })
  }

  fillDatetimestampForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      date_format: [{ value: formdata.date_format, disabled: true }],
      datetime_key: [{ value: formdata.datetime_key, disabled: true }],
      id: id,
    })
  }

  addNewDatetimestampForm(id) {
    this.datetimestampRows().push(this.datetimestampForm(id));
  }

  fillNewDatetimestampForm(id, formdata) {
    this.datetimestampRows().push(this.fillDatetimestampForm(id, formdata));
  }
  //--------------------------------------------
  json2dlForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      delimiter: '',
      fields: '',
      autodetect_column_names: '',
      skip_header: '',
      response_key: '',
      id: id,
    })
  }

  fillJson2dlForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: [{ value: formdata.key_data, disabled: true }],
      delimiter: [{ value: this.helperService.replaceDoubleToSingleBackSlash(formdata.delimiter), disabled: true }],
      fields: [{ value: this.helperService.objectToStringConverter("Array", formdata.fields), disabled: true }],
      autodetect_column_names: [{ value: formdata.autodetect_column_names, disabled: true }],
      skip_header: [{ value: formdata.skip_header, disabled: true }],
      response_key: [{ value: formdata.response_key, disabled: true }],
      id: id,
    })
  }

  addNewJson2dlForm(id) {
    this.json2dlRows().push(this.json2dlForm(id));
  }

  fillNewJson2dlForm(id, formdata) {
    this.json2dlRows().push(this.fillJson2dlForm(id, formdata));
  }

  dl2jsonForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      delimiter: '',
      fields: '',
      autodetect_column_names: '',
      skip_header: '',
      response_key: '',
      id: id,
    })
  }

  fillDl2jsonForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: [{ value: formdata.key_data, disabled: true }],
      delimiter: [{ value: this.helperService.replaceDoubleToSingleBackSlash(formdata.delimiter), disabled: true }],
      fields: [{ value: this.helperService.objectToStringConverter("Array", formdata.fields), disabled: true }],
      autodetect_column_names: [{ value: formdata.autodetect_column_names, disabled: true }],
      skip_header: [{ value: formdata.skip_header, disabled: true }],
      response_key: [{ value: formdata.response_key, disabled: true }],
      id: id,
    })
  }

  addNewDl2jsonForm(id) {
    this.dl2jsonRows().push(this.dl2jsonForm(id));
  }

  fillNewDl2jsonForm(id, formdata) {
    this.dl2jsonRows().push(this.fillDl2jsonForm(id, formdata));
  }

  dataaggregationForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      agg_data_key: '',
      groupby_key: '',
      array_key: '',
      array_key_nested_columns: '',
      id: id,
    })
  }

  fillDataaggregationForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      agg_data_key: [{ value: formdata.agg_data_key, disabled: true }],
      groupby_key: [{ value: formdata.groupby_key, disabled: true }],
      array_key: [{ value: formdata.array_key, disabled: true }],
      array_key_nested_columns: [{ value: this.helperService.objectToStringConverter("Array", formdata.array_key_nested_columns), disabled: true }],
      id: id,
    })
  }

  addNewDataaggregationForm(id) {
    this.dataaggregationRows().push(this.dataaggregationForm(id));
  }

  fillNewDataaggregationForm(id, formdata) {
    this.dataaggregationRows().push(this.fillDataaggregationForm(id, formdata));
  }

  pivotForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      get_key: '',
      transposed_key_name: '',
      transposed_value: '',
      id: id,
    })
  }

  fillPivotForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      get_key: [{ value: formdata.get_key, disabled: true }],
      transposed_key_name: [{ value: this.helperService.objectToStringConverter("Array", formdata.transposed_key_name), disabled: true }],
      transposed_value: [{ value: this.helperService.objectToStringConverter("Array", formdata.transposed_value), disabled: true }],
      id: id,
    })
  }


  addNewPivotForm(id) {
    this.pivotRows().push(this.pivotForm(id));
  }

  fillNewPivotForm(id, formdata) {
    this.pivotRows().push(this.fillPivotForm(id, formdata));
  }

  unpivotForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      transpose_key_name: '',
      transpose_value: '',
      id: id,
    })
  }

  fillUnpivotForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      transpose_key_name: [{ value: this.helperService.objectToStringConverter("Array", formdata.transpose_key_name), disabled: true }],
      transpose_value: [{ value: this.helperService.objectToStringConverter("Array", formdata.transpose_value), disabled: true }],
      id: id,
    })
  }

  addNewUnPivotForm(id) {
    this.unpivotRows().push(this.unpivotForm(id));
  }

  fillNewUnpivotForm(id, formdata) {
    this.unpivotRows().push(this.fillUnpivotForm(id, formdata));
  }

  chopForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      chopkey: '',
      id: id,
    })
  }


  fillChopForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      chopkey: [{ value: formdata.chopkey, disabled: true }],
      id: id,
    })
  }

  addNewChopForm(id) {
    this.chopRows().push(this.chopForm(id));
  }

  fillNewChopForm(id, formdata) {
    this.chopRows().push(this.fillChopForm(id, formdata));
  }

  singleline2tupleForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      singleline_key: '',
      table_headers: '',
      tuple_key: '',
      id: id,
    })
  }

  fillSingleline2tupleForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      singleline_key: [{ value: formdata.singleline_key, disabled: true }],
      table_headers: [{ value: this.helperService.objectToStringConverter("Array", formdata.table_headers), disabled: true }],
      tuple_key: [{ value: formdata.tuple_key, disabled: true }],
      id: id,
    })
  }

  addNewSingleline2tupleForm(id) {
    this.singleline2tupleRows().push(this.singleline2tupleForm(id));
  }

  fillNewSingleline2tupleForm(id, formdata) {
    this.singleline2tupleRows().push(this.fillSingleline2tupleForm(id, formdata));
  }

  tuple2singlelineForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      tuple_key: '',
      headers: '',
      singleline_key: '',
      id: id,
    })
  }

  fillTuple2singlelineForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      tuple_key: [{ value: formdata.tuple_key, disabled: true }],
      headers: [{ value: this.helperService.objectToStringConverter("Array", formdata.headers), disabled: true }],
      singleline_key: [{ value: formdata.singleline_key, disabled: true }],
      id: id,
    })
  }

  addNewTuple2singlelineForm(id) {
    this.tuple2singlelineRows().push(this.tuple2singlelineForm(id));
  }

  fillNewTuple2singlelineForm(id, formdata) {
    this.tuple2singlelineRows().push(this.fillTuple2singlelineForm(id, formdata));
  }

  fileForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      target_location: '',
      extension: '',
      write_mode: '',
      id: id,
    })
  }

  fillFileForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      target_location: [{ value: formdata.chopkey, disabled: true }],
      extension: [{ value: formdata.extension, disabled: true }],
      write_mode: [{ value: formdata.write_mode, disabled: true }],
      id: id,
    })
  }

  // addNewFileForm(id) {
  //   this.fileRows().push(this.fileForm(id));
  // }

  // fillNewFileForm(id, formdata) {
  //   this.fileRows().push(this.fillFileForm(id, formdata));
  // }

  emailForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_to_start_with: '',
      response_parameter: '',
      mailserver: '',
      port_number: '',
      From: '',
      to: '',
      password: '',
      cc: '',
      response_key: '',
      seperator: '',
      attachment: '',
      attachment_extension: '',
      in_data: '',
      body_arr: '',
      subject: '',
      body: '',
      id: id,
    })
  }

  async fillEmailForm(id, formdata): Promise<UntypedFormGroup> {
      formdata.password =  formdata.password ? await this.helperService.decrypt(formdata.password):"";
    const parser = new DOMParser();
    const parsedBody = parser.parseFromString(formdata.body || "", "text/html");
    const bodyText = parsedBody.body.textContent || "";
    return this._formBuilder.group({
      drop_all_event_to_start_with: [{ value: formdata.drop_all_event_to_start_with, disabled: true }],
      response_parameter: [{ value: formdata.response_parameter, disabled: true }],
      mailserver: [{ value: formdata.mailserver, disabled: true }],
      port_number: [{ value: formdata.port_number, disabled: true }],
      From: [{ value: formdata.From, disabled: true }],
      to: [{ value: formdata.to, disabled: true }],
      password: [{ value: formdata.password, disabled: true }],
      cc: [{ value: formdata.cc, disabled: true }],
      bcc: [{ value: formdata.bcc, disabled: true }],
      source_key: [{ value: formdata.source_key, disabled: true }],
      file_name: [{ value: formdata.file_name, disabled: true }],
      response_key: [{ value: formdata.response_key, disabled: true }],
      seperator: [{ value: formdata.seperator, disabled: true }],
      attachment: [{ value: formdata.attachment, disabled: true }],
      attachment_extension: [{ value: formdata.attachment_extension, disabled: true }],
      in_data: [{ value: formdata.in_data, disabled: true }],
      body_arr: [{ value: formdata.body_arr, disabled: true }],
      subject: [{ value: formdata.subject, disabled: true }],
      body: [{ value: bodyText, disabled: true }],
      id: id,
    })
  }

  addNewEmailForm(id) {
    this.emailRows().push(this.emailForm(id));
  }

  async fillNewEmailForm(id, formdata) {
    this.emailRows().push( await this.fillEmailForm(id, formdata));
  }

  restapiForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      'drop_all_event_to_start_with': [''],
      "min_num": [''],
      "max_num": [''],
      "endpoint_url": [''],
      "endpoint_headers": [''],
      "endpoint_method": [''],
      "endpoint_body": [''],
      "endpoint_params": [''],
      "authentication_type": [''],
      "username": [''],
      "password": [''],
      "refresh_token_url": [''],
      "refresh_token_headers": [''],
      "refresh_token_method": [''],
      "refresh_token_body": [''],
      "refresh_token_params": [''],
      "pre_request_script": [''],
      "response_parameters": [''],
      "another_response_parameter": [''],
      "key_name_to_update": [''],
      "user_key": [''],
      "pagination_style": [''],
      "timer_type": [''],
      "interval_in_seconds": [''],
      "schedule": [''],
      "user_key_url": [''],
      "bridge_endpoint_selected_environments_name":[''],
      "bridge_target_endpoint_method":[''],
      "bridge_target_endpoint_url":[''],
      "bridge_target_endpoint_params_raw":[''],
      id: id,
    })
  }

  env_variables(env_vars):FormArray{
    let env_array = this._formBuilder.array(
      env_vars.map((varItem: any) =>
        this._formBuilder.group({
          type: [{ value: varItem.type, disabled: true }],
          variable: [{ value: varItem.variable, disabled: true }],
          value: [{ value: varItem.value, disabled: true }],
        })
      )
    );
    return env_array;
  }

  env_varsControls(env_vars):FormArray{
    return env_vars
  }

  async fillRestapiForm(id, formdata): Promise<UntypedFormGroup> {
      formdata.refresh_token_url = formdata.refresh_token_url?await this.helperService.decrypt(formdata.refresh_token_url):"";
      formdata.refresh_token_body = formdata.refresh_token_body?JSON.stringify(JSON.parse(await this.helperService.decrypt(formdata.refresh_token_body))):"";
      formdata.password = formdata.password?await this.helperService.decrypt(formdata.password):"";
      formdata.pre_request_script = formdata.pre_request_script?await this.helperService.decrypt(formdata.pre_request_script):"";

      const endpointParamsArray = this._formBuilder.array(
        formdata.endpoint_params.map(param => this._formBuilder.group({
          endpoint_params_key: [{value:param.key, disabled:true}],
          endpoint_params_value: [{value:param.value,disabled:true}],
          endpoint_params_description: [{value:param.description, disabled:true}]
        }))
      );
      
      const endpointHeadersArray = this._formBuilder.array(
        formdata.endpoint_headers.map(headers => this._formBuilder.group({
          endpoint_headers_key: [{value:headers.key,disabled:true}],
          endpoint_headers_value: [{value:headers.value,disabled:true}],
          endpoint_headers_description: [{value:headers.description, disabled:true}]
        }))
      );
  
      const environments = this._formBuilder.array(
        formdata.environment_variables.map(env => this._formBuilder.group({
          env_name: [{value:env.env_name,disabled:true}],
          env_vars:this.env_variables(env.env_vars)
        }))
      );

    return this._formBuilder.group({
      bridge_target: [{value: formdata.target_name, disabled:true}],
      bridge_target_business_object: [{value:formdata.target_business_obj,disabled: true}],
      drop_all_event_to_start_with: [{ value: formdata.drop_all_event_to_start_with, disabled: true }],
      min_num: [{ value: formdata.min_num, disabled: true }],
      max_num: [{ value: formdata.max_num, disabled: true }],
      endpoint_url: [{ value: formdata.endpoint_url.replace(/<span style="color: red">.*?<\/span>/g, ''), disabled: true }],
      endpoint_headers: [{ value: JSON.stringify(formdata.endpoint_headers), disabled: true }],
      endpoint_method: [{ value: formdata.endpoint_method.method, disabled: true }],
      endpoint_body: [{ value: JSON.stringify(formdata.endpoint_body) == '{}' || formdata.endpoint_body == "" || formdata.endpoint_body == null ? '' : JSON.stringify(formdata.endpoint_body), disabled: true }],
      endpoint_params: [{ value: JSON.stringify(formdata.endpoint_params), disabled: true }],
      endpoint_params_key:[{value:formdata.endpoint_params.key}],
      endpoint_params_value:[{value:formdata.endpoint_params.value}],
      endpoint_params_description:[{value:formdata.endpoint_params.key}],
      authentication_type: [{ value: formdata.authentication_type.type, disabled: true }],
      username: [{ value: formdata.username, disabled: true }],
      password: [{ value: formdata.password, disabled: true }],
      
      refresh_token_url: [{ value: formdata.refresh_token_url, disabled: true }],
      refresh_token_headers: [{ value: JSON.stringify(formdata.refresh_token_headers) == '{}' || formdata.refresh_token_headers == '' || formdata.refresh_token_headers == null ? '' : JSON.stringify(formdata.refresh_token_headers), disabled: true }],
      refresh_token_method: [{ value: formdata.refresh_token_method.method, disabled: true }],
      // refresh_token_body: [{ value: JSON.stringify(formdata.refresh_token_body) == '{}' || formdata.refresh_token_body == '' || formdata.refresh_token_body == null ? '' : JSON.stringify(formdata.refresh_token_body), disabled: true }],
      refresh_token_body: [{ value: JSON.stringify(formdata.refresh_token_body) == '{}' || formdata.refresh_token_body == '' || formdata.refresh_token_body == null ? '' : formdata.refresh_token_body, disabled: true }],
      refresh_token_params: [{ value: JSON.stringify(formdata.refresh_token_params) == '{}' || formdata.refresh_token_params == '' || formdata.refresh_token_params == null ? '' : JSON.stringify(formdata.refresh_token_params), disabled: true }],
      // pre_request_script: [{ value: decodeURIComponent(formdata.pre_request_script), disabled: true }],
      pre_request_script: [{ value: formdata.pre_request_script, disabled: true }],
      response_parameters: [{ value: JSON.stringify(formdata.response_parameters), disabled: true }],
      another_response_parameter: [{ value: formdata.another_response_parameter, disabled: true }],
      key_name_to_update: [{ value: formdata.key_name_to_update, disabled: true }],
      user_key: [{ value: formdata.user_key, disabled: true }],
      pagination_style: [{ value: formdata.pagination_style, disabled: true }],
      timer_type: [{ value: formdata.timer_type, disabled: true }],
      interval_in_seconds: [{ value: formdata.interval_in_seconds, disabled: true }],
      schedule: [{ value: formdata.schedule, disabled: true }],
      user_key_url: [{ value: formdata.user_key_url, disabled: true }],
      bridge_endpoint_selected_environments_name:[''],
      bridge_target_endpoint_method:[''],
      bridge_target_endpoint_url:[''],
      bridge_target_endpoint_params_raw:endpointParamsArray,
      bridge_target_endpoint_authentication_type:[''],
      bridge_target_endpoint_headers:endpointHeadersArray,
      authentication_type_id:[{value:formdata.authentication_type.id}],
      bridge_target_body_type:[{value:formdata.body_type, disabled:true}],
      response_type:[{value:formdata.response_type, disabled:true}],
      bridge_endpoint_environments_raw:environments,
      id: id,
    })
  }

  addNewRestapiForm(id) {
    this.restapiRows().push(this.restapiForm(id));
  }

  async fillNewRestapiForm(id, formdata) {
    this.restapiRows().push(await this.fillRestapiForm(id, formdata));
  }


  jsonForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      'drop_all_event_to_start_with': [''],
      "jdbc_driver": [''],
      "jdbc_string": [''],
      "jdbc_jar_file": [''],
      "username": [''],
      "password": [''],
      "unique_key": [''],
      "query": [''],
      "response_parameter": [''],
      "timer_type": [''],
      "schedule": [''],
      "interval_in_seconds": [''],
      "multiline": [''],
      id: id,
    })
  }


  fillJsonForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_to_start_with: [{ value: formdata.drop_all_event_to_start_with, disabled: true }],
      jdbc_driver: [{ value: formdata.jdbc_driver, disabled: true }],
      jdbc_string: [{ value: formdata.jdbc_string, disabled: true }],
      jdbc_jar_file: [{ value: formdata.jdbc_jar_file, disabled: true }],
      username: [{ value: formdata.username, disabled: true }],
      password: [{ value: formdata.password, disabled: true }],
      unique_key: [{ value: formdata.unique_key, disabled: true }],
      query: [{ value: formdata.query, disabled: true }],
      response_parameter: [{ value: formdata.response_parameter, disabled: true }],
      timer_type: [{ value: formdata.timer_type, disabled: true }],
      schedule: [{ value: formdata.schedule, disabled: true }],
      interval_in_seconds: [{ value: formdata.interval_in_seconds, disabled: true }],
      multiline: [{ value: formdata.multiline, disabled: true }],
      id: id,
    })
  }

  addNewJsonForm(id) {
    this.jsonRows().push(this.jsonForm(id));
  }

  fillNewJsonForm(id, formdata) {
    this.jsonRows().push(this.fillJsonForm(id, formdata));
  }

  dropeventsstartswithForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_to_start_with: '',
      id: id,
    })
  }

  fillDropeventsstartswithForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_to_start_with: [{ value: this.helperService.objectToStringConverter("Array", formdata.drop_all_event_to_start_with), disabled: true }],
      id: id,
    })
  }

  addNewDropeventsstartswithForm(id) {
    this.dropeventsstartswithRows().push(this.dropeventsstartswithForm(id));
  }

  fillNewDropeventsstartswithForm(id, formdata) {
    this.dropeventsstartswithRows().push(this.fillDropeventsstartswithForm(id, formdata));
  }


  dropalleventvaluesForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_for_value: '',
      id: id,
    })
  }

  fillDropalleventvaluesForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_for_value: [{ value: this.helperService.objectToStringConverter("Array", formdata.drop_all_event_for_value), disabled: true }],
      id: id,
    })
  }

  addNewDropalleventvaluesForm(id) {
    this.dropalleventvaluesRows().push(this.dropalleventvaluesForm(id));
  }

  fillNewDropalleventvaluesForm(id, formdata) {
    this.dropalleventvaluesRows().push(this.fillDropalleventvaluesForm(id, formdata));
  }

  eliminateForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      eliminate: '',
      id: id,
    })
  }

  fillEliminateForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      eliminate: [{ value: this.helperService.objectToStringConverter("Array", formdata.eliminate), disabled: true }],
      id: id,
    })
  }

  addNewEliminateForm(id) {
    this.eliminateRows().push(this.eliminateForm(id));
  }

  fillNewEliminateForm(id, formdata) {
    this.eliminateRows().push(this.fillEliminateForm(id, formdata));
  }

  roundForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      round_keys: '',
      decimal_key_number: '2',
      id: id,
    })
  }

  fillRoundForm(id, formdata): UntypedFormGroup {
    //console.log(formdata)
    return this._formBuilder.group({
      round_keys: [{ value: this.helperService.objectToStringConverter("Array", formdata.round_keys), disabled: true }],
      decimal_key_number: [{ value: formdata.decimal_key_number, disabled: true }],
      id: id,
    })
  }

  addNewRoundForm(id) {
    this.roundRows().push(this.roundForm(id));
  }

  fillNewRoundForm(id, formdata) {
    this.roundRows().push(this.fillRoundForm(id, formdata));
  }

  calculaterForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      calculation_keys: '',
      new_calculation_keys: '',
      id: id,
    })
  }

  fillCalculaterForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      calculation_keys: [{ value: this.helperService.objectToStringConverter("Array", formdata.calculation_keys), disabled: true }],
      new_calculation_keys: [{ value: this.helperService.objectToStringConverter("Array", formdata.new_calculation_keys), disabled: true }],
      id: id,
    })
  }

  addNewCalculaterForm(id) {
    this.calculaterRows().push(this.calculaterForm(id));
  }

  fillNewCalculaterForm(id, formdata) {
    this.calculaterRows().push(this.fillCalculaterForm(id, formdata));
  }

  dateanalyticsForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      date_field_key: '',
      fiscal_month_start: '',
      date_column: '',
      weekday: '',
      id: id,
    })
  }

  fillDateanalyticsForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      date_field_key: [{ value: formdata.date_field_key, disabled: true }],
      // date_field_key: [{ value: this.helperService.objectToStringConverter("Array", formdata.date_field_key), disabled: true }],
      fiscal_month_start: [{ value: formdata.fiscal_month_start, disabled: true }],
      date_column: [{ value: this.helperService.objectToStringConverter("Array", formdata.date_column), disabled: true }],
      weekday: [{ value: formdata.weekday, disabled: true }],
      id: id,
    })
  }

  addNewDateanalyticsForm(id) {
    this.dateanalyticsRows().push(this.dateanalyticsForm(id));
  }

  fillNewDateanalyticsForm(id, formdata) {
    this.dateanalyticsRows().push(this.fillDateanalyticsForm(id, formdata));
  }

  substituteForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      substitute: '',
      id: id,
    })
  }

  fillSubstitutesForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      substitute: [{ value: this.helperService.objectToStringConverter("Array", formdata.substitute), disabled: true }],
      id: id,
    })
  }

  addNewSubstituteForm(id) {
    this.substituteRows().push(this.substituteForm(id));
  }

  fillNewSubstituteForm(id, formdata) {
    this.substituteRows().push(this.fillSubstitutesForm(id, formdata));
  }

  stripForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      strip: '',
      id: id,
    })
  }

  fillStripForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      strip: [{ value: this.helperService.objectToStringConverter("Array", formdata.strip), disabled: true }],
      id: id,
    })
  }

  addNewStripForm(id) {
    this.stripRows().push(this.stripForm(id));
  }

  fillNewStripForm(id, formdata) {
    this.stripRows().push(this.fillStripForm(id, formdata));
  }

  substringForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      substring: '',
      id: id,
    })
  }

  fillSubstringForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      substring: [{ value: this.helperService.objectToStringConverter("Json", formdata.substring), disabled: true }],
      id: id,
    })
  }

  addNewSubstringForm(id) {
    this.substringRows().push(this.substringForm(id));
  }

  fillNewSubstringForm(id, formdata) {
    this.substringRows().push(this.fillSubstringForm(id, formdata));
  }


  renameForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      rename: '',
      id: id,
    })
  }

  fillRenameForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      rename: [{ value: this.helperService.objectToStringConverter("Json", formdata.rename), disabled: true }],
      id: id,
    })
  }

  addNewRenameForm(id) {
    this.renameRows().push(this.renameForm(id));
  }

  fillNewRenameForm(id, formdata) {
    this.renameRows().push(this.fillRenameForm(id, formdata));
  }

  sleepForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      sleep_time: '',
      id: id,
    })
  }

  fillSleepForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      sleep_time: [{ value: formdata.sleep_time, disabled: true }],
      id: id,
    })
  }

  addNewSleepForm(id) {
    this.sleepRows().push(this.sleepForm(id));
  }

  fillNewSleepForm(id, formdata) {
    this.sleepRows().push(this.fillSleepForm(id, formdata));
  }

  pycodeForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      pycode: '',
      response: '',
      id: id,
    })
  }

  fillPycodeForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      pycode: [{ value: formdata.pycode, disabled: true }],
      response: [{ value: formdata.response, disabled: true }],
      id: id,
    })
  }

  fillaiOpsForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      question: [{ value: formdata.question, disabled: true }],
      id: id,
    })
  }

  addNewPycodeForm(id) {
    this.pycodeRows().push(this.pycodeForm(id));
  }

  fillNewPycodeForm(id, formdata) {
    this.pycodeRows().push(this.fillPycodeForm(id, formdata));
  }

  fillNewaiOpsForm(id, formdata) {
    this.aiOpsRows().push(this.fillaiOpsForm(id, formdata));
  }

  encodedecodeForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      response_key: '',
      method_type: '',
      process: 'encode',
      id: id,
    })
  }

  fillEncodedecodeForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      response_key: [{ value: formdata.response_key, disabled: true }],
      method_type: [{ value: formdata.method_type, disabled: true }],
      process: [{ value: formdata.process, disabled: true }],
      id: id,
    })
  }

  addNewEncodedecodeForm(id) {
    this.encodedecodeRows().push(this.encodedecodeForm(id));
  }

  fillNewEncodedecodeForm(id, formdata) {
    this.encodedecodeRows().push(this.fillEncodedecodeForm(id, formdata));
  }

  async fillJdbcoutputForm(id, formdata): Promise<UntypedFormGroup> {
      formdata.password =  formdata.password ? await this.helperService.decrypt(formdata.password):"";
    return this._formBuilder.group({
      "storage_name": [{ value: formdata.storage_name.storage_name, disabled: true }],
      "db_version": [{ value: formdata.db_version.dbversion, disabled: true }],
      "tuple_key": [{ value: formdata.tuple_key, disabled: true }],//JSON.parse(this.helperService.objectToStringConverter('Array', formdata.tuple_key)), disabled: true }],
      "host_ip": [{ value: formdata.host_ip, disabled: true }],
      "port_number": [{ value: formdata.port_number, disabled: true }],
      "schema_name": [{ value: formdata.schema_name, disabled: true }],
      "batch_size": [{ value: formdata.batch_size, disabled: true }],
      "username": [{ value: formdata.username, disabled: true }],
      "password": [{ value: formdata.password, disabled: true }],
      "query": [{ value: '"'+ formdata.query+'"', disabled: true }],//this.helperService.objectToStringConverter('Array', formdata.query), disabled: true }],
      "id": id
    })
  }

  async fillNewJdbcoutputForm(id, formdata) {
    this.jdbcoutputRows().push(await this.fillJdbcoutputForm(id, formdata));
  }

  zipfileinbase64Form(id): UntypedFormGroup {
    return this._formBuilder.group({
      "source_key": "",
      "file_name_key": "",
      "file_extension_key": "",
      "file_data_key": "",
      "base64_response_key": "",
      "id": id
    })
  }

  addNewZipfileinbase64Form(id) {
    this.zipfileinbase64Rows().push(this.zipfileinbase64Form(id));
  }

  fillZipfileinbase64Form(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "source_key": [{ value: formdata.source_key, disabled: true }],
      "file_name_key": [{ value: formdata.file_name_key, disabled: true }],
      "file_extension_key": [{ value: formdata.file_extension_key, disabled: true }],
      "file_data_key": [{ value: formdata.file_data_key, disabled: true }],
      "base64_response_key": [{ value: formdata.base64_response_key, disabled: true }],
      "id": id
    })
  }

  fillNewZipfileinbase64Form(id, formdata) {
    this.zipfileinbase64Rows().push(this.fillZipfileinbase64Form(id, formdata));
  }

  arraycountForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      "array_key_name": "",
      "id": id
    })
  }

  addNewArraycountForm(id) {
    this.arraycountRows().push(this.arraycountForm(id));
  }


  fillArraycountForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "array_key_name": [{ value: formdata.array_key_name, disabled: true }],
      "id": id
    })
  }

  fillNewArraycountForm(id, formdata) {
    this.arraycountRows().push(this.fillArraycountForm(id, formdata));
  }

  fillPdfextractorForm(id, formdata): UntypedFormGroup {
    this.pdfLocationToggleValue = formdata.pdfLocationToggle ? formdata.pdfLocationToggle : 'file_url';
    return this._formBuilder.group({
      "pdfLocationToggle": [this.pdfLocationToggleValue],
      "file_url": [{ value: formdata.file_url, disabled: this.pdfLocationToggleValue }],
      "base64_key": [{ value: formdata.base64_key, disabled: this.pdfLocationToggleValue  }],
      "id": id
    })
  }
  fillFileextractorForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "file_data_key": [{ value: formdata.file_data_key, disabled: true }],
      "id": id
    })
  }

  fillNewPdfextractorForm(id, formdata) {
    this.pdfextractorRows().push(this.fillPdfextractorForm(id, formdata));
  }

  fillNewFileextractorForm(id, formdata) {
    this.fileextractorRows().push(this.fillFileextractorForm(id, formdata));
  }
  addNewGrokPatternForm(id, isMute) {
    this.grokpatternRows().push(this.gorkpatterForm(id, isMute));
  }

  gorkpatterForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "input_key": "",
      "grok_pattern": "",
      "isMute": isMute,
      "id": id
    })
  }

  fillGorkPatterForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "input_key": [{ value: formdata.input_key, disabled: true }],
      "grok_pattern": [{ value: formdata.grok_pattern, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewGorkPatterForm(id, formdata) {
    this.grokpatternRows().push(this.fillGorkPatterForm(id, formdata));
  }

  addNewRawSentenceGeneratorForm(id, isMute) {
    this.rawsentencegeneratorRows().push(this.rawsentencegeneratorForm(id, isMute));
  }

  rawsentencegeneratorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "singleline_key":"",
      "include_keys": "",
      "raw_response_key": "",
      "isMute": isMute,
      "id": id
    })
  }

  fillRawSentenceGeneratorForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "singleline_key": [{ value: formdata.singleline_key, disabled: true }],
      "include_keys": [{ value: this.helperService.objectToStringConverter("Array", formdata.include_keys), disabled: true }],
      "raw_response_key": [{ value: formdata.raw_response_key, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewRawSentenceGeneratorForm(id, formdata) {
    this.rawsentencegeneratorRows().push(this.fillRawSentenceGeneratorForm(id, formdata));
  }

  fillTimeUnitsForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "timestamp_key": [{ value: formdata.timestamp_key, disabled: true }],
      "timestamp_column": [{ value: this.helperService.objectToStringConverter("Array", formdata.timestamp_column), disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewTimeUnitsForm(id, formdata) {
    this.timeunitsRows().push(this.fillTimeUnitsForm(id, formdata));
  }

  fillDataChunkingForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "process_key": [{ value: formdata.process_key, disabled: true }],
      "chunk_key": [{ value: formdata.chunk_key, disabled: true }],
      "token_size": [{ value: formdata.token_size, disabled: true }],
      "group_by_chunk": [{ value: formdata.group_by_chunk, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }
  
  fillNewDataChunkingForm(id, formdata) {
    this.datachunkingRows().push(this.fillDataChunkingForm(id, formdata));

  }
  
  filljson2avroForm(id, formdata): UntypedFormGroup {

    //console.log(this._formBuilder)
    return this._formBuilder.group({
      "jsondata_key": [{ value: formdata.jsondata_key, disabled: true }],
      "avro_schema": [{value: this.helperService.objectToStringConverter("Json",formdata.avro_schema), disabled: true }],
      "response_key": [{ value: formdata.response_key, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
    
  }

  fillNewjson2avroForm(id, formdata) {
    this.json2avroRows().push(this.filljson2avroForm(id, formdata));
    //console.log(this.json2avroRows());
  }

  fillHTMLExtractorForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "input_html_key": [{ value: formdata.input_html_key, disabled: true }],
      "output_data_key": [{ value: formdata.output_data_key, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewHTMLExtractorForm(id, formdata) {
    this.htmlextractorRows().push(this.fillHTMLExtractorForm(id, formdata));
  }

  fillavro2jsonForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "avro_data": [{ value: formdata.avro_data, disabled: true }],
      "json_data_key": [{value: formdata.json_data_key, disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewavro2jsonForm(id, formdata) {
    this.avro2jsonRows().push(this.fillavro2jsonForm(id, formdata));
  }
  fillExtract2ArrayForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "list_object_key": [{value: formdata.list_object_key, disabled: true }],
      "extraction_key":  [{value: "["+this.helperService.objectToStringConverter("Array", formdata.extraction_key)+"]", disabled: true }],
      "array_collection_key": [{value: "["+this.helperService.objectToStringConverter("Array", formdata.array_collection_key)+"]", disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewExtract2ArrayForm(id, formdata) {
    this.extract2ArrayRows().push(this.fillExtract2ArrayForm(id, formdata));
  }

  addNewExtract2ArrayForm(id, isMute) {
    this.extract2ArrayRows().push(this.extract2ArrayForm(id, isMute));
  }
  extract2ArrayForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "list_object_key": '',
      "extraction_key": [],
      "array_collection_key":[],
      "isMute": isMute,
      "id": id
    })
  }


  addDocunderstandingQuestionFormValue(data): UntypedFormGroup {
    return this._formBuilder.group({
      'docunderstanding_question': new UntypedFormControl({ value: data[0], disabled: true }),
      'docunderstanding_attribute': new UntypedFormControl({ value: data[1], disabled: true })
    })
  }

  addDocunderstandingQuestionForm(): UntypedFormGroup {
    return this._formBuilder.group({
      'docunderstanding_question': new UntypedFormControl({ value: "", disabled: true }),
      'docunderstanding_attribute': new UntypedFormControl({ value: "", disabled: true })
    })
  }

  fillDocUnderstandingForm(id, formdata): UntypedFormGroup {
    let doc_question_raw = this.docunderstandingRows().controls['questions'] = this._formBuilder.array(formdata.questions.map(form => {
      const group = this.addDocunderstandingQuestionFormValue(form);
      // group.patchValue(form);
      return group;
    }));

    return this._formBuilder.group({
      "text_key": [{ value: formdata.text_key, disabled: true }],
      "questions": doc_question_raw,
      "output_key": [{ value: formdata.output_key, disabled: true }],
      "id": id
    })
  }

  fillNewDocUnderstandingForm(id, formdata) {
    this.docunderstandingRows().push(this.fillDocUnderstandingForm(id, formdata));
  }

  addImgunderstandingQuestionFormValue(data): UntypedFormGroup {
    return this._formBuilder.group({
      'imgunderstanding_question': new UntypedFormControl({ value: data[0], disabled: true }),
      'imgunderstanding_attribute': new UntypedFormControl({ value: data[1], disabled: true }),
    })
  }

  addImgunderstandingQuestionForm(): UntypedFormGroup {
    return this._formBuilder.group({
      'imgunderstanding_question': new UntypedFormControl({ value: '', disabled: true }),
      'imgunderstanding_attribute': new UntypedFormControl({ value: '', disabled: true }),
    })
  }

  fillImgUnderstandingForm(id, formdata): UntypedFormGroup {
    let img_question_raw = this.imgunderstandingRows().controls['questions'] = this._formBuilder.array(formdata.questions.map(form => {
      const group = this.addImgunderstandingQuestionFormValue(form);
      // group.patchValue(form);
      return group;
    }));

    return this._formBuilder.group({
      "img_key": [{value: formdata.img_key,disabled: true }],
      "questions": img_question_raw,
      "output_key": [{ value : formdata.output_key,disabled: true }],
      "isMute": formdata.isMute,
      "id": id
    })
  }

  fillNewImgUnderstandingForm(id, formdata) {
    this.imgunderstandingRows().push(this.fillImgUnderstandingForm(id, formdata));
  }

  filterForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      conditional_statement: [""],
      id: id,
    })
  }
  docunderstandingOperationRow(empIndex: number): UntypedFormArray {
    return this.docunderstandingRows().at(empIndex).get('questions') as UntypedFormArray;
  };

  imgunderstandingOperationRow(empIndex: number): UntypedFormArray {
    return this.imgunderstandingRows().at(empIndex).get('questions') as UntypedFormArray;
  }

  fillDl2arrayForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      "dl_key": [{ value: formdata.dl_key, disabled: true }],
      "delimiter": [{ value: this.helperService.replaceDoubleToSingleBackSlash(formdata.delimiter), disabled: true }],
      "id": id
    })
  }

  fillNewDl2arrayForm(id, formdata) {
    this.dl2arrayRows().push(this.fillDl2arrayForm(id, formdata));
  }

  fillFilterForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      conditional_statement: [{ value: formdata.conditional_statement, disabled: true }],
      id: id,
    })
  }

  addNewFilterForm(id) {
    this.filterRows().push(this.filterForm(id));
  }

  fillNewFilterForm(id, formdata) {
    this.filterRows().push(this.fillFilterForm(id, formdata));
  }

  fillFilterEndsForm(id, formdata): UntypedFormGroup {
    return this._formBuilder.group({
      id: id,
    })
  }

  filterEndsForm(id): UntypedFormGroup {
    return this._formBuilder.group({
      id: id,
    })
  }

  addNewFilterEndsForm(id) {
    this.filterEndsRows().push(this.filterEndsForm(id));
  }

  fillNewFilterEndsForm(id, formdata) {
    this.filterEndsRows().push(this.fillFilterEndsForm(id, formdata));
  }

  validateSleetTime(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  validateDateAnalytics(event) {
    let value = event.target.value;
    return (((event.key >= '0' && event.key <= '9') && (value <= 12)) || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  fillDLIngestionForm(id, formdata): UntypedFormGroup {
    let primary_key;
    if (formdata.primary_key == undefined || formdata.primary_key == "" || formdata.primary_key == null) {
      primary_key = "";
    } else {
      primary_key = formdata.primary_key.split("%")[1];
    }
    let index_name = formdata.index_name.replace(new RegExp("bizintel360-", "g"), "");
    return this._formBuilder.group({
      "version": [{ value: formdata.verion, disabled: true }],
      "dlake_host": "",
      "dlake_port": "",
      "dlusername": "",
      "dlpassword": "",
      "dl_ca_certs_path": "",
      "index_name": [{ value: index_name, disabled: true }],
      "action_type": [{ value: formdata.action_type, disabled: true }],
      "primary_key": [{ value: primary_key, disabled: true }],
      "refresh_type": "True",
      "request_timeout_sec": 200,
      "indexing_type": [{ value: formdata.indexing_type, disabled: true }],
      "max_retries": 10,
      "chunk_size": 500,
      "thread_count": 4,
      "queue_size": 4,
      id: id,
    })
  }
  fillDlsearchForm(id, formdata): UntypedFormGroup {
    let index_name = formdata.dlsearch_index_name.replace(new RegExp("bizintel360-", "g"), "");
    // if(formdata.password != undefined && formdata.password.includes("gAAAA")){
    //   formdata.password =  formdata.password ? await this.helperService.decrypt(formdata.password):"";
    // }
    return this._formBuilder.group({
      "version": [{ value: formdata.version.dlversion, disabled: true }],
      "dlsearch_host": "",
      "dlsearch_port": "",
      "dlsearch_username": "",
      "dlsearch_password": "",
      "dlsearch_ca_certs_path": "",
      "dlsearch_index_name": [{ value: index_name, disabled: true }],
      "dlsearch_scroll": [{ value: formdata.dlsearch_scroll ? formdata.dlsearch_scroll : "2m", disabled: true }],
      "dlsearch_timeout": [{ value: formdata.dlsearch_timeout ? formdata.dlsearch_timeout : "2m", disabled: true }],
      "dlsearch_batch_size": [{ value: formdata.dlsearch_batch_size ? formdata.dlsearch_batch_size : 1000, disabled: true }],
      "dlsearch_body": [{ value: formdata.dlsearch_body, disabled: true }],
      "id": id,
    })
  }

  fillNewDlsearchForm(id, formdata) {
    this.dlsearchRows().push(this.fillDlsearchForm(id, formdata));
    var index = -1;
    var filteredObj = this.dlsearchRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });

  }
  fillNewDLIngestionForm(id, formdata) {
    this.dlIngestionRows().push(this.fillDLIngestionForm(id, formdata));
    var index = -1;
    var filteredObj = this.dlIngestionRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    let dlVersion = this.verisonListDLO.filter(function (entry) { return entry.dlversion === formdata.version.dlversion });
    (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['version'].setValue(dlVersion[0]);
    let value = (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['version'].value.dlversion;
    // this.getStorage().then((res) => {
    //   let payload = {
    //     "dlversion": value
    //   }
    //   this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
    //     (data) => {
    //       (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_host'].setValue(data.data.dlhost_name);
    //       (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlpassword'].setValue(data.data.dlpsw);
    //       (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_port'].setValue(+(data.data.dlport));
    //       (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlusername'].setValue(data.data.dlusername);
    //       (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dl_ca_certs_path'].setValue(data.data.dl_ca_certs_path);
    //     },
    //     (error) => {
    //       //console.log(error);
    //     }
    //   );
    // })
  }
  async getDlVersionDLO() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        // this.backendService.GetAPICall('getDLVersions', { op_type: 'ingestion' }, res.token).subscribe(
        this.backendService.PostAPICall('getDLVersions', { op_type: 'ingestion' }, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }
  onChangeToggleButton(event, index) {
    this.pdfLocationToggleValue= event.value;
    (<UntypedFormGroup>this.pdfextractorRows().at(index)).controls['pdfLocationToggle'].setValue(this.pdfLocationToggleValue); 
  }


  
  onChangeGetDlversion(event, index) {
    let value = event.value.dlversion
    //console.log(event)
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": value
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
          let data=JSON.parse(records);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlpassword'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlusername'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dl_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });
        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }
  openForm(item, id) {
    for (let item of this.finalBlocks) {
      if (id == item.id) {
        item.isValid = true;
        break;
      }
    }
    this.selectedOperationId = id;
    // this.hideAllOpsForms();
    this.isDataTypeFromEnabled = false;
    this.isBase64decodingFromEnabled = false;
    this.isBase64encodingFromEnabled = false;
    this.isData_extractorFromEnabled = false;
    this.isTitlecaseFromEnabled = false;
    this.isUppercaseFromEnabled = false;
    this.isLowercaseFromEnabled = false;
    this.isTrimFromEnabled = false;
    this.isAppendFromEnabled = false;
    this.isJSON_to_XMLFromEnabled = false;
    this.isXML_to_JSONFromEnabled = false;
    this.isGeneratesequenceFromEnabled = false;
    this.isJson2stringFromEnabled = false;
    this.isString2jsonFromEnabled = false;
    this.isToplevelFromEnabled = false;
    this.isDatetimestampFromEnabled = false;
    this.isRepeatfirstrowFromEnabled = false;
    this.isZipfileinbase64FromEnabled = false;
    this.isArraycountFromEnabled = false;
    this.isPdfextractorFormEnabled = false;
    this.isFileextractorFormEnabled = false;
    this.isGorkPatternFormEnabled = false;
    this.isRawSentenceGeneratorFormEnabled = false
    this.isTimeUnitsFormEnabled = false;
    this.isDataChunkingFormEnabled = false;
    this.isJson2avroFormEnabled = false;
    this.isHTMLExtractorFormEnabled = false;
    this.isAvro2jsonFormEnabled = false;
    this.isExtract2ArrayFormEnabled = false;
    this.isJSON2dlFromEnabled = false;
    this.isDl2jsonFromEnabled = false;
    this.isPivotFromEnabled = false;
    this.isUnPivotFromEnabled = false;
    this.isDataaggregationFromEnabled = false;
    this.chopFormEnabled = false;
    this.singleline2tupleFormEnabled = false;
    this.tuple2singlelineFormEnabled = false;
    this.isDl2arrayFormEnabled = false;

    this.isemailFromEnabled = false
    this.isfileFromEnabled = false
    this.isdropeventsstartswithFromEnabled = false;
    this.isdropalleventvaluesFromEnabled = false;
    this.iseliminateFromEnabled = false;
    this.isroundFromEnabled = false;
    this.iscalculaterFromEnabled = false;
    this.isdateanalyticsFromEnabled = false;
    this.issubstituteFromEnabled = false;
    this.isstripFromEnabled = false;
    this.issubstringFromEnabled = false;
    this.isrenameFromEnabled = false;
    this.ispycodeFromEnabled = false;
    this.isaiopsFromEnabled = false;
    this.isjsonFormEnabled = false;
    this.isrestapiFormEnabled = false;

    this.issleepFromEnabled = false;
    this.isPostgresFromEnabled = false
    this.isReplacingvalueFromEnabled = false
    this.isAnalyticsFromEnabled = false
    this.isDataextractorEnabled = false
    this.isjdbcoutputFromEnabled = false;
    this.isfilterFromEnabled = false;
    this.isEncodedecodeFromEnabled = false;
    this.isDLIngestionFormEnabled = false;
    this.isDlsearchFormEnabled = false;
    this.isDocunderstandingFromEnabled = false;
    this.isImgunderstandingFromEnabled = false;
    this.isfilterEndsFromEnabled = false;
    if (item == 'Data types') {
      this.isDataTypeFromEnabled = true;
    } else if (item == 'Append') {
      this.isAppendFromEnabled = true;
    } else if (item == 'Titlecase') {
      this.isTitlecaseFromEnabled = true;
    } else if (item == 'Uppercase') {
      this.isUppercaseFromEnabled = true;
    } else if (item == 'Lowercase') {
      this.isLowercaseFromEnabled = true;
    } else if (item == 'Data extractor') {
      this.isData_extractorFromEnabled = true;
    } else if (item == 'Trim') {
      this.isTrimFromEnabled = true;
    } else if (item == 'Base64 encoding') {
      this.isBase64encodingFromEnabled = true;
    } else if (item == 'Base64 decoding') {
      this.isBase64decodingFromEnabled = true;
    } else if (item == 'JSON to XML') {
      this.isJSON_to_XMLFromEnabled = true;
    } else if (item == 'XML to JSON') {
      this.isXML_to_JSONFromEnabled = true;
    } else if (item == 'Repeat First Row Values') {
      this.isRepeatfirstrowFromEnabled = true;
    } else if (item == 'JSON to delimiter') {
      this.isJSON2dlFromEnabled = true
    } else if (item == 'Delimiter to JSON') {
      this.isDl2jsonFromEnabled = true
    } else if (item == 'JSON to String') {
      this.isJson2stringFromEnabled = true;
    } else if (item == 'String to JSON') {
      this.isString2jsonFromEnabled = true;
    } else if (item == 'Generate Array Sequence Number') {
      this.isGeneratesequenceFromEnabled = true;
    } else if (item == 'Send Keys Top of Root') {
      this.isToplevelFromEnabled = true;
    } else if (item == 'Today Timestamp') {
      this.isDatetimestampFromEnabled = true;
    } else if (item == 'Data aggregation') {
      this.isDataaggregationFromEnabled = true
    } else if (item == 'Pivot') {
      this.isPivotFromEnabled = true
    } else if (item == 'Unpivot') {
      this.isUnPivotFromEnabled = true
    } else if (item == 'Single Line to Multiline') {
      this.chopFormEnabled = true
    } else if (item == 'Single Line to Tuple') {
      this.singleline2tupleFormEnabled = true
    } else if (item == 'Tuple to Single Line') {
      this.tuple2singlelineFormEnabled = true
    } else if (item == 'Rename') {
      this.isrenameFromEnabled = true
    } else if (item == 'Drop all events to start with') {
      this.isdropeventsstartswithFromEnabled = true
    } else if (item == 'Eliminate') {
      this.iseliminateFromEnabled = true
    } else if (item == 'Drop all events for value') {
      this.isdropalleventvaluesFromEnabled = true
    } else if (item == 'Calculator') {
      this.iscalculaterFromEnabled = true
    } else if (item == 'Date Analytics') {
      this.isdateanalyticsFromEnabled = true
    } else if (item == 'Substitute') {
      this.issubstituteFromEnabled = true
    } else if (item == 'Strip') {
      this.isstripFromEnabled = true
    } else if (item == 'Substring') {
      this.issubstringFromEnabled = true
    } else if (item == 'Round') {
      this.isroundFromEnabled = true
    } else if (item == 'API') {
      this.isrestapiFormEnabled = true
      // setTimeout(()=>{this.setHeight(id)},0)
    } else if (item == 'Sleep time') {
      this.issleepFromEnabled = true
    } else if (item == 'Python') {
      this.ispycodeFromEnabled = true
    }else if (item == 'AI Operation') {
      this.isaiopsFromEnabled = true
    } else if (item == 'Email') {
      this.isemailFromEnabled = true
    } else if (item == 'JSON') {
      this.isjsonFormEnabled = true
    } else if (item == 'File') {
      this.isfileFromEnabled = true
    } else if (item == 'Database') {
      this.isjdbcoutputFromEnabled = true;
    } else if (item == 'Filter') {
      this.isfilterFromEnabled = true;
    } else if (item == 'Encode Decode') {
      this.isEncodedecodeFromEnabled = true;
    } else if (item == 'DL Ingestion') {
      this.isDLIngestionFormEnabled = true;
    } else if (item == 'DataLake Search') {
      this.isDlsearchFormEnabled = true;
    } else if (item == 'Zipfile in Base64') {
      this.isZipfileinbase64FromEnabled = true;
    } else if (item == 'Array Count') {
      this.isArraycountFromEnabled = true;
    } else if (item == 'Delimiter to Array') {
      this.isDl2arrayFormEnabled = true;
    } else if (item == 'PDF Extractor') {
      this.isPdfextractorFormEnabled = true;
    } else if (item == 'File Extractor') {
      this.isFileextractorFormEnabled = true;
    } else if (item == 'Document Understanding') {
      this.isDocunderstandingFromEnabled = true;
    }else if (item == 'Image Understanding') {
      this.isImgunderstandingFromEnabled = true;
    } else if (item == 'Filter Ends') {
      this.isfilterEndsFromEnabled = true;
    } else if (item == 'Grok Pattern') {
      this.isGorkPatternFormEnabled = true;
    } else if (item == 'Raw Sentence Generator') {
      this.isRawSentenceGeneratorFormEnabled = true;
    } else if (item == 'Time Units') {
      this.isTimeUnitsFormEnabled = true;
    } else if (item == 'Data Chunking') {
      this.isDataChunkingFormEnabled = true;
    }else if (item == 'JSON to AVRO') {
      this.isJson2avroFormEnabled = true;
    } else if (item == 'HTML Extractor') {
      this.isHTMLExtractorFormEnabled = true;
    }else if (item == 'AVRO to JSON') {
      this.isAvro2jsonFormEnabled = true;
    }else if (item == 'Extract to Array') {
      this.isExtract2ArrayFormEnabled = true;
    }
  }

  setHeight(id){
    let url=document.getElementById(`rest_api_url${id}`);
    url.style.height=url?.scrollHeight+'px';
  }

  hideAllOpsForms() {
    this.isDataTypeFromEnabled = false;
    this.isBase64decodingFromEnabled = false;
    this.isBase64encodingFromEnabled = false;
    this.isData_extractorFromEnabled = false;
    this.isTitlecaseFromEnabled = false;
    this.isUppercaseFromEnabled = false;
    this.isLowercaseFromEnabled = false;
    this.isTrimFromEnabled = false;
    this.isAppendFromEnabled = false;
    this.isJSON_to_XMLFromEnabled = false
    this.isXML_to_JSONFromEnabled = false;
    this.isGeneratesequenceFromEnabled = false;
    this.isJson2stringFromEnabled = false;
    this.isString2jsonFromEnabled = false;
    this.isToplevelFromEnabled = false;
    this.isDatetimestampFromEnabled = false;
    this.isRepeatfirstrowFromEnabled = false;
    this.isZipfileinbase64FromEnabled = false;
    this.isPdfextractorFormEnabled = false;
    this.isFileextractorFormEnabled = false;

    this.isJSON2dlFromEnabled = false;
    this.isDl2jsonFromEnabled = false;
    this.isPivotFromEnabled = false;
    this.isUnPivotFromEnabled = false;
    this.isDataaggregationFromEnabled = false;
    this.chopFormEnabled = false;
    this.singleline2tupleFormEnabled = false;
    this.tuple2singlelineFormEnabled = false;
    this.isDl2arrayFormEnabled = false;

    this.isemailFromEnabled = false
    this.isfileFromEnabled = false
    this.isdropeventsstartswithFromEnabled = false;
    this.isdropalleventvaluesFromEnabled = false;
    this.iseliminateFromEnabled = false;
    this.isroundFromEnabled = false;
    this.iscalculaterFromEnabled = false;
    this.isdateanalyticsFromEnabled = false;
    this.issubstituteFromEnabled = false;
    this.isstripFromEnabled = false;
    this.issubstringFromEnabled = false;
    this.isrenameFromEnabled = false;
    this.ispycodeFromEnabled = false;
    this.isaiopsFromEnabled = false;

    this.isPostgresFromEnabled = false
    this.isReplacingvalueFromEnabled = false
    this.isAnalyticsFromEnabled = false
    this.isDataextractorEnabled = false
    this.isEncodedecodeFromEnabled = false;
    this.isDocunderstandingFromEnabled = false;
    this.isImgunderstandingFromEnabled = false;
    this.isfilterEndsFromEnabled = false;
    this.isRawSentenceGeneratorFormEnabled = false;
    this.isTimeUnitsFormEnabled = false;
    this.isDataChunkingFormEnabled = false;
    this.isJson2avroFormEnabled = false;
    this.isHTMLExtractorFormEnabled = false;
    this.isAvro2jsonFormEnabled = false;
    this.isExtract2ArrayFormEnabled = false;
  }

  splitArr(arr, size) {
    let newArr = [];
    for (let i = 0; i < arr.length; i += size) {
      let arr2 = arr.slice(i, i + size);
      // if(i%2 !== 0){
      //   arr2.reverse();
      // }
      newArr.push(arr2);
    }
    return newArr;
  }


  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }

 async getDataOperations(key, dataOperations) {
    for (let row of key) {
      if (row.includes('bizdata_ops_append')) {
        // let count;
        let formData = dataOperations[row]
        this.fillNewAppendForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Append',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_append' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_datatypes')) {
        let formData = dataOperations[row]
        this.fillNewDataTypesForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Data types',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_datatypes' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_titlecase')) {
        let formData = dataOperations[row]
        this.fillNewTitlecaseForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Titlecase',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_titlecase' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_uppercase')) {
        let formData = dataOperations[row]
        this.fillNewUppercaseForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Uppercase',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_uppercase' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_lowercase')) {
        let formData = dataOperations[row]
        this.fillNewLowercaseForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Lowercase',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_lowercase' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dataextractor')) {
        let formData = dataOperations[row]
        this.fillNewDataExtractorForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Data extractor',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dataextractor' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_base64decoding')) {
        let formData = dataOperations[row]
        this.fillNewBase64decodingForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Base64 decoding',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_base64decoding' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_trim')) {
        let formData = dataOperations[row]
        this.fillNewTrimForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Trim',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_trim' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_json2string')) {
        let formData = dataOperations[row]
        this.fillNewJson2stringForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'JSON to String',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_json2string' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_string2json')) {
        let formData = dataOperations[row]
        this.fillNewString2jsonForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'String to JSON',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_string2json' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_generatesequence')) {
        let formData = dataOperations[row]
        this.fillNewGeneratesequenceForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Generate Array Sequence Number',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_generatesequence' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_toplevel')) {
        let formData = dataOperations[row]
        this.fillNewToplevelForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Send Keys Top of Root',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_toplevel' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_datetimestamp')) {
        let formData = dataOperations[row]
        this.fillNewDatetimestampForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Today Timestamp',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_datetimestamp' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_base64encoding')) {
        let formData = dataOperations[row]
        this.fillNewBase64encodingForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Base64 encoding',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_base64encoding' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_jsontoxml')) {
        let formData = dataOperations[row]
        this.fillNewJSONtoXMLForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'JSON to XML',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_jsontoxml' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_repeatfirstrow')) {
        let formData = dataOperations[row]
        this.fillNewRepeatfirstrowForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Repeat First Row Values',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_repeatfirstrow' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_xmltojson')) {
        let formData = dataOperations[row]
        this.fillNewXmltojsonForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'XML to JSON',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_xmltojson' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dl2json')) {
        let formData = dataOperations[row]
        this.fillNewDl2jsonForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Delimiter to JSON',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dl2json' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_json2dl')) {
        let formData = dataOperations[row]
        this.fillNewJson2dlForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'JSON to delimiter',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_json2dl' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_singletomultiline')) {
        let formData = dataOperations[row]
        this.fillNewChopForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Single Line to Multiline',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_singletomultiline' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dataaggregation')) {
        let formData = dataOperations[row]
        this.fillNewDataaggregationForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Data aggregation',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dataaggregation' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_pivot')) {
        let formData = dataOperations[row]
        this.fillNewPivotForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Pivot',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_pivot' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_unpivot')) {
        let formData = dataOperations[row]
        this.fillNewUnpivotForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Unpivot',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_unpivot' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_singleline2tuple')) {
        let formData = dataOperations[row]
        this.fillNewSingleline2tupleForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Single Line to Tuple',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_singleline2tuple' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_tuple2singleline')) {
        let formData = dataOperations[row]
        this.fillNewTuple2singlelineForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Tuple to Single Line',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_tuple2singleline' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_rename')) {
        let formData = dataOperations[row]
        //console.log(formData);
        this.fillNewRenameForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Rename',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_rename' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dropeventsstartswith')) {
        let formData = dataOperations[row]
        this.fillNewDropeventsstartswithForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Drop all events to start with',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dropeventsstartswith' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_eliminate')) {
        let formData = dataOperations[row]
        this.fillNewEliminateForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Eliminate',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_eliminate' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dropalleventvalues')) {
        let formData = dataOperations[row]
        this.fillNewDropalleventvaluesForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Drop all events for value',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dropalleventvalues' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_calculator')) {
        let formData = dataOperations[row]
        this.fillNewCalculaterForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Calculator',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_calculator' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dateanalytics')) {
        let formData = dataOperations[row]
        this.fillNewDateanalyticsForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Date Analytics',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dateanalytics' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_substitute')) {
        let formData = dataOperations[row]
        this.fillNewSubstituteForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Substitute',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_substitute' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_strip')) {
        let formData = dataOperations[row]
        this.fillNewStripForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Strip',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_strip' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_substring')) {
        let formData = dataOperations[row]
        this.fillNewSubstringForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Substring',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_substring' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_round')) {
        let formData = dataOperations[row]
        this.fillNewRoundForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Round',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_round' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_restapi')) {
        let formData = dataOperations[row]
        await this.fillNewRestapiForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'API',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_restapi' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_sleeptime')) {
        let formData = dataOperations[row]
        this.fillNewSleepForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Sleep time',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_sleeptime' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_pycode')) {
        let formData = dataOperations[row]
        this.fillNewPycodeForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Python',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_pycode' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_aiops')) {
        let formData = dataOperations[row]
        this.fillNewaiOpsForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'AI Operation',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_aiops' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_email')) {
        let formData = dataOperations[row]
        await this.fillNewEmailForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Email',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_email' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      console.log(row)
      if (row.includes('bizdata_ops_jdbcoutput')) {
        let formData = dataOperations[row]
        await this.fillNewJdbcoutputForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Database',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_jdbcoutput' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dlakeingestion')) {
        let formData = dataOperations[row];
        this.fillNewDLIngestionForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'DL Ingestion',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dlakeingestion' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_bizintel360ingestion')) {
        let formData = dataOperations[row];
        this.fillNewDLIngestionForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'DL Ingestion',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_bizintel360ingestion' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dlsearch')) {
        let formData = dataOperations[row]
        this.fillNewDlsearchForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'DataLake Search',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dlsearch' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_bizintel360search')) {
        let formData = dataOperations[row]
        this.fillNewDlsearchForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'DataLake Search',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_bizintel360search' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_filter') && !row.includes('bizdata_ops_filterends')) {
        let formData = dataOperations[row]
        this.fillNewFilterForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Filter',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_filter' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_filterends')) {
        let formData = dataOperations[row]
        this.fillNewFilterEndsForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Filter Ends',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_filterends' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_encodedecode')) {
        let formData = dataOperations[row]
        this.fillNewEncodedecodeForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Encode Decode',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_encodedecode' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_zipfileinbase64')) {
        let formData = dataOperations[row]
        this.fillNewZipfileinbase64Form(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Zipfile in Base64',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_zipfileinbase64' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_arraycount')) {
        let formData = dataOperations[row]
        this.fillNewArraycountForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Array Count',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_arraycount' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_dl2array')) {
        let formData = dataOperations[row]
        this.fillNewDl2arrayForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Delimiter to Array',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_dl2array' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_pdfextractor')) {
        let formData = dataOperations[row]
        this.fillNewPdfextractorForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'PDF Extractor',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_pdfextractor' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_fileextractor')) {
        let formData = dataOperations[row]
        this.fillNewFileextractorForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'File Extractor',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_fileextractor' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_docunderstanding')) {
        let formData = dataOperations[row]
        this.fillNewDocUnderstandingForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Document Understanding',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_docunderstanding' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_imgunderstanding')) {
        let formData = dataOperations[row]
        this.fillNewImgUnderstandingForm(formData.id, formData)
        let data = {
          id: formData.id,
          element_id: row == 'bizdata_ops_imgunderstanding' ? 'bizdata_ops_imgunderstanding_1' : row,
          keys: Object.keys(formData),
          title: 'Image Understanding',
          isValid: true,
          isMute: formData.hasOwnProperty('isMute') ? formData.isMute : false,
          count: row == 'bizdata_ops_imgunderstanding' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_grokpattern')) {
        let formData = dataOperations[row]
        this.fillNewGorkPatterForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Grok Pattern',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_grokpattern' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_rawsentencegenerator')) {
        let formData = dataOperations[row]
        this.fillNewRawSentenceGeneratorForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Raw Sentence Generator',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_rawsentencegenerator' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_timeunits')) {
        let formData = dataOperations[row]
        this.fillNewTimeUnitsForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Time Units',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_timeunits' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_datachunking')) {
        let formData = dataOperations[row]
        this.fillNewDataChunkingForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Data Chunking',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_datachunking' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
       if (row.includes('bizdata_ops_json2avro')) {
        let formData = dataOperations[row]
        this.fillNewjson2avroForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'JSON to AVRO',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_json2avro' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }

      if (row.includes('bizdata_ops_avro2json')) {
        let formData = dataOperations[row]
        this.fillNewavro2jsonForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'AVRO to JSON',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_avro2json' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }

      if (row.includes('bizdata_ops_htmlextractor')) {
        let formData = dataOperations[row]
        this.fillNewHTMLExtractorForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'HTML Extractor',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_htmlextractor' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      if (row.includes('bizdata_ops_extract2array')) {
        let formData = dataOperations[row]
        this.fillNewExtract2ArrayForm(formData.id, formData)
        let data = {
          id: formData.id,
          keys: Object.keys(formData),
          title: 'Extract to Array',
          isValid: true,
          isMute: formData?.isMute,
          count: row == 'bizdata_ops_extract2array' ? 1 : row.split("_")[3]
        }
        this.finalBlocks.push(data)
        this.blocks.push(data)
      }
      this.newBlocks = this.splitArr(this.finalBlocks, 3);
    }
  }

   getIntegrationDetails(id) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: (atob(id)),
      }
      this.backendService.PostAPICall('getIntBridgeDetails', payload, _storage.token).subscribe(
        async (data) => {
          this.integrationObj = data;
          this.source_name_for_webSocket = data.source_name
          this.helperService.closeLoader();
          this.summary.controls['bridge_name'].setValue(data.integration_bridge_name);
          this.summary.controls['bridge_description'].setValue(data.integration_bridge_description);
          let email = data.alert_emails;
          this.emails = email;
          let advance_settings = JSON.parse(atob(data.advance_settings));
          if (advance_settings.toggle == true) {
            this.summary.controls['toggle'].setValue(1);
            this.showAdvancedSettings = true;
          } else {
            this.summary.controls['toggle'].setValue(0);
            this.showAdvancedSettings = false;
          }
          this.summary.controls['sbs'].setValue(advance_settings.sbs);
          this.summary.controls['now'].setValue(advance_settings.now.toString());
          this.summary.controls['srwt'].setValue(advance_settings.srwt);
          this.summary.controls['logsize'].setValue(advance_settings.logs_size);

          this.bridge_source_type = data.source_type;
          this.bridge_target_type = data.target_type;
          let bridge_source_type = this.bridgeSourceType.filter(function (entry) { return entry.id == data.source_type });
          let bridge_target_type = this.bridgeTargetType.filter(function (entry) { return entry.id == data.target_type });
          this.dataSource.controls['bridge_source_type'].setValue(bridge_source_type[0].value);
          this.dataTarget.controls['bridge_target_type'].setValue(bridge_target_type[0].value);
          if(data.source_type == 2){
            this.sourceDatabaseAddFormControl();
          }else if(data.source_type == 3){
            this.sourceDatalakeAddFormControl();
          }else if(data.source_type == 4){
            this.sourceWebsocketAddFormControl();
          }else if(data.source_type == 5){
            this.sourceEmailAddFormControl();
          }
          if(data.target_type == 2){
            this.targetDatabaseAddFormControl();
          }else if(data.target_type == 3){
            this.targetDataLakeAddFormControl();
          }else if(data.target_type == 4){
            this.targetEmailAddFormControl();
          }


          // this.summary.controls['timertype'].setValue(data.timer_type);
          if (data.timer_type == "schedule") {
            this.scheduleval = true;
            this.timertypeval = 'schedule'
            this.summary.patchValue({ schedule: data.schedule });
            this.summary.controls['time_zone'].setValue(data.timezone);
          }
          if (data.timer_type == "interval") {
            this.scheduleval = false;
            this.timertypeval = 'interval'
            this.summary.patchValue({ interval: data.interval_in_seconds })
          }

          // this.timertypeval = data.timer_type;
          // ***************************
          // Data Process for Source
          // ***************************
          // let source_pp = JSON.parse(await this.helperService.decrypt(data.source_params));
          let source_pp;
          let source_params = await this.helperService.decryptpayload(data.source_params)
          await this.helperService.decryptpayload(JSON.parse(source_params)).then((decoRecords: any) => {
            source_params = JSON.parse(decoRecords);
            source_pp = JSON.parse(atob(source_params));
          })
          // let source_pp = JSON.parse(data.source_params);
          let source_postman_params: any;
          if (data.source_type == 1) {
            source_postman_params = source_pp.input.bizdata_rest;
            if (data.source_id == 0) {
              this.isNewSource = true;
              this.dataSource.patchValue({
                bridge_source: 'Create New',
              })
              this.dataSource.addControl('new_bridge_source', new UntypedFormControl("", [Validators.required]));
              this.dataSource.addControl('new_bridge_source_business_object', new UntypedFormControl("", [Validators.required]));
              this.dataSource.get('bridge_source').clearValidators();
              this.dataSource.get('bridge_source').updateValueAndValidity();
              const is_bridge_source_business_object = this.dataSource.contains('bridge_source_business_object');
              if (is_bridge_source_business_object) this.dataSource.removeControl('bridge_source_business_object');

              this.dataSource.controls['new_bridge_source'].setValue(data.source_name);
              this.dataSource.controls['new_bridge_source'].disable();
              this.dataSource.controls['new_bridge_source_business_object'].setValue(data.source_business_obj);
              this.dataSource.controls['new_bridge_source_business_object'].disable();
            } else {
              this.isNewSource = false;
              this.dataSource.patchValue({
                bridge_source: data.source_name,
              })
              this.dataSource.addControl('bridge_source_business_object', new UntypedFormControl("", [Validators.required]));
              const is_new_bridge_source = this.dataSource.contains('new_bridge_source');
              const is_new_bridge_source_business_object = this.dataSource.contains('new_bridge_source_business_object');
              if (is_new_bridge_source) this.dataSource.removeControl('new_bridge_source');
              if (is_new_bridge_source_business_object) this.dataSource.removeControl('new_bridge_source_business_object');
            }

            // this.dataSource.controls['bridge_source'].setValue(data.source_id);
            // this.dataSource.controls['bridge_source'].setValue(bridge_source[0].product_name);

            let bridge_source_endpoint_method = this.methodList.filter(function (entry) { return entry.id == source_postman_params.endpoint_method.id });
            this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_source_endpoint_method[0].method);
            let bridge_source_endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === source_postman_params.authentication_type.id });
            this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_source_endpoint_authentication_type[0].type);


            if (source_postman_params.hasOwnProperty('body_type')) {
              if (source_postman_params.body_type != "" && source_postman_params.body_type != undefined) {
                this.dataSource.controls['bridge_source_body_type'].setValue(source_postman_params.body_type);
                if (source_postman_params.body_type == 'JSON') {
                  if (source_postman_params.endpoint_body_raw != '' && source_postman_params.endpoint_body_raw != undefined) {
                    this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(JSON.stringify(source_postman_params.endpoint_body_raw));
                  } else {
                    this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(source_postman_params.endpoint_body_raw);
                  }
                } else {
                  this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(source_postman_params.endpoint_body_raw);
                }
              }
            }
            if (JSON.stringify(source_postman_params.endpoint_body_raw) === '{}') {
              this.sourcebodyFlag = false;
            }
            this.dataSource.controls['pre_request_script'].setValue(source_postman_params.pre_request_script?await this.helperService.decrypt(source_postman_params.pre_request_script):"");
            this.dataSource.controls['bridge_source_endpoint_url'].setValue(source_postman_params.endpoint_url);
            let source_api=document.getElementById('ib_details_source_endpoint_request_url');
            source_api.style.height = source_api.scrollHeight + 'px';

            let bridge_source_endpoint_params_raw_array = this.dataSource.get('bridge_source_endpoint_params_raw') as UntypedFormArray;
            if (source_postman_params.endpoint_params_raw.length > 0) {
              for (var row of source_postman_params.endpoint_params_raw) {
                bridge_source_endpoint_params_raw_array.push(this.addSourceValueParams(row));
              }
            } else {
              this.addSourceParams(0);
            }

            let bridge_source_endpoint_headers_raw_array = this.dataSource.get('bridge_source_endpoint_headers') as UntypedFormArray;
            if (source_postman_params.endpoint_headers.length > 0) {
              for (var row of source_postman_params.endpoint_headers) {
                bridge_source_endpoint_headers_raw_array.push(this.addSourceValueHeaders(row));
              }
            } else {
              this.sourceheadersFlag = false;
              this.addSourceheaders(0);
            }

            if (bridge_source_endpoint_authentication_type[0].id == 3) {
              // Bearer Token
              this.dataSource.addControl('bridge_source_authentication_token', new UntypedFormControl(""));
              this.dataSource.controls['bridge_source_authentication_token'].setValue(source_postman_params.authentication_token);
              this.selectSourceType = 3;
            } else if (bridge_source_endpoint_authentication_type[0].id == 4) {
              // Basic Auth
              this.dataSource.addControl('bridge_source_authentication_username', new UntypedFormControl(""));
              this.dataSource.addControl('bridge_source_authentication_password', new UntypedFormControl(""));
              this.dataSource.controls['bridge_source_authentication_username'].setValue(source_postman_params.username);
              this.dataSource.controls['bridge_source_authentication_username'].disable();
              this.dataSource.controls['bridge_source_authentication_password'].setValue(source_postman_params.password?await this.helperService.decrypt(source_postman_params.password):"");
              this.dataSource.controls['bridge_source_authentication_password'].disable();
              this.selectSourceType = 4;
            } else if (bridge_source_endpoint_authentication_type[0].id == 6) {
              // OAuth 2.0
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
              this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(source_postman_params.refresh_token_endpoint_url?await this.helperService.decrypt(source_postman_params.refresh_token_endpoint_url):"");
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].disable();
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(source_postman_params.refresh_token_endpoint_headers));
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].disable();
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(source_postman_params.refresh_token_endpoint_params));
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].disable();
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_body'].setValue(source_postman_params.refresh_token_endpoint_body? (await this.helperService.decrypt(source_postman_params.refresh_token_endpoint_body)):"");
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_body'].disable();
              // this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].setValue(source_postman_params.refresh_token_endpoint_params);
              let bridge_source_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === source_postman_params.refresh_token_endpoint_method.id });
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].setValue(bridge_source_refresh_token_endpoint_method[0].method);
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].disable();
              this.selectSourceType = 6;
            }
            this.bridge_summary_source_name = this.integrationObj.source_name;
            this.bridge_summary_source_bobj = this.integrationObj.source_business_obj;
          } else if (data.source_type == 2) {
            this.dataSource.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
            // this.dataSource.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('db_version', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('tuple_key', new UntypedFormControl("", []));
            this.dataSource.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('port_number', new UntypedFormControl("3306", [Validators.required]));
            this.dataSource.addControl('schema_name', new UntypedFormControl("", []));
            // this.dataSource.addControl('batch_size', new UntypedFormControl("1000", []));
            this.dataSource.addControl('jdbc_driver', new UntypedFormControl("", []));
            this.dataSource.addControl('jdbc_string', new UntypedFormControl("", []));
            this.dataSource.addControl('jdbc_jar_file', new UntypedFormControl("", []));
            this.dataSource.addControl('username', new UntypedFormControl("", []));
            this.dataSource.addControl('password', new UntypedFormControl("", []));
            this.dataSource.addControl('query', new UntypedFormControl("", []));
            this.dataSource.addControl('status', new UntypedFormControl("", []));
            this.dataSource.addControl('response', new UntypedFormControl("", []));
            // this.dataSource.addControl('multiline', new UntypedFormControl("", []));
            // this.dataSource.addControl('unique_key', new UntypedFormControl("", []));
            this.dataSource.addControl('chunks_size', new UntypedFormControl("", []));
            this.dataSource.addControl('response_parameter', new UntypedFormControl("", []));
            // let query = this.helperService.objectToStringConverter('Array', source_pp.bizdata_ops_jdbcsource.query);
            // let tuple_key = JSON.parse(this.helperService.objectToStringConverter('Array', source_pp.bizdata_ops_jdbcsource.tuple_key));

            this.dataSource.controls['host_ip'].setValue(source_pp.bizdata_ops_jdbcsource.host_ip);
            this.dataSource.controls['jdbc_jar_file'].setValue(source_pp.bizdata_ops_jdbcsource.jdbc_jar_file);
            this.dataSource.controls['jdbc_driver'].setValue(source_pp.bizdata_ops_jdbcsource.jdbc_driver);
            this.dataSource.controls['jdbc_string'].setValue(source_pp.bizdata_ops_jdbcsource.jdbc_string);
            this.dataSource.controls['password'].setValue(await this.helperService.decrypt(source_pp.bizdata_ops_jdbcsource.password));
            this.dataSource.controls['port_number'].setValue(source_pp.bizdata_ops_jdbcsource.port_number);
            this.dataSource.controls['pre_request_script'].setValue(decodeURIComponent(source_pp.bizdata_ops_jdbcsource.pre_request_script));
            this.dataSource.controls['query'].setValue(source_pp.bizdata_ops_jdbcsource.query);
            this.dataSource.controls['response'].setValue(source_pp.bizdata_ops_jdbcsource.response);
            this.dataSource.controls['schema_name'].setValue(source_pp.bizdata_ops_jdbcsource.schema_name);
            this.dataSource.controls['status'].setValue(source_pp.bizdata_ops_jdbcsource.status);
            this.dataSource.controls['storage_name'].setValue(source_pp.bizdata_ops_jdbcsource.storage_name.storage_name);
            // this.dataSource.controls['db_version_list'].setValue(source_pp.bizdata_ops_jdbcsource.db_version_list);
            this.dataSource.controls['db_version'].setValue(source_pp.bizdata_ops_jdbcsource.db_version.dbversion);
            // this.dataSource.controls['multiline'].setValue(source_pp.bizdata_ops_jdbcsource.multiline);
            // this.dataSource.controls['unique_key'].setValue(source_pp.bizdata_ops_jdbcsource.unique_key);
            this.dataSource.controls['response_parameter'].setValue(source_pp.bizdata_ops_jdbcsource.response_parameter);
            // this.dataSource.controls['tuple_key'].setValue(tuple_key);
            this.dataSource.controls['chunks_size'].setValue(source_pp.bizdata_ops_jdbcsource.chunks_size);
            this.dataSource.controls['username'].setValue(source_pp.bizdata_ops_jdbcsource.username);
            this.dataSource.controls['host_ip'].disable();
            this.dataSource.controls['jdbc_jar_file'].disable();
            this.dataSource.controls['jdbc_driver'].disable();
            this.dataSource.controls['jdbc_string'].disable();
            this.dataSource.controls['password'].disable();
            this.dataSource.controls['port_number'].disable();
            this.dataSource.controls['pre_request_script'].disable();
            this.dataSource.controls['query'].disable();
            this.dataSource.controls['response'].disable();
            this.dataSource.controls['schema_name'].disable();
            this.dataSource.controls['status'].disable();
            this.dataSource.controls['storage_name'].disable();
            this.dataSource.controls['db_version'].disable();
            // this.dataSource.controls['multiline'].disable();
            // this.dataSource.controls['unique_key'].disable();
            this.dataSource.controls['response_parameter'].disable();
            // this.dataSource.controls['tuple_key'].disable();
            this.dataSource.controls['username'].disable();
            this.dataSource.controls['chunks_size'].disable();
            this.bridge_summary_source_name = source_pp.bizdata_ops_jdbcsource.storage_name.storage_name;
            this.bridge_summary_source_bobj = "-";
            this.isjdbcSourceFromEnabled=true;

          } else if (data.source_type == 3) {
            let dlkey = Object.keys(source_pp);
            this.dataSource.addControl('dlsource_host', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_port', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_username', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_password', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_ca_certs_path', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_index_name', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('scroll', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_timeout', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_batch_size', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('dlsource_body', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('timer_type', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('interval_in_seconds', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('schedule', new UntypedFormControl("", [Validators.required]));
            let index_name = source_pp[dlkey[0]].dlsource_index_name.replace(new RegExp("bizintel360-", "g"), "");
            this.dataSource.controls['dlsource_index_name'].setValue(index_name);
            this.dataSource.controls['dlsource_host'].setValue(source_pp[dlkey[0]].dlsource_host);
            this.dataSource.controls['dlsource_port'].setValue(source_pp[dlkey[0]].dlsource_port);
            this.dataSource.controls['dlsource_username'].setValue(source_pp[dlkey[0]].dlsource_username);
            // if(source_pp[dlkey[0]].dlsource_password != undefined && source_pp[dlkey[0]].dlsource_password.includes('gAAAAA')){
            //   let pwd = source_pp[dlkey[0]].dlsource_password?await this.helperService.decrypt(source_pp[dlkey[0]].dlsource_password):"";
            //   this.dataSource.addControl('dlsource_password', new UntypedFormControl(pwd, Validators.required));
            // }else{
              this.dataSource.addControl('dlsource_password', new UntypedFormControl(source_pp[dlkey[0]].dlsource_password, Validators.required));
            // }
            this.dataSource.controls['dlsource_ca_certs_path'].setValue(source_pp[dlkey[0]].dlsource_ca_certs_path);
            // this.dataSource.controls['dlsource_index_name'].setValue(source_pp[dlkey[0]].dlsource_index_name);
            this.dataSource.controls['scroll'].setValue(source_pp[dlkey[0]].scroll);
            this.dataSource.controls['dlsource_timeout'].setValue(source_pp[dlkey[0]].dlsource_timeout);
            this.dataSource.controls['dlsource_batch_size'].setValue(source_pp[dlkey[0]].dlsource_batch_size);
            this.dataSource.controls['dlsource_body'].setValue(source_pp[dlkey[0]].dlsource_body);
            this.dataSource.controls['timer_type'].setValue(source_pp[dlkey[0]].timer_type);
            this.dataSource.controls['interval_in_seconds'].setValue(source_pp[dlkey[0]].interval_in_seconds);
            this.dataSource.controls['schedule'].setValue(source_pp[dlkey[0]].schedule);
            this.dataSource.addControl('version', new UntypedFormControl("", [Validators.required]));
            this.dataSource.controls['version'].setValue(source_pp[dlkey[0]].version.dlversion);
            this.dataSource.controls['dlsource_host'].disable();
            this.dataSource.controls['dlsource_port'].disable();
            this.dataSource.controls['dlsource_username'].disable();
            this.dataSource.controls['dlsource_password'].disable();
            this.dataSource.controls['dlsource_ca_certs_path'].disable();
            this.dataSource.controls['dlsource_index_name'].disable();
            this.dataSource.controls['scroll'].disable();
            this.dataSource.controls['dlsource_timeout'].disable();
            this.dataSource.controls['dlsource_batch_size'].disable();
            this.dataSource.controls['dlsource_body'].disable();
            this.dataSource.controls['timer_type'].disable();
            this.dataSource.controls['interval_in_seconds'].disable();
            this.dataSource.controls['schedule'].disable();
            this.dataSource.controls['version'].disable();
            this.bridge_summary_source_name = index_name;//"Bizintel360 Data Lake Source";
            this.bridge_summary_source_bobj = "-";
          } else if (data.source_type == 4) {
            this.dataSource.addControl('bridge_source_ws_endpoint_url', new UntypedFormControl('', [Validators.required]));
            this.dataSource.addControl('bridge_source_ws_endpoint_params_raw', new UntypedFormArray([]));
            this.dataSource.addControl('bridge_source_ws_endpoint_headers', new UntypedFormArray([]));
            this.dataSource.addControl('bridge_source_ws_message', new UntypedFormControl('', []));

            this.dataSource.controls['bridge_source_ws_endpoint_url'].setValue(source_pp.bizdata_ops_websocketsource.endpoint_url);
            // this.dataSource.controls['bridge_source_ws_endpoint_params_raw'].setValue(source_pp.bizdata_ops_websocketsource.params);
            // this.dataSource.controls['bridge_source_ws_endpoint_headers'].setValue(source_pp.bizdata_ops_websocketsource.headers);
            this.dataSource.controls['bridge_source_ws_message'].setValue(source_pp.bizdata_ops_websocketsource.message);

            // let source_postman_ws_params: any;
            let source_postman_ws_params = source_pp.bizdata_ops_websocketsource;
            let bridge_source_endpoint_params_raw_array = this.dataSource.get('bridge_source_ws_endpoint_params_raw') as UntypedFormArray;
            if (source_postman_ws_params.params.length > 0) {
              for (var row of source_postman_ws_params.params) {
                bridge_source_endpoint_params_raw_array.push(this.addSourceValueWsParams(row));
              }
            } else {
              // this.sourceparamsFlag = false;
              this.addSourceWsParams(0);
            }

            let bridge_source_endpoint_headers_raw_array = this.dataSource.get('bridge_source_ws_endpoint_headers') as UntypedFormArray;
            if (source_postman_ws_params.headers.length > 0) {
              for (var row of source_postman_ws_params.headers) {
                bridge_source_endpoint_headers_raw_array.push(this.addSourceValueWsHeaders(row));
              }
            } else {
              this.sourceheadersFlag = false;
              this.addSourceWsheaders(0);
            }
            this.dataSource.controls['bridge_source_ws_endpoint_url'].disable();
            this.dataSource.controls['bridge_source_ws_endpoint_params_raw'].disable();
            this.dataSource.controls['bridge_source_ws_endpoint_headers'].disable();
            this.dataSource.controls['bridge_source_ws_message'].disable();
          } else if (data.source_type == 5) {
            this.dataSource.addControl('password', new UntypedFormControl("", Validators.required));
            this.dataSource.addControl('user_email', new UntypedFormControl("", [Validators.required, Validators.email]));
            
            this.dataSource.addControl('mail_server', new UntypedFormControl("", Validators.required));
            this.dataSource.addControl('port_number', new UntypedFormControl("", Validators.required));
            this.dataSource.addControl('out_type', new UntypedFormControl("", Validators.required));
            this.dataSource.controls['password'].setValue(source_pp.bizdata_ops_emailsource.password?await this.helperService.decrypt(source_pp.bizdata_ops_emailsource.password):"");
            this.dataSource.controls['user_email'].setValue(source_pp.bizdata_ops_emailsource.user_email);
            this.dataSource.controls['mail_server'].setValue(source_pp.bizdata_ops_emailsource.mail_server);
            this.dataSource.controls['port_number'].setValue(source_pp.bizdata_ops_emailsource.port_number);
            this.dataSource.controls['out_type'].setValue(source_pp.bizdata_ops_emailsource.out_type);
            this.dataSource.controls['user_email'].disable();
            this.dataSource.controls['password'].disable();
            this.dataSource.controls['mail_server'].disable();
            this.dataSource.controls['port_number'].disable();
            this.dataSource.controls['out_type'].disable();
          }

          // ***************************
          // ***************************


          // ***************************
          // Data Process for Target
          // ***************************
          // let target_pp: any;
          // if (data.target_params != null && data.target_params != "") {
          //   target_pp = JSON.parse(await this.helperService.decrypt(data.target_params));
          // }
          // let target_pp: any;
          // if (data.target_params != null && data.target_params != "") {
          //   target_pp = JSON.parse(data.target_params);
          // }
          let target_pp: any;
          if (data.target_params != null && data.target_params != "") {
          let target_params = await this.helperService.decryptpayload(data.target_params);          
          if(target_params != "" && target_params.length != 2){
            await this.helperService.decryptpayload(JSON.parse(target_params)).then((decoRecords:any)=>{
              target_params = JSON.parse(decoRecords);
              target_pp = JSON.parse(atob(target_params));
            })
          }else{
            target_pp = "";
          }
          
          //   await this.helperService.decodeIntegration(data.target_params).then((target_params:any)=>{
          //   target_pp =JSON.parse(target_params); 
          // })
          }

          let target_postman_params: any;
          if (data.target_type == 1) {
            target_postman_params = target_pp.input.bizdata_rest;
            if (data.target_id == 0) {
              this.isNewTarget = true;
              this.dataTarget.patchValue({
                bridge_target: data.target_name,
              });
              this.dataTarget.addControl('new_bridge_target', new UntypedFormControl("", [Validators.required]));
              this.dataTarget.addControl('new_bridge_target_business_object', new UntypedFormControl("", [Validators.required]));
              this.dataTarget.get('bridge_target').clearValidators();
              this.dataTarget.get('bridge_target').updateValueAndValidity();
              const is_bridge_target_business_object = this.dataTarget.contains('bridge_target_business_object');
              if (is_bridge_target_business_object) this.dataTarget.removeControl('bridge_target_business_object');

              this.dataTarget.controls['new_bridge_target'].setValue(data.target_name);
              this.dataTarget.controls['new_bridge_target'].disable();
              this.dataTarget.controls['new_bridge_target_business_object'].setValue(data.target_business_obj);
              this.dataTarget.controls['new_bridge_target_business_object'].disable();
            } else {
              this.isNewTarget = false;
              this.dataTarget.patchValue({
                bridge_target: data.target_name,
              })
              this.dataTarget.addControl('bridge_target_business_object', new UntypedFormControl("", [Validators.required]));
              const is_new_bridge_target = this.dataTarget.contains('new_bridge_target');
              const is_new_bridge_target_business_object = this.dataTarget.contains('new_bridge_target_business_object');
              if (is_new_bridge_target) this.dataTarget.removeControl('new_bridge_target');
              if (is_new_bridge_target_business_object) this.dataTarget.removeControl('new_bridge_target_business_object');
            }

            let bridge_target_endpoint_method = this.methodList.filter(function (entry) { return entry.id == target_postman_params.endpoint_method.id });
            this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_target_endpoint_method[0].method);
            let bridge_target_endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === target_postman_params.authentication_type.id });
            this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_target_endpoint_authentication_type[0].type);
            if (target_postman_params.hasOwnProperty('body_type')) {
              if (target_postman_params.body_type != "" && target_postman_params.body_type != undefined) {
                this.dataTarget.controls['bridge_target_body_type'].setValue(target_postman_params.body_type);
                if (target_postman_params.body_type == 'JSON') {
                  if (target_postman_params.endpoint_body_raw != '' && target_postman_params.endpoint_body_raw != undefined) {
                    this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(JSON.stringify(target_postman_params.endpoint_body_raw));
                  } else {
                    this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(target_postman_params.endpoint_body_raw);
                  }
                } else {
                  this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(target_postman_params.endpoint_body_raw);
                }
              }
              this.dataTarget.controls['bridge_target_endpoint_body_raw'].disable();
            }
            if (JSON.stringify(target_postman_params.endpoint_body_raw) === '{}') {
              this.targetbodyFlag = false;
            }
            this.dataTarget.controls['pre_request_script'].setValue(target_postman_params.pre_request_script?await this.helperService.decrypt(target_postman_params.pre_request_script):"");  
            this.dataTarget.controls['pre_request_script'].disable();
            this.dataTarget.controls['bridge_target_endpoint_url'].setValue(target_postman_params.endpoint_url);
            let bridge_target_endpoint_params_raw_array = this.dataTarget.get('bridge_target_endpoint_params_raw') as UntypedFormArray;
            if (target_postman_params.endpoint_params_raw.length > 0) {
              for (var row of target_postman_params.endpoint_params_raw) {
                bridge_target_endpoint_params_raw_array.push(this.addTargetValueParams(row));
              }
            } else {
              this.targetparamsFlag = false;
              this.addTargetParams(0);
            }

            let bridge_target_endpoint_headers_raw_array = this.dataTarget.get('bridge_target_endpoint_headers') as UntypedFormArray;
            if (target_postman_params.endpoint_headers.length > 0) {
              for (var row of target_postman_params.endpoint_headers) {
                bridge_target_endpoint_headers_raw_array.push(this.addTargetValueHeaders(row));
              }
            } else {
              this.targetheadersFlag = false;
              this.addTargetHeaders(0);
            }

            if (bridge_target_endpoint_authentication_type[0].id == 3) {
              // Bearer Token
              this.dataTarget.addControl('bridge_target_authentication_token', new UntypedFormControl(""));
              this.dataTarget.controls['bridge_target_authentication_token'].setValue(target_postman_params.authentication_token);
              this.selectTargetType = 3;
            } else if (bridge_target_endpoint_authentication_type[0].id == 4) {
              // Basic Auth
              this.dataTarget.addControl('bridge_target_authentication_username', new UntypedFormControl(""));
              this.dataTarget.addControl('bridge_target_authentication_password', new UntypedFormControl(""));
              this.dataTarget.controls['bridge_target_authentication_username'].setValue(target_postman_params.username);
              this.dataTarget.controls['bridge_target_authentication_username'].disable();
              this.dataTarget.controls['bridge_target_authentication_password'].setValue(target_postman_params.password?await this.helperService.decrypt(target_postman_params.password):"");        
              this.dataTarget.controls['bridge_target_authentication_password'].disable();
              this.selectTargetType = 4;
            } else if (bridge_target_endpoint_authentication_type[0].id == 6) {
              // OAuth 2.0
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
              this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(target_postman_params.refresh_token_endpoint_url?await this.helperService.decrypt(target_postman_params.refresh_token_endpoint_url):"");             
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].disable();
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(target_postman_params.refresh_token_endpoint_headers));
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].disable();
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(target_postman_params.refresh_token_endpoint_params));
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_params'].disable();          
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_body'].setValue(target_postman_params.refresh_token_endpoint_body?JSON.stringify(JSON.parse(await this.helperService.decrypt(target_postman_params.refresh_token_endpoint_body))):{});
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_body'].disable();
              let bridge_target_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === target_postman_params.refresh_token_endpoint_method.id });
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_method'].setValue(bridge_target_refresh_token_endpoint_method[0].method);
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_method'].disable();
              this.selectTargetType = 6;
            }
            this.bridge_summary_target_name = this.integrationObj.target_name;
            this.bridge_summary_target_bobj = this.integrationObj.target_business_obj;
          } else if (data.target_type == 2) {

            this.dataTarget.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
            // this.dataTarget.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('db_version', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('tuple_key', new UntypedFormControl("", []));
            this.dataTarget.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('port_number', new UntypedFormControl("3306", [Validators.required]));
            this.dataTarget.addControl('schema_name', new UntypedFormControl("", []));
            this.dataTarget.addControl('batch_size', new UntypedFormControl("1000", []));
            this.dataTarget.addControl('jdbc_driver', new UntypedFormControl("", []));
            this.dataTarget.addControl('jdbc_string', new UntypedFormControl("", []));
            this.dataTarget.addControl('jar_file', new UntypedFormControl("", []));
            this.dataTarget.addControl('username', new UntypedFormControl("", []));
            this.dataTarget.addControl('password', new UntypedFormControl("", []));
            this.dataTarget.addControl('query', new UntypedFormControl("", []));
            this.dataTarget.addControl('status', new UntypedFormControl("", []));
            this.dataTarget.addControl('response', new UntypedFormControl("", []));

            // let query = this.helperService.objectToStringConverter('Array', target_pp.bizdata_ops_jdbcoutput.query);
            // let tuple_key = JSON.parse(this.helperService.objectToStringConverter('Array', target_pp.bizdata_ops_jdbcoutput.tuple_key));

            this.dataTarget.controls['host_ip'].setValue(target_pp.bizdata_ops_jdbcoutput.host_ip);
            this.dataTarget.controls['jar_file'].setValue(target_pp.bizdata_ops_jdbcoutput.jar_file);
            this.dataTarget.controls['jdbc_driver'].setValue(target_pp.bizdata_ops_jdbcoutput.jdbc_driver);
            this.dataTarget.controls['jdbc_string'].setValue(target_pp.bizdata_ops_jdbcoutput.jdbc_string);
              this.dataTarget.controls['password'].setValue(target_pp.bizdata_ops_jdbcoutput.password?await this.helperService.decrypt(target_pp.bizdata_ops_jdbcoutput.password):"");       
            this.dataTarget.controls['port_number'].setValue(target_pp.bizdata_ops_jdbcoutput.port_number);
            this.dataTarget.controls['pre_request_script'].setValue(target_pp.bizdata_ops_jdbcoutput.pre_request_script);
            this.dataTarget.controls['query'].setValue('"' + target_pp.bizdata_ops_jdbcoutput.query + '"');
            this.dataTarget.controls['response'].setValue(target_pp.bizdata_ops_jdbcoutput.response);
            this.dataTarget.controls['schema_name'].setValue(target_pp.bizdata_ops_jdbcoutput.schema_name);
            this.dataTarget.controls['status'].setValue(target_pp.bizdata_ops_jdbcoutput.status);
            this.dataTarget.controls['storage_name'].setValue(target_pp.bizdata_ops_jdbcoutput.storage_name.storage_name);
            // this.dataTarget.controls['db_version_list'].setValue(target_pp.bizdata_ops_jdbcoutput.db_version_list);
            this.dataTarget.controls['db_version'].setValue(target_pp.bizdata_ops_jdbcoutput.db_version.dbversion);
            this.dataTarget.controls['tuple_key'].setValue(target_pp.bizdata_ops_jdbcoutput.tuple_key);
            this.dataTarget.controls['username'].setValue(target_pp.bizdata_ops_jdbcoutput.username);
            this.dataTarget.controls['batch_size'].setValue(target_pp.bizdata_ops_jdbcoutput.batch_size);
            this.dataTarget.controls['host_ip'].disable();
            this.dataTarget.controls['jar_file'].disable();
            this.dataTarget.controls['jdbc_driver'].disable();
            this.dataTarget.controls['jdbc_string'].disable();
            this.dataTarget.controls['password'].disable();
            this.dataTarget.controls['port_number'].disable();
            this.dataTarget.controls['pre_request_script'].disable();
            this.dataTarget.controls['query'].disable();
            this.dataTarget.controls['response'].disable();
            this.dataTarget.controls['schema_name'].disable();
            this.dataTarget.controls['status'].disable();
            this.dataTarget.controls['storage_name'].disable();
            this.dataTarget.controls['db_version'].disable();
            this.dataTarget.controls['tuple_key'].disable();
            this.dataTarget.controls['username'].disable();
            this.dataTarget.controls['batch_size'].disable();
            this.bridge_summary_target_name = target_pp.bizdata_ops_jdbcoutput.storage_name.storage_name;
            this.bridge_summary_target_bobj = "-";
            this.isjdbcTargetFromEnabled=true;

          } else if (data.target_type == 3) {
            this.dataTarget.addControl('version', new UntypedFormControl("", []));
            this.dataTarget.addControl('index_name', new UntypedFormControl("", []));
            this.dataTarget.addControl('action_type', new UntypedFormControl("", []));
            this.dataTarget.addControl('primary_key', new UntypedFormControl("", []));
            this.dataTarget.addControl('indexing_type', new UntypedFormControl("", []));
            this.dataTarget.addControl('dl_ca_certs_path', new UntypedFormControl("", []));
            this.dataTarget.addControl('dlake_host', new UntypedFormControl("", []));
            this.dataTarget.addControl('dlake_port', new UntypedFormControl("", []));
            this.dataTarget.addControl('dlpassword', new UntypedFormControl("", []));
            this.dataTarget.addControl('dlusername', new UntypedFormControl("", []));
            this.dataTarget.addControl('dlversion', new UntypedFormControl("", []));
            if (target_pp.bizdata_ops_bizintel360ingestion == undefined) {
              target_pp.bizdata_ops_bizintel360ingestion = target_pp.bizdata_ops_dlakeingestion;
            }
            // let version = this.verisonListDLO.filter(function (entry) { return entry.op_name == target_pp.bizdata_ops_dlakeingestion.version.op_name });
            this.dataTarget.controls['version'].setValue(target_pp.bizdata_ops_bizintel360ingestion.version.dlversion);
            this.dataTarget.controls['version'].disable();

            let primary_key;
            if (target_pp.bizdata_ops_bizintel360ingestion.primary_key == undefined || target_pp.bizdata_ops_bizintel360ingestion.primary_key == "" || target_pp.bizdata_ops_bizintel360ingestion.primary_key == null) {
              primary_key = "";
            } else {
              primary_key = target_pp.bizdata_ops_bizintel360ingestion.primary_key
            }

            let index_name = target_pp.bizdata_ops_bizintel360ingestion.index_name.replace(new RegExp("bizintel360-", "g"), "");
            this.dataTarget.controls['index_name'].setValue(index_name);
            this.dataTarget.controls['index_name'].disable();
            this.dataTarget.controls['action_type'].setValue(target_pp.bizdata_ops_bizintel360ingestion.action_type);
            this.datatarget_action_type = target_pp.bizdata_ops_bizintel360ingestion.action_type;
            this.dataTarget.controls['action_type'].disable();
            this.dataTarget.controls['primary_key'].setValue(primary_key);
            this.dataTarget.controls['primary_key'].disable();
            this.dataTarget.controls['indexing_type'].setValue(target_pp.bizdata_ops_bizintel360ingestion.indexing_type);
            this.dataTarget.controls['indexing_type'].disable();

            this.dataTarget.controls['dl_ca_certs_path'].setValue(target_pp.bizdata_ops_bizintel360ingestion.ca_certs_path);
            this.dataTarget.controls['dl_ca_certs_path'].disable();
            this.dataTarget.controls['dlake_host'].setValue(target_pp.bizdata_ops_bizintel360ingestion.dlake_host);
            this.dataTarget.controls['dlake_host'].disable();
            this.dataTarget.controls['dlake_port'].setValue(target_pp.bizdata_ops_bizintel360ingestion.dlake_port);
            this.dataTarget.controls['dlake_port'].disable();
              this.dataTarget.controls['dlpassword'].setValue(target_pp.bizdata_ops_bizintel360ingestion.dlpassword?await this.helperService.decrypt(target_pp.bizdata_ops_bizintel360ingestion.dlpassword):"");
            // }
            this.dataTarget.controls['dlpassword'].disable();
            this.dataTarget.controls['dlusername'].setValue(target_pp.bizdata_ops_bizintel360ingestion.dlusername);
            this.dataTarget.controls['dlusername'].disable();
            this.bridge_summary_target_name = index_name;
            // this.bridge_summary_target_name = "Bizintel360 Data Lake Ingestion";
            this.bridge_summary_target_bobj = "-";
          } else if (data.target_type == 4) {
            this.dataTarget.addControl('From', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('email_password', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('mailserver', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('email_port_number', new UntypedFormControl("465", [Validators.required]));
            this.dataTarget.addControl('to', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('cc', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('bcc', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('subject', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('source_key', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('body', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('attachment', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('file_name', new UntypedFormControl("", [Validators.required]));

            this.dataTarget.controls['From'].setValue(target_pp.bizdata_ops_email.From);
            this.dataTarget.controls['email_password'].setValue(target_pp.bizdata_ops_email.password?await this.helperService.decrypt(target_pp.bizdata_ops_email.password):"");
            this.dataTarget.controls['mailserver'].setValue(target_pp.bizdata_ops_email.mailserver);
            this.dataTarget.controls['email_port_number'].setValue(target_pp.bizdata_ops_email.port_number);
            this.dataTarget.controls['to'].setValue(target_pp.bizdata_ops_email.to);
            this.dataTarget.controls['cc'].setValue(target_pp.bizdata_ops_email.cc);
            this.dataTarget.controls['bcc'].setValue(target_pp.bizdata_ops_email.bcc);
            this.dataTarget.controls['subject'].setValue(target_pp.bizdata_ops_email.subject);
            this.dataTarget.controls['source_key'].setValue(target_pp.bizdata_ops_email.source_key);
            this.dataTarget.controls['body'].setValue(target_pp.bizdata_ops_email.body);
            this.dataTarget.controls['attachment'].setValue(target_pp.bizdata_ops_email.attachment);
            this.dataTarget.controls['file_name'].setValue(target_pp.bizdata_ops_email.file_name);


            this.dataTarget.controls['From'].disable();
            this.dataTarget.controls['email_password'].disable();
            this.dataTarget.controls['mailserver'].disable();
            this.dataTarget.controls['email_port_number'].disable();
            this.dataTarget.controls['to'].disable();
            this.dataTarget.controls['cc'].disable();
            this.dataTarget.controls['bcc'].disable();
            this.dataTarget.controls['subject'].disable();
            this.dataTarget.controls['source_key'].disable();
            this.dataTarget.controls['body'].disable();
            this.dataTarget.controls['attachment'].disable();
            this.dataTarget.controls['file_name'].disable();
            this.bridge_summary_target_name = "Email";
            this.bridge_summary_target_bobj = "-";
          }else if (data.target_type == 5) {
            this.bridge_summary_target_name = "No Target";
            this.bridge_summary_target_bobj = "-";
          }
          // let bridge_target = this.bridgeTargetCatalogType.filter(function (entry) { return entry.product_name == data.target_name; });
          // this.dataTarget.controls['bridge_target'].setValue(bridge_target[0].product_name);


          this.getStorage().then((res) => {
            if (data.source_id != 0) {
              this.getSourceTargetBusinessObject(this.integrationObj.source_name, res.token, "source").then((stb1) => {
                this.bridgeSourceBusinessObject = stb1;
                let bridge_source_business_object = this.bridgeSourceBusinessObject.filter(function (entry) { return entry.id == data.source_id; });
                this.dataSource.controls['bridge_source_business_object'].setValue(bridge_source_business_object[0].business_obj);
              }); // Load source business object
            }

            if (data.target_id != 0) {
              this.getSourceTargetBusinessObject(this.integrationObj.target_name, res.token, "target").then((stb2) => {
                this.bridgeTargetBusinessObject = stb2;
                let bridge_target_business_object = this.bridgeTargetBusinessObject.filter(function (entry) { return entry.id == data.target_id; });
                this.dataTarget.controls['bridge_target_business_object'].setValue(bridge_target_business_object[0].business_obj);
              }); // Load target business object
            }
          });

          var id: any;
          for (let item of this.paginationTypeOptions) {
            if (this.integrationObj.pagination_style == item.type_value) {
              id = item.id
              this.selectPaginationType = id;
              this.dataSource.controls['bridge_source_pagination_type'].setValue(item.type);
            }
          }
          if (id == 2) {
            // this.option2 = true;
            this.user_key_2 = this.integrationObj.user_key
            this.response_parameters_2 = this.integrationObj.response_parameters
            this.another_response_parameter_2 = this.integrationObj.another_response_parameter
            this.dataSource.patchValue({
              user_key_2: this.integrationObj.user_key,
              response_parameters_2: this.integrationObj.response_parameters,
              another_response_parameter_2: this.integrationObj.another_response_parameter,
            })
          } else if (id == 3) {
            // this.option3 = true;
            this.user_key_3 = this.integrationObj.user_key
            this.key_name_to_update_3 = this.integrationObj.key_name_to_update
            this.response_parameters_3 = this.integrationObj.response_parameters
            this.dataSource.patchValue({
              user_key_3: this.integrationObj.user_key,
              key_name_to_update_3: this.integrationObj.key_name_to_update,
              response_parameters_3: this.integrationObj.response_parameters,
            })
          } else if (id == 4) {
            //console.log(this.integrationObj)
            // this.option4 = true;
            this.user_key_4 = this.integrationObj.user_key
            this.key_name_to_update_4 = this.integrationObj.key_name_to_update
            this.response_parameters_4 = this.integrationObj.response_parameters
            this.dataSource.patchValue({
              user_key_4: this.integrationObj.user_key,
              key_name_to_update_4: this.integrationObj.key_name_to_update,
              response_parameters_4: this.integrationObj.response_parameters,
            })
          } else if (id == 5) {
            // this.option5 = true;
            this.user_key_5 = this.integrationObj.user_key
            this.key_name_to_update_5 = this.integrationObj.key_name_to_update
            this.response_parameters_5 = this.integrationObj.response_parameters
            this.dataSource.patchValue({
              user_key_5: this.integrationObj.user_key,
              key_name_to_update_5: this.integrationObj.key_name_to_update,
              response_parameters_5: this.integrationObj.response_parameters,
            })
          } else if (id == 6) {
            // this.option6 = true;
            this.user_key_6 = this.integrationObj.user_key,
              this.user_key_url_6 = this.integrationObj.user_key_url,
              this.response_parameters_6 = this.integrationObj.response_parameters,
              this.dataSource.patchValue({
                user_key_6: this.integrationObj.user_key,
                user_key_url_6: this.integrationObj.user_key_url,
                response_parameters_6: this.integrationObj.response_parameters,
              })
          } else if (id == 7) {
            // this.option6 = true;
            this.user_key_7 = this.integrationObj.user_key,
              this.response_parameters_7 = this.integrationObj.response_parameters,
              this.dataSource.patchValue({
                user_key_7: this.integrationObj.user_key,
                response_parameters_7: this.integrationObj.response_parameters,
              })
          } else if (id == 8) {
            // this.option6 = true;
            this.custom_pagination_script = this.integrationObj.custom_pagination_script,
              this.dataSource.patchValue({
                custom_pagination_script: this.integrationObj.custom_pagination_script,
              })
          }

          if (this.integrationObj.min_num != null && this.integrationObj.min_num != undefined) {
            this.dataSource.patchValue({
              min_number: this.integrationObj.min_num
            })
          }
          if (this.integrationObj.max_num != null && this.integrationObj.max_num != undefined) {
            this.dataSource.patchValue({
              max_number: this.integrationObj.max_num
            })
          }
          // this.testSourceApi();
          // this.testTargetApi();

          if (this.integrationObj.hasOwnProperty('today_str')) {
            if (this.integrationObj.today_str != '' && this.integrationObj.today_str != undefined) {
              this.dataSource.patchValue({ today_str: this.integrationObj.today_str })
            }
          }

          if (this.integrationObj.hasOwnProperty('yesterday_str')) {
            if (this.integrationObj.yesterday_str != '' && this.integrationObj.yesterday_str != undefined) {
              this.dataSource.patchValue({ yesterday_str: this.integrationObj.yesterday_str })
            }
          }

          if (this.integrationObj.hasOwnProperty('rolling_time_format')) {
            if (this.integrationObj.rolling_time_format != '' && this.integrationObj.rolling_time_format != undefined) {
              this.dataSource.patchValue({ rolling_time_format: this.integrationObj.rolling_time_format })
            }
          }

          if (this.integrationObj.hasOwnProperty('rolling_frequency')) {
            if (this.integrationObj.rolling_frequency != null && this.integrationObj.rolling_frequency != undefined) {
              this.dataSource.patchValue({ rolling_frequency: this.integrationObj.rolling_frequency })
            }
          }

          if (this.integrationObj.hasOwnProperty('offset_value')) {
            if (this.integrationObj.offset_value != '' && this.integrationObj.offset_value != undefined) {
              this.dataSource.patchValue({ offset_value: this.integrationObj.offset_value })
            }
          }

          let dataOperations;
          if (this.integrationObj?.data_operations) {
          await this.helperService.decryptpayload(data.data_operations).then((data_operations:any)=>{
            dataOperations =JSON.parse(data_operations); 
          })
          // dataOperations = JSON.parse(data.data_operations);
            let key = Object.keys(dataOperations)
            this.getDataOperations(key, dataOperations)
          }


          // ***************************
          // ***************************

        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  getSourcePostmanDetails(id) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: id
      }

      this.backendService.PostAPICall('getPostmanData', payload, _storage.token).subscribe(
        (res) => {
          let data = res.input_structure_json.input.bizdata_rest;
          // ***************************
          // Data Process for Source
          // ***************************
          let bridge_source_endpoint_method = this.methodList.filter(function (entry) { return entry.id == data.endpoint_method.id });
          this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_source_endpoint_method[0]);
          let bridge_source_endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === data.authentication_type.id });
          this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_source_endpoint_authentication_type[0]);

          this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(data.endpoint_body_raw);
          this.dataSource.controls['bridge_source_endpoint_url'].setValue(data.endpoint_url);

          let bridge_source_endpoint_params_raw_array = this.dataSource.get('bridge_source_endpoint_params_raw') as UntypedFormArray;
          if (data.endpoint_param_raw.length > 0) {
            bridge_source_endpoint_params_raw_array.clear();
            for (var row of data.endpoint_param_raw) {
              // //console.log(row);
              bridge_source_endpoint_params_raw_array.push(this.addSourceValueParams(row));
            }
          } else {
            bridge_source_endpoint_params_raw_array.clear();
            this.addSourceParams(0);
          }

          let bridge_source_endpoint_headers_raw_array = this.dataSource.get('bridge_source_endpoint_headers') as UntypedFormArray;
          if (data.endpoint_headers.length > 0) {
            bridge_source_endpoint_headers_raw_array.clear();
            for (var row of data.endpoint_headers) {
              // //console.log(row);
              bridge_source_endpoint_headers_raw_array.push(this.addSourceValueHeaders(row));
            }
          } else {
            bridge_source_endpoint_headers_raw_array.clear();
            this.sourceheadersFlag = false;
            this.addSourceheaders(0);
          }

          this.selectSourceType = 1; // Reset the value here
          if (bridge_source_endpoint_authentication_type[0].id == 3) {
            // Bearer Token
            this.dataSource.addControl('bridge_source_authentication_token', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_authentication_token'].setValue(data.authentication_token);
            this.selectSourceType = 3;
          } else if (bridge_source_endpoint_authentication_type[0].id == 4) {
            // Basic Auth
            this.dataSource.addControl('bridge_source_authentication_username', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_authentication_password', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_authentication_username'].setValue(data.username);
            this.dataSource.controls['bridge_source_authentication_password'].setValue(data.password);
            this.selectSourceType = 4;
          } else if (bridge_source_endpoint_authentication_type[0].id == 6) {
            // OAuth 2.0
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(data.refresh_token_endpoint_url);
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(data.refresh_token_endpoint_headers));
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(data.refresh_token_endpoint_params));
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_body'].setValue(JSON.stringify(data.refresh_token_endpoint_body));
            let bridge_source_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === data.refresh_token_endpoint_method.id });
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].setValue(bridge_source_refresh_token_endpoint_method[0].method);
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].disable();
            this.selectSourceType = 6;
          }
          // ***************************
        })
    })
  }

  getTargetPostmanDetails(id) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: id
      }

      this.backendService.PostAPICall('getPostmanData', payload, _storage.token).subscribe(
        (res) => {
          let data = res.input_structure_json.input.bizdata_rest;
          // ***************************
          // Data Process for Target
          // ***************************
          let bridge_target_endpoint_method = this.methodList.filter(function (entry) { return entry.id == data.endpoint_method.id });
          this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_target_endpoint_method[0].method);
          let bridge_target_endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === data.authentication_type.id });
          //console.log("bridge_target_endpoint_authentication_type", bridge_target_endpoint_authentication_type);
          this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_target_endpoint_authentication_type[0].type);

          this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(data.endpoint_body_raw);
          this.dataTarget.controls['bridge_target_endpoint_url'].setValue(data.endpoint_url);

          let bridge_target_endpoint_params_raw_array = this.dataTarget.get('bridge_target_endpoint_params_raw') as UntypedFormArray;
          if (data.endpoint_param_raw.length > 0) {
            bridge_target_endpoint_params_raw_array.clear();
            for (var row of data.endpoint_param_raw) {
              // //console.log(row);
              bridge_target_endpoint_params_raw_array.push(this.addTargetValueParams(row));
            }
          } else {
            this.targetparamsFlag = false;
            this.addTargetParams(0);
          }

          let bridge_target_endpoint_headers_raw_array = this.dataTarget.get('bridge_target_endpoint_headers') as UntypedFormArray;
          if (data.endpoint_headers.length > 0) {
            bridge_target_endpoint_headers_raw_array.clear();
            for (var row of data.endpoint_headers) {
              // //console.log(row);
              bridge_target_endpoint_headers_raw_array.push(this.addTargetValueHeaders(row));
            }
          } else {
            this.targetheadersFlag = false;
            this.addTargetHeaders(0);
          }

          this.selectTargetType = 1; // Reset the value here
          if (bridge_target_endpoint_authentication_type[0].id == 3) {
            // Bearer Token
            this.dataTarget.addControl('bridge_target_authentication_token', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_authentication_token'].setValue(data.authentication_token);
            this.selectTargetType = 3;
          } else if (bridge_target_endpoint_authentication_type[0].id == 4) {
            // Basic Auth
            this.dataTarget.addControl('bridge_target_authentication_username', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_authentication_password', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_authentication_username'].setValue(data.username);
            this.dataTarget.controls['bridge_target_authentication_password'].setValue(data.password);
            this.selectTargetType = 4;
          } else if (bridge_target_endpoint_authentication_type[0].id == 6) {
            // OAuth 2.0
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(data.refresh_token_endpoint_url);
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(data.refresh_token_endpoint_headers));
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(data.refresh_token_endpoint_params));
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_body'].setValue(JSON.stringify(data.refresh_token_endpoint_body));
            let bridge_target_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === data.refresh_token_endpoint_method.id });
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_method'].setValue(bridge_target_refresh_token_endpoint_method[0].method);
            this.selectTargetType = 6;
          }

          // ***************************
        })
    })
  }

  addEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Email
    if (value) {
      this.emails.push(value);
      //console.log(this.emails)
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmail(email): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmail(email, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmail(email);
      return;
    }
    // Edit existing email
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails[index] = value;
    }
  }

  toggleAdvancedSettings() {
    //console.log(this.showAdvancedSettings);
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }

  async getDataSource() {
    return new Promise((resolve, reject) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getSource', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getDataTarget() {
    return new Promise((resolve, reject) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getTarget', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  };

  timezoneList = [];
  timezones$: Observable<TimeZone[]>;
  enableTimeZoneClearIcon: boolean;

  private _filterMapTimeZone(value: string): TimeZone[] {
    const filterValue = value.toLowerCase();
    return this.timezoneList.filter(option => option.timezone.toLowerCase().includes(filterValue));
  }
  getTimeZone() {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getTimezones', res.token).subscribe(
        data => {
          this.timezoneList = data;
          this.summary.controls['time_zone'].setValue({ "timezone": "America/Los_Angeles" });
          this.timezones$ = this.summary.get('time_zone')!.valueChanges.pipe(
            startWith(''),
            map(value => {
              const timezone = typeof value === 'string' ? value : value?.timezone;
              this.enableTimeZoneClearIcon = value ? true : false;
              return timezone ? this._filterMapTimeZone(timezone as string) : this.timezoneList.slice();
            })
          )
        }
      );
    })
  }

  async openSchedular() {
    let data = this.summary.controls["schedule"].value;
    const modal = await this.modalCtrl.create({
      component: SchedularComponent,
      componentProps: {
        "Data": data
      },
      cssClass: 'my-custom-class',
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.onDidDismiss().then(res => {
      if (res != undefined && res != null) {
        if (res.role != "backdrop") {
          this.summary.controls["schedule"].setValue(res.role);
        } else {
          this.summary.controls["schedule"].setValue(data);
        }
      }
    })
    return await modal.present();
  }

  getSourceTargetBusinessObject(product_name, token, type): any {
    // this.helperService.loader();
    let payload = { product_name };
    if (type == "source") payload['api_type'] = 1;
    if (type == "target") payload['api_type'] = 3;
    return new Promise((resolve) => {
      this.backendService.PostAPICall('getBusinessObject', payload, token).subscribe(
        res => {
          const data: [] = res as [];
          resolve(data);
          // this.helperService.closeLoader();
        })
    })
  }

  onChangeBusinessObjectSource(e) {
    this.getSourcePostmanDetails(e.value.id);
  }

  onChangeBusinessObjectTarget(e) {
    this.getTargetPostmanDetails(e.value.id);
  }

  getSourceBusinessObject(product_name, type) {
    // this.helperService.loader();
    let payload = { product_name };
    if (type == "source") payload['api_type'] = 1;
    if (type == "target") payload['api_type'] = 3;
    this.getStorage().then((res) => {
      this.backendService.PostAPICall('getBusinessObject', payload, res.token).subscribe(
        data => {
          if (type == "source") {
            this.bridgeSourceBusinessObject = data;
          } else if (type == "target") {
            this.bridgeTargetBusinessObject = data;
          }
        })
    })
  }

  addOpParam() {
    this.operationParam.push(this.operationParam.length);
  }

  deleteParam(param: number) {
    this.operationParam.splice(param, 1);
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  editorInit(editor) {
    // Here you can access editor instance
    this.editor = editor;
  }

  get bridgeSourceCatalogControls() { return this.dataSource.controls; }
  get bridgeSourceParams() { return this.bridgeSourceCatalogControls.bridge_source_endpoint_params_raw as UntypedFormArray; }
  get bridgeSourceHeaders() { return this.bridgeSourceCatalogControls.bridge_source_endpoint_headers as UntypedFormArray; }

  get bridgeTargetCatalogControls() { return this.dataTarget.controls; }
  get bridgeTargetParams() { return this.bridgeTargetCatalogControls.bridge_target_endpoint_params_raw as UntypedFormArray; }
  get bridgeTargetHeaders() { return this.bridgeTargetCatalogControls.bridge_target_endpoint_headers as UntypedFormArray; }

  get bridgeSourceWsParams() { return this.bridgeSourceCatalogControls.bridge_source_ws_endpoint_params_raw as UntypedFormArray; }
  get bridgeSourceWsHeaders() { return this.bridgeSourceCatalogControls.bridge_source_ws_endpoint_headers as UntypedFormArray; }
  bridgeTargetHeadersRAO(empIndex: number): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_target_endpoint_headers') as UntypedFormArray;
  }
  bridgeTargetParamsRAO(empIndex: number): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_target_endpoint_params_raw') as UntypedFormArray;
  }
  bridgeRAOEnvironments(empIndex): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_endpoint_environments_raw') as UntypedFormArray;
  }
  envRAOData(index: number, empIndex): UntypedFormArray {
    return this.bridgeRAOEnvironments(index).at(empIndex).get('env_vars') as UntypedFormArray;
  }
  addSourceValueParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    console.log(data)
    return this._formBuilder.group({
      bridge_source_paramKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_source_paramValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_source_paramDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addSourceValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      bridge_source_headerKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_source_headerValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_source_headerDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addSourceValueWsParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this._formBuilder.group({
      bridge_source_ws_paramKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_source_ws_paramValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_source_ws_paramDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addSourceValueWsHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      bridge_source_ws_headerKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_source_ws_headerValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_source_ws_headerDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addTargetValueParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this._formBuilder.group({
      bridge_target_paramKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_target_paramValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_target_paramDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addTargetValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      bridge_target_headerKey: new UntypedFormControl({ value: data.key, disabled: true }),
      bridge_target_headerValue: new UntypedFormControl({ value: data.value, disabled: true }),
      bridge_target_headerDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addSourceParams(index) {
    this.bridgeSourceParams.insert(index + 1,
      this._formBuilder.group({
        'bridge_source_paramKey': [''],
        'bridge_source_paramValue': [''],
        'bridge_source_paramDescription': ['']
      })
    );
  }

  removeSourceParams(index) {
    if (this.bridgeSourceParams.value.length > 1) {
      this.bridgeSourceParams.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }
  addSourceWsParams(index) {
    this.bridgeSourceWsParams.insert(index + 1,
      this._formBuilder.group({
        'bridge_source_ws_paramKey': [''],
        'bridge_source_ws_paramValue': [''],
        'bridge_source_ws_paramDescription': ['']
      })
    );
  }

  addSourceheaders(index) {
    this.bridgeSourceHeaders.insert(index + 1,
      this._formBuilder.group({
        'bridge_source_headerKey': [''],
        'bridge_source_headerValue': [''],
        'bridge_source_headerDescription': ['']
      })
    );
  }

  removeSourceheader(index) {
    if (this.bridgeSourceHeaders.value.length > 1) {
      this.bridgeSourceHeaders.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in headers", 2000);
    }
  }

  addSourceWsheaders(index) {
    this.bridgeSourceWsHeaders.insert(index + 1,
      this._formBuilder.group({
        'bridge_source_ws_headerKey': [''],
        'bridge_source_ws_headerValue': [''],
        'bridge_source_ws_headerDescription': ['']
      })
    );
  }
  getTokenExpirationDate(token): Date {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  async checkInvalidToken() {
    try {
      const token = await this.storage.get('postman-token');
      const date = this.getTokenExpirationDate(token);
      if (date === undefined) {
        return false;
      }
      return !(date.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }

  checktoken() {
    return new Promise((resolve) => {
      this.checkInvalidToken().then(invalid => {
        if (!invalid) {
          resolve(true);
        }
        else {
          resolve(false);
          this.generatetoken();
        }
      })
    })
  }

  generatetoken() {
    this.getStorage().then((res) => {
      let payload = {
        type: this.type
      }
      this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
        (data) => {
          this.getgeneratetoken(data['data'][0].username, data['data'][0].hashed_password)
        },
        (error) => {
        }
      );
    })
  }

  getgeneratetoken(userName, password) {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    this.backendService.PostExternalTokenAPICall('https://bizdatapi-sb.bizdata360.com/token', payload).subscribe(
      (data) => {
        this.updatedtoken = data.access_token;
        this.storage.set("postman-token", data.access_token);
      },
      (error) => {
        //console.log(error);
      }
    )
  }

  arrayToObject(arr) {
    return Object.assign({}, ...arr);
  }

  checkAndRemoveBearerTokenSourceControl() {
    const is_authentication_token = this.dataSource.contains('bridge_source_authentication_token');
    if (is_authentication_token) this.dataSource.removeControl('bridge_source_authentication_token');
  }

  checkAndRemoveBasicTokenSourceControl() {
    const is_authentication_username = this.dataSource.contains('bridge_source_authentication_username');
    const is_authentication_password = this.dataSource.contains('bridge_source_authentication_password');
    if (is_authentication_username) this.dataSource.removeControl('bridge_source_authentication_username');
    if (is_authentication_password) this.dataSource.removeControl('bridge_source_authentication_password');
  }

  checkAndRefreshTokenSourceControl() {
    const is_refresh_token_endpoint_url = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_url');
    const is_refresh_token_endpoint_method = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_method');
    const is_refresh_token_endpoint_header = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_header');
    const is_refresh_token_endpoint_params = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_params');
    const is_refresh_token_endpoint_body = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_body');
    if (is_refresh_token_endpoint_url) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_url');
    if (is_refresh_token_endpoint_method) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_method');
    if (is_refresh_token_endpoint_header) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_header');
    if (is_refresh_token_endpoint_params) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_params');
    if (is_refresh_token_endpoint_body) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_body');
  }

  onChangeSourceAuthenticationtype(event) {
    let changedValue = event.value.id;
    this.selectSourceType = changedValue;
    if (changedValue == 3) {
      this.dataSource.addControl('bridge_source_authentication_token', new UntypedFormControl("", [Validators.required]));
    } else if (changedValue == 4) {
      this.dataSource.addControl('bridge_source_authentication_username', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_authentication_password', new UntypedFormControl("", [Validators.required]));
    } else if (changedValue == 6) {
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
    }
  }

  addTargetParams(index) {
    this.bridgeTargetParams.insert(index + 1,
      this._formBuilder.group({
        'bridge_target_paramKey': [''],
        'bridge_target_paramValue': [''],
        'bridge_target_paramDescription': ['']
      })
    );
  }

  removeTargetParams(index) {
    if (this.bridgeTargetParams.value.length > 1) {
      this.bridgeTargetParams.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  addTargetHeaders(index) {
    this.bridgeTargetHeaders.insert(index + 1,
      this._formBuilder.group({
        'bridge_target_headerKey': [''],
        'bridge_target_headerValue': [''],
        'bridge_target_headerDescription': ['']
      })
    );
  }

  removeTargetHeader(index) {
    if (this.bridgeTargetHeaders.value.length > 1) {
      this.bridgeTargetHeaders.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in headers", 2000);
    }
  }

  checkAndRemoveBearerTokenTargetControl() {
    const is_authentication_token = this.dataTarget.contains('bridge_target_authentication_token');
    if (is_authentication_token) this.dataTarget.removeControl('bridge_target_authentication_token');
  }

  checkAndRemoveBasicTokenTargetControl() {
    const is_authentication_username = this.dataTarget.contains('bridge_target_authentication_username');
    const is_authentication_password = this.dataTarget.contains('bridge_target_authentication_password');
    if (is_authentication_username) this.dataTarget.removeControl('bridge_target_authentication_username');
    if (is_authentication_password) this.dataTarget.removeControl('bridge_target_authentication_password');
  }

  checkAndRefreshTokenTargetControl() {
    const is_refresh_token_endpoint_url = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_url');
    const is_refresh_token_endpoint_method = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_method');
    const is_refresh_token_endpoint_header = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_header');
    const is_refresh_token_endpoint_params = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_params');
    const is_refresh_token_endpoint_body = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_body');
    if (is_refresh_token_endpoint_url) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_url');
    if (is_refresh_token_endpoint_method) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_method');
    if (is_refresh_token_endpoint_header) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_header');
    if (is_refresh_token_endpoint_params) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_params');
    if (is_refresh_token_endpoint_body) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_body');
  }

  onChangeTargetAuthenticationtype(event) {
    let changedValue = event.value.id;
    this.selectTargetType = changedValue;
    if (changedValue == 3) {
      this.dataTarget.addControl('bridge_target_authentication_token', new UntypedFormControl("", [Validators.required]));
    } else if (changedValue == 4) {
      this.dataTarget.addControl('bridge_target_authentication_username', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_authentication_password', new UntypedFormControl("", [Validators.required]));
    } else if (changedValue == 6) {
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
    }
  }

  onChangeSourcePaginationtype(event) {
    let changedValue = event.value.id;
    this.selectPaginationType = changedValue
    this.dataSource.patchValue({
      user_key_2: '',
      response_parameters_2: '',
      another_response_parameter_2: '',
      user_key_3: '',
      key_name_to_update_3: '',
      response_parameters_3: '',
      user_key_4: '',
      key_name_to_update_4: '',
      response_parameters_4: '',
      user_key_5: '',
      key_name_to_update_5: '',
      response_parameters_5: '',
      user_key_6: '',
      user_key_url_6: '',
      response_parameters_6: '',
    })

    if (changedValue == 2) {
      this.dataSource.patchValue({
        user_key_2: this.user_key_2,
        response_parameters_2: this.response_parameters_2,
        another_response_parameter_2: this.another_response_parameter_2,
      })
    } else if (changedValue == 3) {
      this.dataSource.patchValue({
        user_key_3: this.user_key_3,
        key_name_to_update_3: this.key_name_to_update_3,
        response_parameters_3: this.response_parameters_3,
      })
    } else if (changedValue == 4) {
      this.dataSource.patchValue({
        user_key_4: this.user_key_4,
        key_name_to_update_4: this.key_name_to_update_4,
        response_parameters_4: this.response_parameters_4,
      })
    } else if (changedValue == 5) {
      this.dataSource.patchValue({
        user_key_5: this.user_key_5,
        key_name_to_update_5: this.key_name_to_update_5,
        response_parameters_5: this.response_parameters_5,
      })
    } else if (changedValue == 6) {
      this.dataSource.patchValue({
        user_key_6: this.user_key_6,
        user_key_url_6: this.user_key_url_6,
        response_parameters_6: this.response_parameters_6,
      })
    }
  }

  selectionChange(e) {
    let bridge_source_name = this.dataSource.value.bridge_source;
    this.bridge_source_arr = this.bridgeSourceList.filter(function (entry) {
      return entry.products == bridge_source_name;
    });
    let bridge_target_name = this.dataTarget.value.bridge_target;
    this.bridge_target_arr = this.bridgeTargetList.filter(function (entry) {
      return entry.products == bridge_target_name;
    });

    if (e.selectedIndex == 1) {
      this.noAbout = true;
    } else {
      this.noAbout = false;
    }
    if(e.selectedIndex ==2){
      setTimeout(()=>{
          let target_api=document.getElementById('ib_details_target_endpoint_request_url');
          if (target_api) {  // Check if the element exists
            target_api.style.height = target_api.scrollHeight + 'px';
        } else {
            console.warn("Element with ID 'ib_details_target_endpoint_request_url' not found.");
        }
        },0)
    }
    if (e.selectedIndex == 3) {
      this.selectedIndex = 3;
      // if (this.bridge_target_type == 3) {
      //   this.bridge_summary_target_name = "Bizintel360 Data Lake Ingestion";
      //   this.bridge_summary_target_bobj = "-";
      // }
    }
  }

  sourcePostmanTabChange(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.tab.textLabel == 'Body') {
      this._bodySourceEditor.codeMirror.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
      this._sourcePreRequestScriptEditor.codeMirror.refresh();
    }
  }
  sourcePostmanWsTabChange(tabChangeEvent: MatTabChangeEvent): void {
  }
  targetPostmanTabChange(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.tab.textLabel == 'Body') {
      this._bodyTargetEditor.codeMirror.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
      this._targetPreRequestScriptEditor.codeMirror.refresh();
    }
  }

  postmanTabChangeROA(tabChangeEvent: MatTabChangeEvent,id,index): void {
    //console.log(tabChangeEvent);
    // if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
    this._preRequestScriptEditorROA.codeMirror.refresh();
    // }
  }
  // ndjf
  sourceDatabaseAddFormControl() {
    this.dataSource.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('db_version', new UntypedFormControl("", [Validators.required]));
    // this.dataSource.addControl('tuple_key', new UntypedFormControl("", []));
    this.dataSource.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('port_number', new UntypedFormControl("3306", [Validators.required]));
    this.dataSource.addControl('schema_name', new UntypedFormControl("", []));
    // this.dataSource.addControl('batch_size', new UntypedFormControl("1000", []));
    this.dataSource.addControl('jdbc_driver', new UntypedFormControl("", []));
    this.dataSource.addControl('jdbc_string', new UntypedFormControl("", []));
    this.dataSource.addControl('jdbc_jar_file', new UntypedFormControl("", []));
    this.dataSource.addControl('username', new UntypedFormControl("", []));
    this.dataSource.addControl('password', new UntypedFormControl("", []));
    this.dataSource.addControl('query', new UntypedFormControl("", []));
    this.dataSource.addControl('status', new UntypedFormControl("", []));
    this.dataSource.addControl('response', new UntypedFormControl("", []));
    // this.dataSource.addControl('unique_key', new UntypedFormControl("", []));
    this.dataSource.addControl('response_parameter', new UntypedFormControl("", []));
    // this.dataSource.addControl('timer_type', new UntypedFormControl("", []));
    // this.dataSource.addControl('interval_in_seconds', new UntypedFormControl("", []));
    // this.dataSource.addControl('schedule', new UntypedFormControl("", []));
    // this.dataSource.addControl('multiline', new UntypedFormControl("no", []));
    this.dataSource.addControl('chunks_size', new UntypedFormControl(1000, [Validators.required]));
    this.dataSource.addControl('limit_query', new UntypedFormControl("", []));
  }

  sourceDatalakeAddFormControl() {
    this.dataSource.addControl('version', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_host', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_port', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_username', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_password', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_ca_certs_path', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('dlsource_index_name', new UntypedFormControl("", [Validators.required]));
    this.dataSource.addControl('scroll', new UntypedFormControl("2m", []));
    this.dataSource.addControl('dlsource_timeout', new UntypedFormControl(120, []));
    this.dataSource.addControl('dlsource_batch_size', new UntypedFormControl("1000", []));
    this.dataSource.addControl('dlsource_body', new UntypedFormControl('{"query": { "match_all": {} } }', []));
    this.dataSource.addControl('dlsource_body_response', new UntypedFormControl("", []));
    // this.dataSource.addControl('timer_type', new UntypedFormControl("", []));
    // this.dataSource.addControl('interval_in_seconds', new UntypedFormControl("", []));
    // this.dataSource.addControl('schedule', new UntypedFormControl("", []));
  }

  sourceWebsocketAddFormControl() {
    this.dataSource.addControl('bridge_source_ws_endpoint_url', new UntypedFormControl('', [Validators.required]));
    this.dataSource.addControl('bridge_source_ws_endpoint_params_raw', new UntypedFormArray([]));
    this.dataSource.addControl('bridge_source_ws_endpoint_headers', new UntypedFormArray([]));
    this.dataSource.addControl('bridge_source_ws_message', new UntypedFormControl('', []));
  }

  sourceApiAddFormControl() {
    this.dataSource.addControl('bridge_source', new UntypedFormControl('', [Validators.required]));
    this.dataSource.addControl('bridge_source_business_object', new UntypedFormControl('', [Validators.required]));
    this.dataSource.addControl('bridge_source_endpoint_method', new UntypedFormControl('', []));
    this.dataSource.addControl('bridge_source_endpoint_url', new UntypedFormControl('', [Validators.required]));
    this.dataSource.addControl('bridge_source_endpoint_params_raw', new UntypedFormArray([]));
    this.dataSource.addControl('bridge_source_endpoint_headers', new UntypedFormArray([]));
    this.dataSource.addControl('bridge_source_endpoint_authentication_type', new UntypedFormControl("", []));
    this.dataSource.addControl('bridge_source_endpoint_body_raw', new UntypedFormControl("", []));
    this.dataSource.addControl('pre_request_script', new UntypedFormControl("", []));
    this.dataSource.addControl('bridge_source_response', new UntypedFormControl("", []));
  }
  sourceEmailAddFormControl() {
    this.bridge_summary_source_name = "Email";
    this.bridge_summary_source_bobj = "-";
    this.dataSource.addControl('user_email', new UntypedFormControl('', [Validators.required, Validators.email]));
    this.dataSource.addControl('password', new UntypedFormControl('', Validators.required));
    this.dataSource.addControl('mail_server', new UntypedFormControl('', Validators.required));
    this.dataSource.addControl('port_number', new UntypedFormControl('993', Validators.required));
    this.dataSource.addControl('out_type', new UntypedFormControl(this.email_out_types[0].value, Validators.required));
  }

  targetApiAddFormControl() {
    this.dataTarget.addControl('bridge_target', new UntypedFormControl('', [Validators.required]));
    this.dataTarget.addControl('bridge_target_business_object', new UntypedFormControl('', [Validators.required]));
    this.dataTarget.addControl('bridge_target_endpoint_method', new UntypedFormControl("", []));
    this.dataTarget.addControl('bridge_target_endpoint_url', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('bridge_target_endpoint_params_raw', new UntypedFormArray([]));
    this.dataTarget.addControl('bridge_target_endpoint_headers', new UntypedFormArray([]));
    this.dataTarget.addControl('bridge_target_endpoint_authentication_type', new UntypedFormControl("", []));
    this.dataTarget.addControl('bridge_target_endpoint_body_raw', new UntypedFormControl("", []));
    this.dataTarget.addControl('pre_request_script', new UntypedFormControl("", []));
    this.dataTarget.addControl('bridge_target_response', new UntypedFormControl("", []));
  }
  targetDatabaseAddFormControl() {
    this.dataTarget.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('db_version', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('tuple_key', new UntypedFormControl("", []));
    this.dataTarget.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('port_number', new UntypedFormControl("3306", [Validators.required]));
    this.dataTarget.addControl('schema_name', new UntypedFormControl("", []));
    this.dataTarget.addControl('batch_size', new UntypedFormControl("1000", []));
    this.dataTarget.addControl('jdbc_driver', new UntypedFormControl("", []));
    this.dataTarget.addControl('jdbc_string', new UntypedFormControl("", []));
    this.dataTarget.addControl('jar_file', new UntypedFormControl("", []));
    this.dataTarget.addControl('username', new UntypedFormControl("", []));
    this.dataTarget.addControl('password', new UntypedFormControl("", []));
    this.dataTarget.addControl('query', new UntypedFormControl("", []));
    this.dataTarget.addControl('status', new UntypedFormControl("", []));
    this.dataTarget.addControl('response', new UntypedFormControl("", []));    
  }
  targetEmailAddFormControl() {
    this.dataTarget.addControl('From', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('email_password', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('mailserver', new UntypedFormControl("", [Validators.required]));
    this.dataTarget.addControl('email_port_number', new UntypedFormControl("465", [Validators.required]));
    this.dataTarget.addControl('to', new UntypedFormControl("", []));
    this.dataTarget.addControl('cc', new UntypedFormControl("", []));
    this.dataTarget.addControl('bcc', new UntypedFormControl("", []));
    this.dataTarget.addControl('subject', new UntypedFormControl("", []));
    this.dataTarget.addControl('source_key', new UntypedFormControl("", []));
    this.dataTarget.addControl('body', new UntypedFormControl("", []));
    this.dataTarget.addControl('attachment', new UntypedFormControl("", []));
    this.dataTarget.addControl('file_name', new UntypedFormControl("", []));
  }
  targetDataLakeAddFormControl() {
    this.dataTarget.addControl('version', new UntypedFormControl("", []));
    this.dataTarget.addControl('index_name', new UntypedFormControl("", []));
    this.dataTarget.addControl('action_type', new UntypedFormControl("upsert", []));
    this.dataTarget.addControl('primary_key', new UntypedFormControl("", []));
    this.dataTarget.addControl('refresh_type', new UntypedFormControl("true", []));
    this.dataTarget.addControl('request_timeout_sec', new UntypedFormControl("1000", []));
    this.dataTarget.addControl('indexing_type', new UntypedFormControl("parallel_bulk", []));
    this.dataTarget.addControl('max_retries', new UntypedFormControl("10", []));
    this.dataTarget.addControl('chunk_size', new UntypedFormControl("500", []));
    this.dataTarget.addControl('thread_count', new UntypedFormControl("4", []));
    this.dataTarget.addControl('queue_size', new UntypedFormControl("4", []));
    this.dataTarget.addControl('dl_ca_certs_path', new UntypedFormControl("", []));
    this.dataTarget.addControl('dlake_host', new UntypedFormControl("", []));
    this.dataTarget.addControl('dlake_port', new UntypedFormControl("", []));
    this.dataTarget.addControl('dlpassword', new UntypedFormControl("", []));
    this.dataTarget.addControl('dlusername', new UntypedFormControl("", []));
    this.dataTarget.addControl('dlversion', new UntypedFormControl("", []));
  }
}
